var App = App || {};

/** Monaca APP related params */

/** @type {{native_api_call: function(string, Object): void, set_badge_number: function(number): void}} */
App.hybrid_app ||= null;

if (!('public_root' in App)) App.public_root = '/';
if (!('svg_embed' in App)) App.svg_embed = false;

App.core = {

	loaded: false,
	json: null,
	url: '',
	login_refresh_interval_sec: 500,
	is_cache: true,

	asset_rewrite_path: function (path) {
		return path;
	},

	init: function() {
		Date.prototype.clone = function () {
			return new Date(this.getTime());
		};

		this.cookie = new CookieApi();
		this.set_cookie = this.cookie.set;
		this.get_cookie = this.cookie.get;

		this.history = new HistoryApi();

		const eventbus = new Eventbus({
			onAfterPush: function (bus, scope, event, payload, context) {
				if (scope === 'ws' && ['offline', 'online'].indexOf(event) !== -1) return;

				if (['other_tab', 'ws', 'iframe'].indexOf(scope) !== -1) {
					bus.push('msg', event, payload, context ? { ...context, scope } : { scope });
				}
			}
		});
		eventbus.app = eventbus.scope(eventbus.SCOPE_APP = 'app');
		eventbus.hybrid_app = eventbus.scope(eventbus.SCOPE_HYBRID_APP = 'hybrid');
		eventbus.window = eventbus.scope(eventbus.SCOPE_WINDOW = 'window');
		eventbus.other_tab = eventbus.scope(eventbus.SCOPE_OTHER_TAB = 'other_tab');
		eventbus.ws = eventbus.scope(eventbus.SCOPE_WEBSOCKET = 'ws');
		eventbus.iframe = eventbus.scope(eventbus.SCOPE_IFRAME = 'iframe');
		eventbus.msg = eventbus.scope(eventbus.SCOPE_MESSAGE = 'msg');
		eventbus.state = eventbus.scope(eventbus.SCOPE_STATE = 'state');
		eventbus.desktop_firebase_message = eventbus.scope(eventbus.SCOPE_DESKTOP_FIREBASE_MESSAGE = 'desktop_firebase_message');

		this.async_task = new AsyncTask();
		this.async_module = new AsyncModule(window.APP_BUILD_HASH);
		this.context = new ContextProvider();
		this.call_queue = new CallQueue();
		this.websocket = new WebsocketApi(eventbus.ws, {
			version: window.APP_WORKER_HASH,
			isAvailable: function () {
				return App.config.websockets;
			},
			resolveWorkerParams: function(ws) {
				App.core.cookie.set('branch', ws.branch);
				return {
					id_account: App.me.id_account,
					id_user: App.me.id,
					id_db: App.me.id_db,
					id_device: App.core.cookie.getOrSet('id_device', () => Math.floor(10000 + Math.random()*89999), 10 * 365 * 86400),
					branch: ws.branch,
					hash: App.me.hash,
				};
			}
		});
		this.page = new PageController(this.async_module, this.context);
		this.desktop_firebase_message = new FirebaseMessage(eventbus.desktop_firebase_message);
		this.devtools = typeof Devtools !== 'undefined' ? new Devtools(eventbus, this.websocket, this.async_task) : null;

		//window.onerror = App.core.onerror;

		App.page = App.core.page.create_fake_page();
		App.bus = eventbus;
		eventbus.begin_binding_context();
		App.core.onload();
		eventbus.finish_bounded_context();

		/** @type {RPC} */
		App.expose_data = createRpc({
			id: 'expose_data',
			fetch: (req) => App.core.async_task.ajax(req),
		});
		App.state = createAppState();

		this.add_hooks = function (target) {
			if (target == null) return;
			target.onBoot = function() { App.helper.call_hook(target, 'onBoot'); };
			target.onLogin = function() { App.helper.call_hook(target, 'onLogin'); };
			target.onLogout = function() { App.helper.call_hook(target, 'onLogout'); };
			target.onInitPage = function(params) { App.helper.call_hook(target, 'onInitPage', params); };
			target.onLoadPage = function() { App.helper.call_hook(target, 'onLoadPage'); };
			target.onReadyPage = function() { App.helper.call_hook(target, 'onReadyPage'); };
			target.onUnloadPage = function() { App.helper.call_hook(target, 'onUnloadPage'); };
		};

		this.add_hooks(App.controls);
		this.add_hooks(App.components);

		App.state.drag.$watch('is_on', function(is_on) {
			$('body').toggleClass('body-dragInProgress', is_on);
		});
	},

	base: function() {
		return App.hybrid_app ? App.api.get_account_domen() : '';
	},

	apply_config: function (config) {
		Object.assign(this, config);
	},

	obj_window: null,
	active_window: function(params) {
		params ||= {};
		const is_top_layer = (component) => {
			return component.obj_wrapper.hasClass('top-layer');
		};
		if (params.menu && App.menu.is_shown()) return App.menu.obj_window;
		if (App.device.is_mobile()) {
			// відкрита з дашборда модалка може бути "фоновою", принаймні на мобілі
			if (params.skip_modal && App.modal.is_shown() && is_top_layer(App.modal)) {
				// на мобілі модалка - це повноцінне вікно з top-layer, тому, якщо скіпнули модалку - візмемо попереднє
				if (App.windows.opened[1]) {
					const window = App.windows.get(App.windows.opened[1]);
					if (window.target && window.target.obj_window) {
						return window.target.obj_window;
					}
				}
			}
			if (!params.skip_modal && App.modal.is_shown() && is_top_layer(App.modal) && (!params.skip_modal_preview || !$('body').hasClass('withModalAndTask'))) return App.modal.obj_window;
		} else {
			if (!params.skip_modal && App.modal.is_shown() && (!params.skip_modal_preview || !$('body').hasClass('withModalAndTask'))) return App.modal.obj_window;
		}
		if (App.project_view.is_shown()) return App.project_view.obj_wrapper;
		if (App.task_create.is_shown() && is_top_layer(App.task_create)) return App.task_create.obj_window;
		if (App.file_create.is_shown() && is_top_layer(App.file_create)) return App.file_create.obj_window;
		if (App.task_view.is_shown() && is_top_layer(App.task_view)) return App.task_view.obj_window;
		if (App.right_panel.is_shown()) return App.right_panel.obj_window;
		if (App.mymenu.is_shown()) return App.mymenu.obj_window;
		return this.obj_window;
	},

	has_modals: function() {
		return App.modal.is_shown()
			|| App.project_view.is_shown()
			|| App.task_create.is_shown()
			|| App.file_create.is_shown()
			|| App.task_view.is_shown()
			|| App.right_panel.is_shown()
			|| App.mymenu.is_shown();
	},

	active_object: function() {
		if (App.modal.is_shown()) return App.modal;
		if (App.task_view.is_shown()) return App.task_view;
		return this.page || {};
	},

	sound: function(name, muted) {
		try {
			let snd = new Audio(App.public_root + "assets/sound/" + name + ".mp3");
			if (muted) snd.volume = 0.01;
			snd.play();
			snd.remove();
		} catch (e) {}
	},

	log: function(category, message, data) {
		if (('APP_DEBUG' in window && APP_DEBUG) || App.hybrid_app?.show_console) console.log('['+category+']: ', message, data);

		if (window.Sentry) {
			Sentry.addBreadcrumb({category: category, message: message, level: 'info', data: data});
		}
	},
	warn: function(category, message, data) {
		if (('APP_DEBUG' in window && APP_DEBUG) || App.hybrid_app?.show_console) console.warn('['+category+']: ', message, data);

		if (window.Sentry) {
			Sentry.addBreadcrumb({category: category, message: message, level: 'warning', data: data});
		}
	},
	error: function(category, message, data) {
		if (message instanceof Error && message.is_aborted) return;

		if (('APP_DEBUG' in window && APP_DEBUG) || App.hybrid_app?.show_console) console.error('['+category+']: ', message);

		if (window.Sentry) {
			Sentry.withScope(scope => {
				scope.setTag("id_user", App.me.id);
				scope.setTag("id_account", App.me.id_account);
				if (data) scope.setExtra("data", data);
				Sentry.captureException(message instanceof Error ? message : new Error(message));
			});

		} else App.core.submit_log_js('err', category, message);
	},

	is_active: function() {
		return document.visibilityState === 'visible';
	},

	multytab_function_call: function(callback, call_id, call_ttl) {
		let dt = (new Date).getTime();
		if (!localStorage.getItem(call_id + '_dt') || (dt > 1*localStorage.getItem(call_id + '_dt') + 1000 * call_ttl)) {
			localStorage.setItem(call_id + '_dt', dt);
			callback();
		}
	},

	listen_messages_from_promo_gate: function(e) {
		let data = e.originalEvent.data;
		let msg;
		if (!data) return;
		try {
			msg = JSON.parse(data);
		} catch (e) {
			return;
		}
		switch (msg.command)
		{
			case 'sociallogin':
				if (msg.response) App.auth.process_login_response(msg.response);
				else if (msg.url) $.getScript(msg.url);
				break;
			case 'account_payment':
				App.core.goto('/account/payment/?from=payment' + (msg.data ? '&' + $.param(msg.data) : ''));
				break;
			default:
				return;
		}
	},

	send_message_to_other_tabs: function (message) {
		// TODO: rewrite to window.postMessage(message, targetOrigin)
		if (message.dt == null) message.dt = (new Date).getTime() + Math.random();

		localStorage.setItem('message', JSON.stringify(message));
		localStorage.removeItem('message');
	},

	send_message_to_other_devices: function (message, name) {
		name ||= JSON.stringify(message).hashCode();
		App.core.websocket.callback_push(name, () => {
			App.core.websocket.postMessage({ action: 'send_to_me', message });
			delete(App.core.websocket.callbacks[name]);
		});
	},

	listen_messages_from_other_tabs: function (e) {
		if (e.originalEvent.key !== 'message' || !e.originalEvent.newValue) return;
		// App.core.log('core.listen_messages_from_other_tabs', e.originalEvent.newValue);
		let msg = App.helper.json.safeParse(e.originalEvent.newValue);
		if (!msg || !msg.command) return;

		if (msg.command === 'title') document.title = msg.data;
		App.bus.other_tab.emit(msg.command, msg.data);

		// switch (msg.command)
		// {
			// case 'title':
			// 	document.title = msg.data;
			// 	break;
			// case 'object_state':
			// 	App.object_state.update(msg.data.obj_type, msg.data.obj_id, msg.data.obj_data, FROM_OTHER_TAB, msg.data.event_id);
			// 	break;
			// case 'object_state_sync_start':
			// 	App.object_state.fallback.set_timeout();
			// 	break;
			// case 'object_state_too_many':
			// 	App.object_state.on_too_many_updates();
			// 	break;
			// case 'object_state_sync_end':
			// 	App.object_state.seen = msg.data.max_id;
			// 	App.object_state.fallback.set_timeout();
			// 	break;
			// case 'task_panel':
			// 	App.task_panel.update(msg.data);
			// 	break;
			// case 'queue':
			// 	App.queue.process();
			// 	break;
			// case 'logout':
			// 	App.workspace.logout();
			// 	break;
			// case 'typing':
			// 	App.controls.typing.add(msg.data.id_task, msg.data.id_user);
			// 	break;
			// case 'task_view':
			// 	App.controls.task_view_indicator.set(msg.data.id_task, msg.data.ids_user, msg.data.ids_users_online);
			// 	break;
			// case 'who_see_task':
			// 	if (App.comments.helper_i_see_task(msg.data))
			// 		App.core.send_message_to_other_tabs({command: 'i_see_task', data: msg.data});
			// 	break;
			// case 'i_see_task':
			// 	App.mymenu.play_sound = false;
			// 	break;
			// case 'sidebar_options':
			// 	App.me.sidebar = msg.data;
			// 	App.sidebar.set_optional_menu();
			// 	break;
			// case 'i_see_project':
			// 	App.sidebar.helper.seen_project(msg.data.id);
			// 	break;
			// default:
			// 	$(document).trigger('message.' + msg.command);
			// 	break;
		// }
	},

	listen_messages_from_frames: function(e) {
		if (!e.originalEvent.origin.match(/https:\/\/(promo-[a-z]+\.)?worksection\.com$/)) return;
		// App.core.log('core.listen_messages_from_frames', e.originalEvent.data);
		let msg = App.helper.json.safeParse(e.originalEvent.data);
		if (!msg || !msg.command) return;

		if (msg && msg.command) App.bus.iframe.emit(msg.command, msg.data, msg);

		// switch (msg.command) {
		// 	case 'gd.file':
		// 		App.upload.google_drive.upload(msg.data, msg.token, msg.share);
		// 		break;
		// }
	},

	set_favicon: function(url) {
		$('link[rel$=icon]').replaceWith('');
		$('<link rel="shortcut icon" type="image/x-icon"/>')
			.appendTo('head')
			.attr('href', url);
	},

	share: function(url, title, onerror) {
		if (App.hybrid_app) {
			App.hybrid_app.native_api_call('share', {url, title});
		} else if(navigator.share && App.device.is_mobile()) { // ugly on desktop
			navigator.share({
				title: title,
				url: url
			}).catch((error) => onerror?.call());
		} else if (onerror) {
			onerror.call();
		} else {
			const dummy = document.createElement('textarea');
			dummy.value = window.location.href;
			document.body.appendChild(dummy);
			dummy.select();
			document.execCommand('copy');
			document.body.removeChild(dummy);
			console.log('Link copied to clipboard');
		}
	},

	download_file_and_share(url, post, callback) {

		App.core.log('download_file_and_share', url);

		url = url.indexOf('https://') === -1 ? App.core.base() + url : url;

		let promise = new Promise(function (resolve, reject) {
			let xhr = new XMLHttpRequest();
			xhr.open('POST', url, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.responseType = 'blob';
			xhr.onload = function () {

				let blob = xhr.response;

				// hybrid app fallback:
				if (xhr.status === 303) return App.helper.read_blob_as_text(blob, function (error, next_url) {
					if (error) {
						reject(error);
					} else {
						App.core.new_window(App.core.base() + next_url);
						resolve();
					}
				});

				let disposition = this.getResponseHeader("Content-Disposition"),
					type = this.getResponseHeader("Content-type"), // server will tell correct mime type
					filename = 'export.xlsx';

				if (disposition && disposition.indexOf('attachment') !== -1) {
					let matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
					if (matches != null && matches[1]) filename = matches[1].replace('UTF-8\'\'', '').replace(/['"]/g, '');

					if (type === 'application/x-download') {
						const ext = filename.split('.').pop();
						type = App.helper.get_mime_type_by_extension(ext);
					}

					blob = type ? new Blob([blob], { type }) : blob;
					const file = new File([blob], filename, { type: blob.type });

					App.core.share_files(
						[file],
						filename,
						(error) => console.error('Failed to share image: ', error)
					);

					resolve();
				} else if (type && type.indexOf('text/javascript') === 0) { // JS response instead of file ((
					App.helper.read_blob_as_text(blob, function (error, text) {
						if (error) {
							reject(error);
						} else {
							eval(text);
							resolve();
						}
					});
				} else {
					reject(new Error('Failed to download'));
				}
			}
			App.helper.xhr.set_headers(xhr);
			xhr.send(post);
		});

		promise.then(function () {
			if (callback) callback();
		}).catch(function (error) {
			App.core.error('download_file', error);
			App.core.reload();
		});
	},

	// не знадобилось .. але поки залишу
	share_image: function(img_el, title = 'image') {

		img_el = $(img_el).get(0);

		if (!img_el) throw new Error('No image element');

		App.helper.promise.imgToBlob(img_el)
			.then(blob => {
				const file = new File([blob], title+'.png', { type: blob.type }); // TODO extension by type
				return App.core.share_files(
					[file],
					title,
					(error) => console.error('Failed to share image: ', error)
				);
			});
	},

	share_files: function(files, title, onerror) {
		if (false && App.hybrid_app) {
			// TODO треба дописати підтримку цього + перевірити чи взагалі працює share в додатку
			// App.hybrid_app.native_api_call('share', {url, title});
		} else if(navigator.canShare && navigator.canShare({ files })) {
			navigator.share({
				files,
				title
			}).catch((error) => onerror?.call(error));
		} else {
			onerror?.call();
		}
	},

	clipboard: async function(el, textarea) {
		let text;
		if (typeof el == 'string') {
			text = el;
		} else if ($(el).is('input, textarea')) {
			text = $(el).val();
		} else if ($(el).is('code')) {
			text = $(el)[0].innerText.replace(/\u00A0/g, ' ');
		} else {
			text = $(el).text();
		}
		let result = true;
		if (App.hybrid_app) {
			App.hybrid_app.native_api_call('clipboard', {text});
		} else {
			try {
				await navigator.clipboard.writeText(text);
			} catch (err) {
				console.error(err);
				App.modal.show({url: App.helper.endpoint.primary() + '?' + App.actions.get('clipboard:show') + '&url=' + encodeURIComponent(text), width: 400, title: '', group: ''});
				result = false;
			}
		}
		return result;
	},

	clipboard_from_menu: async function(el, txt, textarea, repos_result) {
		// TODO можливо це можна вже викосити, не бачу використання ico_dlink
		if ($(el).hasClass('ico_dlink')) {
			if (await App.core.clipboard(txt, !!textarea)) {
				if (!window.tmpid) window.tmpid = 1; else window.tmpid++;
				$('<div class="clipped clipped_abs'+($(el).hasClass('ico_dlink_out') ? ' clipped_abs2' : '')+'" id="tmp'+window.tmpid+'"><span></span>'+$(el).attr('rel')+'</div>').bind('click',function(e) {$(this).remove();}).appendTo('body');
				setTimeout("$('#tmp"+window.tmpid+"').remove();", 2000);
			}
		} else {
			if (!await App.core.clipboard(txt, !!textarea)) return;

			if (App.device.is_mobile() && App.menu.obj_window.hasClass('menu-mode-auto')) {

				const setText = (menu, text) => menu.find('.clipped > .in').text(text);
				const text = $(el).attr('rel') || App?.object_state?.locale?.copied || '';
				const menu = $('#mobileCopiedMenu');

				setText(menu, text);
				const timeout = setTimeout(() => menu.click(), 1500);
				menu.on('click.clipped before_hide.clipped', () => {
					menu.off('click.clipped before_hide.clipped');
					clearTimeout(timeout);
					setText(menu, '');
					App.menu.hide_all();
				});

				App.menu.show({
					anchor: el,
					box: menu,
					backup: true,
					force_dropdown: true,
				});

			} else {
				let o = $(el).closest('.menu');
				let menuEl = App.menu.obj_window;

				// TODO: if new style menu, delte in future
				if (repos_result && $(el).parents().find('.menu__submenuWrapper').length) {
					let left = $(el).width();
					let top = $(el).offset().top - menuEl.parent().offset().top;
					menuEl.parent().css({left: menuEl.parent().offset().left + left, top: menuEl.parent().offset().top + top});
				}

				o.addClass('menu-clipped').css({ minWidth: o.outerWidth() }); // корисно при menu-autoWidthMax etc

				let detached = o.children().not('.clipboard_help, .menu__swipe').detach();
				if (!window.tmpid) window.tmpid = 1; else window.tmpid++;
				let clipped = $('<div class="clipped"><ws-icon name="ui_helper_suite/clipboard"></ws-icon>'+($(el).attr('rel') || App?.object_state?.locale?.copied || '')+'</div>').appendTo(o);
				setTimeout(() => {
					const restore_menu = () => {
						o.append(detached);
						o.find('.clipboard_help').hide();
						// if (menuEl.find('.menu__group').length) {
						// 	menuEl.css({left: '', marginTop: ''});
						// }
						o.find('.clipped').remove();
						o.removeClass('menu-clipped').css({ minWidth: '' });
						// if (o.attr('id') === 'quickTaskMenu') o.css({minWidth: ''});
					};

					o
						.one('click.clipped', function() {
							restore_menu();
							o.off('before_hide.clipped');
							App.menu.hide(true);
						})
						.one('before_hide.clipped', function() {
							restore_menu();
							o.off('click.clipped');
						});
				}, 0);
				if (o.find('.clipboard_help').length) o.find('.clipboard_help').show().appendTo(o); else setTimeout(function() { clipped.click(); }, 1500);
			}
		}
	},

	clipboard_wysiwyg: async function (el) {
		const html = el.outerHTML;

		// modern Clipboard API
		if (navigator.clipboard && window.ClipboardItem) {
			try {
				const item = new ClipboardItem({
					"text/html": new Blob([html], {type: "text/html"}),
					"text/plain": new Blob([el.innerText || el.textContent || ""], {type: "text/plain"})
				});

				await navigator.clipboard.write([item]);
				return true;
			} catch (e) {
				// fallback below
			}
		}

		// fallback for older browsers
		try {
			const container = document.createElement("div");
			container.style.position = "fixed";
			container.style.pointerEvents = "none";
			container.style.opacity = "0";
			container.innerHTML = html;

			document.body.appendChild(container);

			const range = document.createRange();
			range.selectNode(container);

			const selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);

			document.execCommand("copy");

			selection.removeAllRanges();
			document.body.removeChild(container);

			return true;
		} catch (e) {
			console.error("Copy failed", e);
			return false;
		}
	},

	show_clipped: function(el, text) {
		let val = (text != null && String(text).trim() !== '') ? text : el.attr('rel');
		const offset = el.offset();
		const pos = { top: offset.top, left: offset.left };
		let clipped = $('<div class="clipped_wrapper" style="top: '+pos.top+'px; left: '+pos.left+'px;"><div class="clipped"><ws-icon name="ui_helper_suite/clipboard"></ws-icon>'+(val || App?.object_state?.locale?.copied || '')+'</div></div>').appendTo($('body'));
		setTimeout(function(){clipped.remove()}, 1500);
	},

	popup: function(url, title, w, h) {
		if (App.hybrid_app) return App.core.new_window(url);
		return BrowserHelper.openPopup(url, title, w, h);
	},

	sleep: function (t) {
		return new Promise(function (resolve) {
			setTimeout(resolve, t)
		});
	},

	passive_supported: false,

	skip_request_after_error: 0,
	onerror: function (errorMsg, source, lineNumber, column, errorObj) {
		if (errorObj && errorObj.toString().indexOf('tracktor') !== -1) return false;
		if (errorMsg.indexOf('ResizeObserver') !== -1) return false;
		if (source.indexOf('tracktor.io') !== -1) return false;
		if (App.hybrid_app?.show_console) {
			console.error(errorMsg);
			alert('Error: ' + errorMsg + ' Script: ' + source + ' Line: ' + lineNumber + ' Column: ' + column + ' StackTrace: ' + errorObj);
		}

		let origin = App.hybrid_app ? App.api.get_account_domen() : document.location.origin;

		App.core.submit_log_js('err', 'app', errorMsg, source.replace(origin+'/assets/', '/').replace(origin+'/', '/'), lineNumber, column, errorObj);
	},
	submit_log_js: function (level, category, msg, file, lineNumber, column, errorObj) {
		if (App.offline_mode.active) return;

		errorObj = errorObj == null ? (msg instanceof Error ? msg : new Error(String(msg))) : errorObj;

		const filter_file_url = function (url) {
			return App.hybrid_app
				? url.replace(App.api.get_account_domen()+'/', 'account://').replace(document.location.origin+'/', 'local://')
				: url.replace(document.location.origin+'/', 'local://');
		};

		try {
			const stack = errorObj.stack ? errorObj.stack.split('\n').map(line => line.replace('at', '').trim()).slice(1).map(filter_file_url) : [];
			const context = {
				user: { id: App.me?.id, email: App.me?.email},
				agent: App.hybrid_app ? {
					url: document.location.href.replace(document.location.origin, ''),
					agent: navigator.userAgent,
					is_hybrid: App.hybrid_app ? true : undefined,
					is_cordova: App.hybrid_app.is_cordova() ? true : undefined,
					is_android: App.hybrid_app.is_android() ? true : undefined,
					is_ios: App.hybrid_app.is_ios() ? true : undefined,
					account_domen: App.api.get_account_domen(),
				} : {
					url: document.location.href,
					agent: navigator.userAgent
				},
				app: {
					build: window.APP_BUILD_HASH || ''
				}
			};
			$.ajax({
				url: App.helper.endpoint.primary() + '?' + App.actions.get('process:log_js')
					+ '&level=' + encodeURIComponent(level)
					+ '&category=' + encodeURIComponent(category)
					+ '&msg=' + encodeURIComponent(errorObj.message)
					+ '&stack=' + encodeURIComponent(JSON.stringify(stack))
					+ '&context=' + encodeURIComponent(JSON.stringify(context))
					+ (lineNumber ? '&line=' + encodeURIComponent(lineNumber) : '')
					+ (column ? '&column=' + encodeURIComponent(column) : '')
					+ (file ? '&file=' + encodeURIComponent(filter_file_url(file)) : ''),
				statusCode: {
					403: function(response) { return false; }
				},
				error: function () {
					// skip
				}
			});
		} catch (e) {
			// skip
		}
	},

	next_force_goto: false,

	reload: function(force_goto) {
		if (App.object_state) App.object_state.available = false;
		App.core.log('core.reload', force_goto ? 'FORCE' : '');
		App.core.goto(document.location.href, force_goto);
	},

	process_ajax_error: function (xhr, req) {
		if (xhr.statusText === 'abort') return;

		let is_json = String(xhr.getResponseHeader('content-type')).includes('application/json'),
			req_id = xhr.getResponseHeader('x-request-id'),
			account_url = xhr.getResponseHeader('x-account-url'),
			loginStep = xhr.getResponseHeader('X-Login-Step'),
			json = is_json ? JSON.parse(xhr.responseText) : null;

		const req_endpoint = req ? req.type + ' ' + req.url : '';

		if (loginStep === 'refresh') App.core.request_login_refresh();

		if (xhr.status === 403 || xhr.status === 404) {

			if (account_url) App.core.set_account_url(account_url);

			App.core.error('ajax client error', `${xhr.status}[${req_id}] ${req_endpoint}`);
			App.controls.loader.stop();
			if (is_json && json.show_message) {
				App.menu.hide(true);
				App.message.show(json.show_message);
			}
		} else if (xhr.status === 401) {
			if (loginStep === 'version-downgrade') {
				App.core.goto('/', true);
			} else if (loginStep === 'version-change') {
				App.controls.page_reloader.state_changed();
			} else if (loginStep === 'blocking-state') {
				App.workspace.blocking_state(xhr.getResponseHeader('X-Blocking-Action'), xhr.getResponseHeader('X-Blocking-Check') || null);
			} else if (loginStep.startsWith('secure')) {
				App.workspace.secure_state(loginStep);
			} else App.workspace.logout(loginStep);
		} else if (xhr.status > 0 && is_json && json.show_message) {
			App.core.error('ajax', `${xhr.status}[${req_id}] ${req_endpoint}`);
			App.message.show(json.show_message);
		} else if (xhr.status === 0) {
			if (App.offline_mode.is_on() || !!App.hybrid_app?.is_pause) return;
			App.offline_mode.schedule_ping();
			App.core.error('ajax', `FAILED ${req_endpoint}`);

			if (req_endpoint.includes('action=process:')) return;
			App.message.show(App.object_state.locale['load_error'], MSG_VARIANT_D, {
				action: { left_icon: 'autorenew', onclick: 'App.core.reload(true)', text: '' }
			});
		}
	},
	create_jq_ajax_error: (handler) => function (xhr, status, error) {
		App.core.process_ajax_error(xhr, this);
		if (handler) handler.apply(this, [xhr, status, error]);
	},

	hybrid_goto_history: {
		locations: [],
		push: function(url) {
			this.locations.push(url);
			this.locations = this.locations.slice(-10);
		},
		back: function() {
			if (App.core.async_task.is_loading('core.goto') || !App.page.loaded) return;
			if (!this.has_back()) return;

			this.locations.pop(); // remove current url
			App.core.goto(this.locations.pop());
		},
		has_back: function() {
			return this.locations.length > 1;
		}
	},

	goto: function(url, force_goto, options) {
		if (App.offline_mode.is_on()) return;

		App.core.log('core.goto', url);
		options ||= {};

		if (this.next_force_goto) {
			this.next_force_goto = false;
			force_goto = true;
		}

		let parser = new URL(url, window.location.origin);

		if (App.helper.validate.is_file_download_url(parser.pathname)) {
			return App.core.download_file(url);
		}

		// TODO: bind events
		App.sidebar?.hide_mobile();
		App.admin_menu?.hide_mobile();
		if (App.modal?.is_shown() && !App.modal.helper_validate_preview_url(url) && !App.modal.is_preserve) App.modal.hide({hide_all:true});
		if (!options.preserve_menu && App.menu?.is_shown()) App.menu.hide_all();

		if (!force_goto && App.task_view?.is_shown() && url.endsWith('/project/'+App.current_page.project+'/')) {
			if (App.mymenu?.is_shown()) App.mymenu.hide();
			if (App.right_panel?.is_shown()) App.right_panel.hide();
			if (!options.preserve_task_view) App.task_view.hide();
			return;
		}

		App.controls.page_reloader.remove();

		const is_external_host = (!App.hybrid_app && document.location.host !== parser.host)
			|| (App.hybrid_app && (document.location.host !== parser.host && App.api.get_account_domen().indexOf(parser.host) === -1));

		if (!is_external_host) App.core.hybrid_goto_history.push(url);

		force_goto = force_goto || is_external_host || $('body').hasClass('login') || url.indexOf('/login/') !== -1;
		if (force_goto) {
			if (App.hybrid_app) {
				if (is_external_host) {
					App.core.new_window(url);
				} else {
					App.helper.localStorage.set('force_goto', url, 30);
					document.location.href = '/';
				}
			} else {
				document.location.href = url;
			}
		} else {
			if (App.me.id) {
				if (App.helper.validate.file_view_url.test(parser.pathname) || App.helper.validate.link_view_url.test(parser.pathname)) {
					App.modal.show({url: parser.pathname})
					return;
				}
				if (App.helper.validate.task_url.test(parser.pathname) || App.helper.validate.task_url_fallback.test(parser.pathname)) {
					App.task_view.show({url: parser.pathname, hash: parser.hash});
					return;
				}
				if (App.helper.validate.chat_url.test(parser.pathname)) {
					App.chat_view.show({url: parser.pathname, hash: parser.hash});
					return;
				}
			}

			App.core.goto_pending = true;
			App.task_view.exit_fullscreen_url = null;

			if (App.mymenu?.is_shown()) App.mymenu.hide();
			if (App.right_panel?.is_shown()) App.right_panel.hide();
			if (App.task_view?.is_shown()) {
				if (App.task_view.open_in_fullscreen || App.device.is_sm_width()) App.task_view.hide();
			}

			if (App.core.has_goto_loader) App.controls.loader.start();
			App.core.has_goto_loader = true;

			App.core.async_task.ajax({
				id: 'core.goto',
				url: parser.pathname + parser.search,
				dataType: 'html',
				timeout: App.env === 'local' ? 60000 : 20000,
				headers: {'x-load-type': 'page'},
				error: function() {
					App.core.goto_pending = false;
					App.controls.loader.stop();
				},
				success: (html, status, xhr) => {
					App.core.goto_pending = false;
					App.core.page.init_after_load(html, status, xhr, options);
				}
			});
		}
	},

	post_form_submit: function(form) {
		form = $(form).last(); // JQuery or DOM object passed
		let form_action = form.attr('action') || document.location.pathname;
		let form_data = form.serialize()
		App.core.log('core.post_form_submit', form_action);
		if (App.mymenu.is_shown()) App.mymenu.hide();
		if (App.right_panel.is_shown()) App.right_panel.hide();
		if (App.object_state) App.object_state.available = false;
		App.controls.loader.start();
		$.ajax({
			url: form_action,
			dataType: 'html',
			timeout: 20000,
			type: 'POST',
			data: form_data,
			headers: {'x-load-type': 'page'},
			error: App.core.create_jq_ajax_error(function(xhr) {
				App.controls.loader.stop();
			}),
			success: (html, status, xhr) => App.core.page.init_after_load(html, status, xhr)
		});
	},

	goto_no_history: function(url) {
		if (App.object_state) App.object_state.available = false;
		document.location.replace(url);
	},

	new_window: function(url) {
		App.core.log('new_window', url);

		const open_url = App.hybrid_app ? new URL(url, App.api.get_account_domen()) : new URL(url, window.location.origin),
			locale = App.object_state.locale.confirm_new_window,
			is_download = App.helper.validate.is_file_download_url(open_url.pathname),
			should_confirm = !!App.hybrid_app;

		let real_open_url = open_url.toString();
		const whitelist = [
			'https://*.office.com/*',
			'https://*.officeapps.live.com/*',
			'https://*.live.com/*',
			'https://*.microsoftonline.com/*',
			'https://*.sharepoint.com/*',
			'https://*.office.net/*',
			'https://google.com/*',
			'https://*.googleusercontent.com/*',
			'https://*.gstatic.com/*',
			'https://*.googleapis.com/*',
			'https://*.google.com/*'
		];
		let should_rewrite = App.hybrid_app && whitelist.some(rule => new RegExp('^' + rule.replace(/\*/g, '.*').replace(/\/\*/, '.*') + '$').test(real_open_url));
		if (should_rewrite) {
			real_open_url = 'https://out.wsgo.in/r/' + real_open_url.replace(/^[a-z]+:\/\//, '');
		}

		const open = () => {
			return window.open(real_open_url, '', '');
		}

		if (!should_confirm) return open();

		const params = App.helper.object.clone(is_download ? locale.download : locale.link);
		params.message = params.message.replace('%s', '<br/><span style="word-break: break-all;font:var(--font-ui-12-mini-reg)">'+App.helper.html.encode(open_url.toString())+'</span>');

		return App.controls.confirm.menu($('body'), {
			variant: 'b',
			force_dropdown: false,
			onconfirm: open,
			...params,
		})
	},

	download_blob: function(content, filename, mimetype) {
		const blob = mimetype ? new Blob([content], { type: mimetype }) : content;
		const blobUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = blobUrl;
		link.download = filename;
		link.click();
		URL.revokeObjectURL(blobUrl);
	},

	request_feature: function (name) {
		if (window.Ybug) {
			Ybug.open();
		} else {
			let lang = App.config.language_symbol;
			if (lang === 'uk') lang = 'ua';
			App.core.new_window('https://worksection.com/'+lang+'/support.html?id_type=4')
		}
	},

	reload_everything: function() {
		// TODO: process any windows, reload top one
		if (App.modal.is_shown()) App.modal.hide({hide_all:true});
		if (App.task_view.is_shown()) App.task_view.reload();
		else App.core.reload();
	},

	form_submit: function(form, success_callback, fail_callback) {
		form = $(form).last(); // JQuery or DOM object passed
		if (form.attr('data-submitted') || form.hasClass('frm_dis')) return false;
		if (form.get(0).onsubmit) {
			let onsubmit = form.get(0).onsubmit();
			if (onsubmit === false) return false;
		}
		form.attr('data-submitted', 'yes');
		App.controls.editblock.set_updated_state(false);

		App.controls.loader.start();
		let form_data = new FormData(form.get(0));
		let form_action = form.attr('action') || document.location.pathname;

		let xhr = new XMLHttpRequest();
		xhr.requestURL = form_action.replace(/#.*/, '') || document.location.pathname + document.location.search;
		xhr.open("POST", App.core.base() + form_action, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 2 && xhr.responseURL.replace(/(http|https|monaca|monaca-debugger):\/\/[^\/]+/, '') !== xhr.requestURL) {
				xhr.abort();
				form.removeAttr('data-submitted');
				App.controls.loader.stop();
			}
			if (xhr.readyState !== 4) return;
			if (xhr.status !== 200) {
				App.controls.loader.stop();
				form.removeAttr('data-submitted');

				let is_handled = fail_callback ? fail_callback(xhr, xhr.responseText) : false;
				if (is_handled) return;

				App.core.process_ajax_error(xhr, { type: 'POST', url: xhr.requestURL });
			} else {
				App.controls.loader.stop();
				form.removeAttr('data-submitted');
				if (xhr.responseText) App.helper.eval_string(xhr.responseText);
				if (success_callback) success_callback()
			}
		};
		App.helper.xhr.set_headers(xhr);
		xhr.setRequestHeader('Accept', 'text/javascript');
		if (App.modal.is_shown()) xhr.setRequestHeader( 'x-modal-level', App.modal.layer_level);
		if (App.page.where()) xhr.setRequestHeader('x-page', App.page.where());
		if ($('body').attr('data-subpage')) xhr.setRequestHeader('x-subpage', $('body').attr('data-subpage'));
		xhr.send(form_data);

		// $.ajax({
		// 	type: 'POST',
		// 	url: form_action,
		// 	data: form_data,
		// 	processData: false,
		// 	dataType: 'script',
		// 	complete: function(xhr) {
		// 		if (xhr.responseText.indexOf('App.core.goto') === -1 && xhr.responseText.indexOf('App.core.reload') === -1) App.controls.loader.stop();
		// 	},
		// 	error: function() {
		// 	}
		// });
		// TODO: unify usage: document.modfrm, this.form, $(this).parents().form()
	},

	/** see also: App.helper.debounce */

	call_once: function(callback, delay = 0.01) { // shortcut
		App.core.call_queue.add('call_once.' + callback.toString().hashCode(), callback, App, null, delay);
	},

	form_as_url: function(form) {
		form = $(form).last(); // JQuery or DOM object passed
		return App.helper.url.add_query(form.attr('action')) + form.serialize();
	},

	download_file(url, post, callback) {
		App.core.log('download_file', url);

		url = url.indexOf('https://') === -1 ? App.core.base() + url : url;

		let promise = new Promise(function (resolve, reject) {
			let xhr = new XMLHttpRequest();
			xhr.open('POST', url, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.responseType = 'blob';
			xhr.onload = function () {
				let blob = xhr.response;

				// hybrid app fallback:
				if (xhr.status === 303) {
					return App.helper.read_blob_as_text(blob, function (error, next_url) {
						if (error) {
							reject(error);
						} else {
							App.core.new_window(App.core.base() + next_url);
							resolve();
						}
					});
				}

				if (xhr.status !== 200) {
					const error = new Error('Failed to download');

					if (blob.type === 'application/json') {
						App.helper.read_blob_as_text(blob, function (_, json) {
							try { error.show_message = JSON.parse(json).show_message; } catch (e) {}

							reject(error);
						});
					} else {
						reject(error);
					}

					return;
				}

				let disposition = this.getResponseHeader("Content-Disposition"),
					type = this.getResponseHeader("Content-type"), // server will tell correct mime type
					filename = 'export.xlsx';

				if (disposition && disposition.indexOf('attachment') !== -1) {
					let matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
					if (matches != null && matches[1]) filename = matches[1].replace('UTF-8\'\'', '').replace(/['"]/g, '');
					App.core.download_blob(blob, decodeURIComponent(filename), type)
					resolve();
				} else if (type && type.indexOf('text/javascript') === 0) { // JS response instead of file ((
					App.helper.read_blob_as_text(blob, function (error, text) {
						if (error) {
							reject(error);
						} else {
							eval(text);
							resolve();
						}
					});
				} else {
					reject(new Error('Failed to download'));
				}
			}
			App.helper.xhr.set_headers(xhr);
			xhr.send(post);
		});

		promise.then(function () {
			if (callback) callback();
		}).catch(function (err) {
			App.core.error('download_file', err);
			if (err.show_message) {
				App.message.show(err.show_message);
			} else {
				App.message.show(App.object_state.locale['load_error'], MSG_VARIANT_D, {
					action: { left_icon: 'autorenew', onclick: 'App.core.reload(true)', text: '' }
				});
			}
			// App.core.reload();
		});
	},
	download_file_with_loader(url, post, callback) {
		App.modal.hide();
		App.controls.loader.start();
		App.core.download_file(url, post, function() {App.controls.loader.stop()});
	},

	theme: {
		dark: false,
		custom: false,
		onchange_old: function () {
			$('body').fadeOut(100);
			setTimeout(App.core.theme.setup, 300);
			setTimeout(() => $('body').fadeIn(100), 500);
			App.core.theme.hybrid_app();
		},
		setup: function () {
			App.core.theme.update_meta();
			App.core.theme.update_ws_icons();
			App.core.theme.update_links();
			App.core.theme.update_images();
			App.core.theme.hybrid_app();
		},
		onchange: function () {
			$('body').fadeOut(100);

			App.core.theme.setup_withPromise()
				.then(() => {
					$('body').fadeIn(100);
				});
		},
		setup_withPromise: function () {
			return Promise.resolve()
				.then(App.core.theme.update_meta)
				.then(App.core.theme.update_ws_icons)
				.then(App.core.theme.update_links_withPromise)
				.then(App.core.theme.update_images)
				.then(App.core.theme.hybrid_app)
				.then(() => new Promise(r =>
					requestAnimationFrame(() =>
						requestAnimationFrame(r)
					)
				));
		},
		hybrid_app: function () {
			if (App.hybrid_app) {
				App.hybrid_app.theme = App.core.theme.dark;
				App.hybrid_app.updateStatusbarColor();
			}
		},
		update_meta: function () {
			// DESKTOP: color of #primaryMenu__wrapper
			$('meta[name="theme-color"][media*=481px]').attr('content', App.core.theme.dark ? '#141A1F' : '#253341');
			// MOBILE: color of .mobile-head
			$('meta[name="theme-color"][media*=480px]').attr('content', App.core.theme.dark ? '#2B333B' : '#ffffff');
		},
		update_ws_icons: function () {
			$('ws-icon:has(svg[data-theme-dep])').each(function () {
				$(this).attr('name', $(this).attr('name'))
			});
		},
		update_links: function () {
			$('link[rel="stylesheet"]').each(function() {
				let page = $(this).attr('data-page'), color = $(this).attr('data-color');

				if (page && page !== App.current_page.where && page !== App.current_page.where + '_' + App.current_page.version) $(this).prop("disabled", true);
				else if (color && color !== (App.core.theme.dark ? 'dark' : 'light')) $(this).prop("disabled", true);
				else $(this).prop("disabled", false);
			});
		},
		update_links_withPromise: function () {
			let wait = [];

			$('link[rel="stylesheet"]').each(function () {
				const page = $(this).attr('data-page');
				const color = $(this).attr('data-color');

				const should_disable =
					(page && page !== App.current_page.where && page !== App.current_page.where + '_' + App.current_page.version) ||
					(color && color !== (App.core.theme.dark ? 'dark' : 'light'));

				if (should_disable) {
					this.disabled = true;
					return;
				}

				this.disabled = false;

				wait.push(new Promise(resolve => {
					const link = this;

					const check = () => {
						try {
							if (link.sheet && link.sheet.cssRules) return resolve();
						} catch (e) {
							// cross domain
							return resolve();
						}
						requestAnimationFrame(check);
					};

					check();
				}));
			});

			return Promise.all(wait);
		},
		update_images: function () {
			const isDark = App.core.theme.dark;

			$('img[data-theme-dep], source[data-theme-dep]').each(function () {
				const $el = $(this);
				const tag = this.tagName.toLowerCase();
				const attr = (tag === 'source') ? 'srcset' : 'src';

				let val = $el.attr(attr);
				if (!val) return;

				let newVal = val;

				// варіант з dark/light
				if (/(^|[\/_\-.])(dark|light)([\/_\-.]|$)/.test(val)) {
					newVal = val.replace(/(^|[\/_\-.])(dark|light)(?=[\/_\-.]|$)/g, function (m, prefix) {
						return prefix + (isDark ? 'dark' : 'light');
					});
				}
				// варіант з day/night
				else if (/(^|[\/_\-.])(day|night)([\/_\-.]|$)/.test(val)) {
					newVal = val.replace(/(^|[\/_\-.])(day|night)(?=[\/_\-.]|$)/g, function (m, prefix) {
						return prefix + (isDark ? 'night' : 'day');
					});
				} else {
					return;
				}

				if (newVal !== val) {
					$el.attr(attr, newVal);
				}
			});
		},
		set: function(is_dark) {
			if (App.core.theme.custom) {
				$.getScript(App.helper.url.add_query(App.helper.endpoint.user(App.me.id), App.actions.get('user_process:theme_config') + '&is_dark=' + Number(is_dark)));
			}
		},
		onload: function() {
			window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => App.core.theme.set(event.matches));
			App.core.theme.set(window.matchMedia('(prefers-color-scheme: dark)').matches);
		},
		menu_set_theme: function (el, url) {
			$.getScript(url + '&is_dark=' + Number(window.matchMedia('(prefers-color-scheme: dark)').matches));
			$(el).siblings().removeClass('menu__item-active');
			$(el).addClass('menu__item-active');
		},
		onlogin: function () {
			$('body').attr('data-color', App.core.theme.dark ? 'color' : '');
			App.core.theme.setup();
		},
		onlogout: function () {
			App.core.theme.dark = false;
			$('body').attr('data-color', '');
			App.core.theme.setup();
		}
	},

	svg_loader: {
		files: {
			'ico-social' : 'color_sprite'
		},
		onload: function() {
			for (let i in App.core.svg_loader.files) {
				jQuery.get('/assets/img/icons/' + App.core.svg_loader.files[i] + '.svg', function(data) {
					let o = $(data).find('svg');
					$('#svg_container').append(o);
				}, 'xml');
			}
		}
	},

	do_login_refresh: function() {
		App.core.async_task.ajax(App.helper.endpoint.auth() + '?' + App.actions.get('login:refresh')).then(function(data) {
			if (data.status === 'login') App.workspace.logout();
		});
	},

	request_login_refresh: function() {
		App.core.multytab_function_call(App.core.do_login_refresh, 'refresh_login', 60);
	},

	onlogin: function() {
		App.core.websocket.start(App.core.context.use('core_websocket_host'));
		App.config.date_timestamp_offset = parseInt((new Date(App.config.date_sync_time)).getTime() / 1000) - App.config.date_sync_timestamp;
		App.config.date_sync_offset = App.helper.time.now() - App.config.date_launch_account;
		App.config.date_timezone_offset = App.config.date_launch_account - App.config.date_launch_server;

		App.expose_data.controller.set('endpoint', App.helper.endpoint.primary() + '?' + App.actions.get('expose_data:do'));

		App.core.context.when('sentry_config', function (conf) {
			if (window.Sentry) {
				Sentry.init(conf);
				App.core.log('sentry', 'initialized');
			} else {
				App.core.log('sentry', 'not defined');
			}
		});

		App.core.context.when('desktop_firebase_message', function (config) {
			App.core.desktop_firebase_message.start({ firebaseConfig: config.firebase, vapidKey: config.vapid_key }).catch(err => {
				App.core.error('desktop_firebase_message::start', err);
			});
		});
		App.core.context.when('preload_pages', function (pages) {
			App.core.page.preload(pages);
		});
		App.core.context.when('menu_counter_event', function (val) {
			if (App.config['title_event_count']) App.mymenu.update_page_title_counter(val);
		});

		App.core.context.when('singletones', function (data) {
			Object.keys(data).forEach(key => {
				App.classes[key].getInstance(data[key]);
			})
		});
		App.core.context.when('team_timers_init', function (data) {
			App.team_timers.init(data.data, data.ids_user);
		});

		$('body').attr('data-lang', App.lang);
		App.core.theme.onlogin();
		App.helper.nextTick(App.core.process_start_url);

		if (!App.hybrid_app) {
			App.helper.cron.add('refresh_login', function() {
				if (App.offline_mode.active) return;
				App.core.request_login_refresh();
			}, (App.core.login_refresh_interval_sec + Math.round(Math.random()*App.core.login_refresh_interval_sec/5)));
		}
	},
	onlogout: function () {
		App.core.theme.onlogout();
		App.helper.cron.remove('refresh_login');
		App.core.async_task.abort_all();
		App.core.call_queue.clear();
		App.core.websocket.stop();
		App.core.desktop_firebase_message.stop().catch(err => {
			App.core.error('desktop_firebase_message::stop', err);
		});
	},

	onload: function() {
		App.core.devtools?.init();
		App.core.history?.mobile?.init();

		App.bus.app.once('page_load page_ready', App.helper.debounce(() => App.core.page.preload(), 5000));

		if (App.core.is_active()) App.helper.cron.start();
		App.bus.window.on('active', () => App.helper.cron.start()).on('inactive', () => App.helper.cron.stop());

		this.obj_window = $('main');
		// App.core.svg_loader.onload();
		App.core.theme.onload();

		if (!/^ws/.test(window.name)) window.name = $('body').attr('data-win-pref') ? $('body').attr('data-win-pref') : 'ws' + (1000 + Math.round(Math.random() * 8999));
		window.addEventListener("beforeunload", function() {
			$(document).off("ajaxSuccess");
			$(document).off("ajaxSend");
			$(document).off("ajaxComplete");
			App.helper.localStorage.set('reload_state', {
				url: App.core.url,
				task_url: App.task_view?.is_shown() ? App.task_view.url : ''
			}, 10);
			App.core.set_cookie('ws_tab', window.name, 1);
			App.core.set_cookie('ws_ref', window.location.href, 1);
			App.core.set_cookie('ws_dark', App.core.theme.dark ? 1 : 0, 1);
		});

		$(document).on("ajaxSuccess", function(e, xhr) {
			if (App.account != null && xhr.getResponseHeader('X-App-State-Hash')) {
				if (App.account.hash_state !== xhr.getResponseHeader('X-App-State-Hash')) App.object_state.account.state(App.account.id, xhr.getResponseHeader('X-App-State-Hash'));
			}
			if (App.me != null && xhr.getResponseHeader('X-DB-State-Hash')) {
				if (App.me.db_hash !== xhr.getResponseHeader('X-DB-State-Hash')) App.task_db.update_workspace(xhr.getResponseHeader('X-DB-State-Hash'));
			}

			let appHash = xhr.getResponseHeader('X-App-Build');
			if (appHash && window.APP_BUILD_HASH && appHash !== window.APP_BUILD_HASH) {
				App.controls.page_reloader.app_version_changed();
			}

			let workTime = xhr.getResponseHeader('X-Work-Time');
			if (workTime) {
				App.work_time.set_state(workTime === '1');
			}
		});

		$.ajaxSetup({
			headers: {
				'x-load-type': 'ajax'
			},
			beforeSend: function(xhr, settings) {
				xhr.setRequestHeader('X-Viewport-Width', App.device.window_width);
				if (App.hybrid_app) {
					if (settings.url.substring(0, 1) === '/') {
						if (/\.(css|json|js)$/.test(settings.url) && settings.url.substr(0, 6) !== '/ajax/') settings.url = ('/cors/' + settings.url).replace('//', '/');
						settings.url = App.api.get_account_domen() + settings.url; // domain setup in beforeSend don't affects $.ajaxSettings.ajaxcrossDomain
					}
					if (App.hybrid_app.token && settings.dataType === 'script') {
						settings.url = App.helper.url.add_query(settings.url, '', {
							is_app: 1,
							token: App.hybrid_app.token,
							version: '2.0'
						});
					} else {
						xhr.setRequestHeader("X-app", '2.0');
						if (App.hybrid_app.token) xhr.setRequestHeader("X-app-token", App.hybrid_app.token);
					}
					xhr.url = settings.url;
				}

				if (settings.context?.__rid == null) {
					settings.context = settings.context || {};
					settings.context.__rid = App.helper.random.string(8) + Date.now().toString(16);
				}
			},
			error: function(xhr) {
				App.controls.loader.stop();
				App.core.process_ajax_error(xhr, this);
			},
		});

		if (App.hybrid_app) {
			// `+*` appends prefilter for all types
			$.ajaxPrefilter('+*', function (s) {

				// `script` etc
				if (s.dataType) return;

				const is_allowed_domain = s.url.startsWith(App.api.get_account_domen())
					|| s.url.substring(0, 1) === '/';
				if (is_allowed_domain) {
					s.crossDomain = false;
				}
			});
		}

		//TODO: migrate from $.ajax to own

		// /**
		//  * @type {Ajax}
		//  */
		// const ajax_instance = App.classes.ajax.getInstance();
		// ajax_instance.setDefaults({
		// 	headers: {
		// 		...ajax_instance.current.headers,
		// 		'x-load-type': 'ajax'
		// 	}
		// })
		// ajax_instance.useInterceptor('error', async ({ req, res, data, text }) => {
		// 	if (res?.status === 403) {
		// 		App.controls.loader.stop();
		// 		if (text?.indexOf('modal__alert') !== -1) {
		// 			App.menu.hide(true);
		// 			let alert = $('<div></div>').html(text);
		// 			App.message.show(alert.find('p').text(), MSG_VARIANT_D, {
		// 				actions: [{
		// 					left_icon: 'autorenew',
		// 					onclick: 'window.location.reload()',
		// 					text: alert.find('ws-btn').attr('text')
		// 				}]
		// 			});
		// 		}
		// 	} else if (res?.status === 401) {
		// 		App.workspace.logout(res.headers.get('X-Login-Step'));
		// 	} else if (res?.status > 0) {
		// 		App.message.show('', MSG_VARIANT_D, {
		// 			action: {
		// 				left_icon: 'autorenew',
		// 				onclick: 'window.location.reload()',
		// 				text: ''
		// 			}
		// 		});
		// 	} else {
		// 		App.controls.loader.stop();
		// 	}
		// });




		$.ajaxPrefilter(function(options, originalOptions, xhr) {
			if (App.page.where()) xhr.setRequestHeader('x-page', App.page.where());
			if ($('body').attr('data-subpage')) xhr.setRequestHeader('x-subpage', $('body').attr('data-subpage'));
			if (App.mymenu && App.mymenu.is_shown()) xhr.setRequestHeader('x-mymenu', 'on');
			if ($('body').hasClass('bd_session') && ((options.data && options.data.indexOf('skip_notify') !== -1) || options.url.indexOf('skip_notify') !== -1)) xhr.setRequestHeader('x-session-changes', 'yes');
			if (!App.core.websocket.ready && App.object_state?.seen) xhr.setRequestHeader('x-object-state', App.object_state.seen);
			// let originalComplete = options.complete;
			// options.complete = function (xhr, textStatus) {
			// 	if (typeof originalComplete == 'function') originalComplete(xhr, textStatus);
			// };
			// let originalSuccess = options.success;
			// options.success = function (data, textStatus, xhr) {
			// 	if (typeof originalSuccess == 'function') originalSuccess(data, textStatus, xhr);
			// };
		});
		//TODO: migrate from $.ajax to own

		// ajax_instance.useInterceptor('request', ({ req }) => {
		// 	if (App.page.where()) req.headers['x-page'] = App.page.where();
		// 	if ($('body').attr('data-subpage')) req.headers['x-subpage'] = $('body').attr('data-subpage');
		// 	if (App.mymenu && App.mymenu.is_shown()) req.headers['x-mymenu'] = 'on';
		// 	if ($('body').hasClass('bd_session') && ((req.data && req.data.skip_notify) || req.url.indexOf('skip_notify') !== -1))  req.headers['x-session-changes'] = 'yes';
		// 	if (!App.core.websocket.ready && App.object_state?.seen) xhr.headers['x-object-state'] = App.object_state.seen;
		// });

		$(window).on('storage', App.core.listen_messages_from_other_tabs);
		$(window).on('message', App.core.listen_messages_from_frames);

		if ($(window).width() > 480 && (window.devicePixelRatio >= 1.5 || (window.matchMedia && window.matchMedia("(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)").matches))) {
			if (document.cookie.indexOf('is_retina') === -1) App.core.set_cookie('is_retina', 1, 365 * 86400);
		}

		try {
			let options = Object.defineProperty({}, "passive", {
				get: function () {
					App.core.passive_supported = true;
				}
			});
			window.addEventListener("test", null, options);
		} catch (err) {
		}

		let last_hash = location.hash;
		$(window).on('popstate', (e) => {
			if (App.core.goto_pending) return;
			const is_hashchange = location.hash !== last_hash;
			if (is_hashchange) last_hash = location.hash;
			return App.core.history.pop(e, is_hashchange);
		});
		// Page Controller SHOULD only cal
		// $(document).trigger('page_init.once').unbind('page_init.once');
		// $(document).trigger('page_onload.once').unbind('page_onload.once');
		// $(document).trigger('page_onload.final').unbind('page_onload.final');
		// $(document).trigger('page_onload.everytime');

		this.start_url = document.location.pathname;
		// if ($('main').length) setTimeout(() => this.process_start_url(), 50App.helper.nextTick();)

		$(window).on('message', App.core.listen_messages_from_promo_gate);

		// browser WINDOW events:
		window.addEventListener("visibilitychange", (event) => {
			App.bus.window.emit(App.core.is_active() ? 'active' : 'inactive', event);
		});
		window.addEventListener('beforeunload', (event) => {
			App.bus.window.emit('beforeunload', event);
		});
		let lastWidth = $(window).width();
		let lastHeight = $(window).height();
		let checkVersionTime = 0;
		$(window).bind('resize', (event) => {

			App.bus.window.emit('resize', event);

			const newWidth = $(window).width();
			const newHeight = $(window).height();

			if (newWidth !== lastWidth && newHeight !== lastHeight) {
				App.bus.window.emit('resize_both', event, { width: newWidth, height: newHeight });
			} else if (newWidth !== lastWidth) {
				App.bus.window.emit('resize_width', event, { width: newWidth });
			} else if (newHeight !== lastHeight) {
				App.bus.window.emit('resize_height', event, { height: newHeight });
			}

			lastWidth = newWidth;
			lastHeight = newHeight;
		}).bind('scroll', (event) => {
			App.bus.window.emit('scroll', event);
		}).bind('focus', (event) => {

			if (window.APP_BUILD_HASH && Date.now() - checkVersionTime > 300000) {
				checkVersionTime = Date.now();
				App.core.fetch_version_json().then(data => {
					if (data.app && window.APP_BUILD_HASH && data.app !== window.APP_BUILD_HASH) {
						App.controls.page_reloader.app_version_changed();
					}
				}).catch(err => App.core.error('check_version', err))
			}

			App.bus.window.emit('focus', event);
		}).bind('blur', (event) => {
			App.bus.window.emit('blur', event);
		}).bind('offline', (event) => {
			App.bus.window.emit('offline', event);
		}).bind('online', (event) => {
			App.bus.window.emit('online', event);
		}).bind('storage', (event) => {
			App.bus.window.emit('storage', event);
		}).bind('dragstart', (event) => {
			App.bus.window.emit('dragstart', event);
		}).bind('dragend', (event) => {
			App.bus.window.emit('dragend', event);
		}).bind('dragenter', (event) => {
			App.bus.window.emit('dragenter', event);
		}).bind('mousemove', (event) => {
			App.bus.window.emit('mousemove', event);
		}).bind('mouseleave', (event) => {
			App.bus.window.emit('mouseleave', event);
		}).bind('mousewheel', (event) => {
			App.bus.window.emit('mousewheel', event);
		}).bind('touchmove', (event) => {
			App.bus.window.emit('touchmove', event);
		}).bind('touchstart', (event) => {
			App.bus.window.emit('touchstart', event);
		}).bind('keyup', (event) => {
			App.bus.window.emit('keyup', event);
		}).bind('click', (event) => {
			App.bus.window.emit('click', event);
		});

		if (typeof visualViewport != 'undefined') {
			window.visualViewport.addEventListener('resize', function (event) {
				App.bus.window.emit('resize_viewport', event);
			});
			window.visualViewport.addEventListener('scroll', function (event) {
				App.bus.window.emit('scroll_viewport', event);
			});
		}

		App.bus.app.on('page_load', function () {
			if ($('#super_error').length > 0) {
				let super_err_close = $('<ws-btn name="btn btn-w btn-solid" left-icon="close"></ws-btn>');
				super_err_close.on('click', () => $('#super_error').remove());
				$('#super_error').append(super_err_close);
			}
		});
		App.bus.other_tab.on('ui_state', ({state}) =>
			App.classes.ui_state_manager.getInstance().mergeStateSilent(state)
		)

		App.bus.state.on('account_update', function (payload) {
			if (payload.data.account_url) {
				App.core.set_account_url(payload.data.account_url);
			}
		});
	},

	set_account_url: function (url) {
		if (App.config.account_url === url) return;

		App.core.log('set_account_url', url);
		App.config.account_url = url

		if (App.hybrid_app) return;

		const account_url = url;
		const alert = $('<div class="fullPageAlert fullPageAlert-account_url"><div class="fullPageAlert__body"></div></div>');
		const alert_body = alert.find('.fullPageAlert__body');

		alert_body.append('<div class="fullPageAlert__body-title"></div>');
		alert_body.append('<div class="fullPageAlert__body-content"></div>');

		alert_body.find('.fullPageAlert__body-title').text(App.object_state.locale.account_url_alert);
		const link = $('<a>');
		link.attr('href', new URL(window.location.pathname, account_url)).text(account_url);
		alert_body.find('.fullPageAlert__body-content').append(link);
		$('body').append(alert);

		App.helper.nextTick(function () {
			alert.addClass('fullPageAlert-shown');
		});
	},

	fetch_version_json: function() {
		return fetch((App.hybrid_app ? App.api.get_account_domen() : '') + '/version.json?version=2.0', {
			cache: 'no-store'
		}).then(r => r.json());
	},

	process_start_next: null,
	start_hash: null,
	process_start_url: function() {
		App.core.log('process_start_url', window.location.href);
		App.page = App.core.page.create_fake_page();

		if (App.hybrid_app) {
			App.core.start_hash = document.location.hash;
			App.core.goto(App.helper.localStorage.get('force_goto', '/'));
			return;
		}

		let reload_state = App.helper.localStorage.get('reload_state', {});
		App.helper.localStorage.del('reload_state');

		if (document.location.hash === '#events') {
			let await_func = function() {
				if (!$('.primaryMenu__item[data-custom-page=events]').length) {
					setTimeout(await_func, 50);
					return false;
				}
				$('.primaryMenu__item[data-custom-page=events]').click();
			}
			await_func();
		}

		let match = document.location.pathname.match(App.helper.validate.task_url_fallback);
		if (match) {
			let task_url = document.location.pathname;
			let task_hash = document.location.hash;
			App.core.process_start_next = function() {
				if (match[1] != App.config.id_project_chat) App.task_view.show({url: task_url, hash: task_hash});
			};
			App.core.goto( match[1] == App.config.id_project_chat || match[1] == App.config.id_project_inbox ? '/' : App.helper.url.project(match[1]));
			return;
		}
		match = document.location.pathname.match(App.helper.validate.project_url);
		if (match && (match[1] == App.config.id_project_inbox || match[1] == App.config.id_project_chat)) {
			App.core.goto('/');
			return;
		}
		match = document.location.pathname.match(App.helper.validate.task_url);
		if (match) {
			let task_url = document.location.pathname;
			let task_hash = document.location.hash;
			if (reload_state.url) {
				App.core.process_start_next = function() {
					App.task_view.show({url: task_url, hash: task_hash}); // redirect to homepage if task is not exists
				};
				App.core.goto(reload_state.url); // refer to correct project
			} else {
				App.task_view.show_page({url: task_url, hash: task_hash}, '/task/' + match[1] + '/project/');
				App.core.history.push('/', 'Worksection');
				App.sidebar.onload();
			}
			return;
		}
		match = document.location.pathname.match(App.helper.validate.chat_url);
		if (match) {
			let task_url = document.location.pathname;
			let task_hash = document.location.hash;
			if (reload_state.url) {
				App.core.process_start_next = function() {
					App.chat_view.show({url: task_url, hash: task_hash});
				};
				App.core.goto(reload_state.url);
			} else {
				App.chat_view.show_page({url: task_url, hash: task_hash});
				App.core.history.push('/', 'Worksection');
				App.sidebar.onload();
			}
			return;
		}

		App.core.start_hash = document.location.hash;
		let url = document.location.href;
		if (/\/(login|logout)\//.test(url)) url = '/';
		App.core.goto(url);
	},

	process_start_hash: function (regexp, handler) {
		let start_hash_match = App.core.start_hash ? App.core.start_hash.match(regexp) : null;
		if (start_hash_match) {
			App.core.start_hash = null;
			handler(start_hash_match);
		}
	},

	get_whole_dom: function() {
		return App.task_view_cache.get_all().add('body').add(App.menu.get_all());
	},

	// TODO cache control
	inject_script: function (path, resolve, reject) {
		const script = document.createElement('script');
		script.onload = function() {
			if (resolve) resolve('loaded');
		};
		script.onerror = function() {
			if (reject) reject();
		};
		script.async = true;
		script.src = path;
		document.head.appendChild(script);
	},

	inject_script_once: function (path, resolve, reject) {
		if ( $('script[src="'+path+'"]').length ) {
			if (resolve) resolve('cached');
			return;
		}
		App.core.inject_script(path, resolve, reject);
	},

	hybrid_app: {
		onBackButton: function (e) {
			e.preventDefault();
			e.stopPropagation();
			window.stop_click = true;
			setTimeout(() => window.stop_click = false, 500);

			App.hybrid_app.emit('back_button');

			if (App.menu.is_shown()) {
				App.menu.hide();
			} else if (App.modal.is_shown()) {
				App.modal.hide();
			} else if (App.mymenu.is_shown()) {
				App.mymenu.hide();
			} else if (App.right_panel.is_shown()) {
				App.right_panel.hide();
			} else if (App.windows.has_opened()) {
				App.windows.close();
			} else if (App.sidebar.is_shown()) {
				App.sidebar.hide();
			} else if (App.core.hybrid_goto_history.has_back()) {
				App.core.hybrid_goto_history.back();
			} else if (navigator.app) {
				navigator.app.exitApp();
			} else if (navigator.device) {
				navigator.device.exitApp();
			}

			return false;
		}
	},

	lifecycle: {
		hook_bindings: new Map(),
		boot_bindings: {
			eventbus: null
		},
		call_hooks: function (name, params) {
			this.forget_bindings(name);

			let eventbus = new Map();
			for (let i in App) {
				if (i === 'core') continue;
				if (App[i] != null && App[i][name] != null && typeof App[i][name] === 'function') {
					App.bus.begin_binding_context();
					App[i][name](params);
					eventbus.set(i, App.bus.finish_bounded_context());
				}
			}

			this.hook_bindings.set(name, {
				eventbus: eventbus,
			});

			return this;
		},
		forget_bindings_by_module: function (name) {
			for (const bindings of this.hook_bindings.values()) {
				const eventbus = bindings.eventbus.get(name);
				if (eventbus == null) continue;

				eventbus.off();
				bindings.eventbus.delete(name);
			}

			return this;
		},
		forget_bindings: function (hook_name) {
			const bindings = this.hook_bindings.get(hook_name);
			if (bindings == null) return this;

			for (const ctx of bindings.eventbus.values()) {
				ctx.off();
			}

			bindings.eventbus.clear();
			this.hook_bindings.delete(hook_name);

			return this;
		},
		boot: function () {
			if (App.hybrid_app) {

				document.addEventListener("backbutton", App.core.hybrid_app.onBackButton);

				App.hybrid_app.onBackButton = () => {};

				// Object.keys(App.core.hybrid_app).forEach(key => {
				// 	App.hybrid_app[key] = App.core.hybrid_app[key];
				// });
			}

			App.core.log('core.lifecycle', 'boot');
			App.core.init();
			App.core.lifecycle.call_hooks('onBoot');

			$(document).bind('modal_onload.everytime', () => App.bus.app.emit('modal_load'));
			$(document).bind('modal_onunload', () => App.bus.app.emit('modal_unload'));
			$(document).bind('menu_load.everytime', () => App.bus.app.emit('menu_load'));
			$(document).bind('menu_unload.everytime', () => App.bus.app.emit('menu_unload'));
		},
		login: function () {
			App.core.log('core.lifecycle', 'login');
			App.core.onlogin();
			App.core.lifecycle.forget_bindings('onLogout').call_hooks('onLogin');
			App.bus.app.emit('login');
		},
		logout: function () {
			App.core.log('core.lifecycle', 'logout');
			App.core.lifecycle.forget_bindings('onLogin').call_hooks('onLogout');
			App.core.page.onlogout();
			App.bus.app.emit('logout');
			App.core.onlogout();
		},
		page_init: function (params) {
			App.core.lifecycle.call_hooks('onInitPage', params);
			App.bus.app.emit('page_init');
		},
		page_load: function () {
			// backward compatability:
			$(document).trigger('page_onload.once').unbind('page_onload.once');
			$(document).trigger('page_onload.final').unbind('page_onload.final');
			$(document).trigger('page_onload.everytime');

			if (App.core.process_start_next) {
				App.core.log('process_start_next')
				App.core.process_start_next();
				App.core.process_start_next = null;
			}

			App.core.lifecycle.call_hooks('onLoadPage');
			App.bus.app.emit('page_load');
			App.core.start_hash = null;
		},
		page_ready: function () {
			App.core.lifecycle.call_hooks('onReadyPage');
			App.bus.app.emit('page_ready');
		},
		page_unload: function () {
			App.core.lifecycle
				.forget_bindings('onInitPage')
				.forget_bindings('onLoadPage')
				.forget_bindings('onReadyPage')
				.call_hooks('onUnloadPage')
				.forget_bindings_by_module('page');

			App.bus.app.emit('page_unload');

			$(document).unbind('.page');
			$(window).unbind('.page');
		},
	},

	asset_rewrite_path_in_body: function (html) {
		if (!App.hybrid_app) return html;

		let handler = function (path) {
			// uploaded files:
			if (path.startsWith('/preview/') || path.startsWith('/file/') || path.startsWith('/files/')) {
				return App.api.get_account_domen() + path;
			}

			return App.hybrid_app.asset_rewrite_path(path);
		};

		// html attribute or string:
		html = html.replace(/"\/images\//g,             '"' + handler('/images/'));
		html = html.replace(/"\/preview\//g,            '"' + handler('/preview/'));
		html = html.replace(/"\/data\/images\//g,       '"' + handler('/data/images/'));
		html = html.replace(/"\/assets\/js\/es5\//g,    '"' + handler('/assets/js/es5/'));
		html = html.replace(/"\/assets\/img\/icons\//g, '"' + handler('/assets/img/icons/'));
		html = html.replace(/"\/assets\//g,             '"' + handler('/assets/'));
		html = html.replace(/"\/files\//g,              '"' + handler('/files/'));
		html = html.replace(/"\/file\//g,               '"' + handler('/file/'));

		// encoded json:
		html = html.replace(/"\\\/images\\\//g,         '"' + handler('/images/').replace('/', '\\/'));
		html = html.replace(/"\\\/preview\\\//g,        '"' + handler('/preview/').replace('/', '\\/'));
		html = html.replace(/"\\\/files\\\//g,          '"' + handler('/files/').replace('/', '\\/'));
		html = html.replace(/"\\\/file\\\//g,           '"' + handler('/file/').replace('/', '\\/'));
		html = html.replace(/"\\\/data\\\/images\\\//g, '"' + handler('/data/images/').replace('/', '\\/'));

		// inline style:
		html = html.replace(/url\(\/images\//g,         'url(' + handler('/images/'));
		html = html.replace(/url\(\/preview\//g,        'url(' + handler('/preview/'));
		html = html.replace(/url\(\/files\//g,          'url(' + handler('/files/'));
		html = html.replace(/url\(\/file\//g,           'url(' + handler('/file/'));
		html = html.replace(/url\(\/data\/images\//g,   'url(' + handler('/data/images/'));
		html = html.replace(/url\(\/assets\//g,         'url(' + handler('/assets/'));

		return html;
	}
};

App.i18n = {
	/**
	 * @param {LocaleKey} key
	 * @param {string|number} params
	 * @return {*|string}
	 */
	t: function (key, ...params) {
		params||= [];
		let str = key.split('.').reduce(function (acc, k) {
			return typeof acc === 'object' ? acc[k] : undefined;
		}, App.object_state.locale);

		if (str === undefined) {
			App.core.warn('i18n', 'Key not found: ' + key);
		}

		str = str ?? key;

		while (str.includes('%s')) {
			str = str.replace('%s', params.shift() ?? '');
		}

		return str.trim();
	},
}

$(document).really_ready(() => {
	App.helper.nextTick(App.core.lifecycle.boot);
});

/**
 * @typedef {Object} RPC
 * @property {(id: Number, proof?: Object) => Promise<UserFromTeam>} getUser
 * @property {(id: Number, proof?: Object) => Promise<ContactFromTeam>} getContact
 * @property {(id_inst: Number, id_entity: Number, id_field: Number) => Promise<String>} getCustomValue
 */

;class AsyncTask {

	constructor() {
		this.tasks = new Map();
		this.next_id = 0;
	}

	run (id, create_task) {
		let self = this;
		if (self.tasks.has(id)) throw new Error('Task with id "' + id + '" already exists.');

		const controller = new AbortController(), signal = controller.signal;
		const promise = create_task(signal)
			.then(function (result) {
				if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
				else self.tasks.delete(id);

				return result;
			})
			.catch(function (err) {
				if (!signal.aborted) self.tasks.delete(id);

				// err === 'timeout'
				if (typeof err === 'string') err = new Error(err);

				err.is_aborted = signal.aborted;
				throw err;
			});

		self.tasks.set(id, {
			controller: controller,
			promise: promise
		});

		promise.abort = () => {
			self.tasks.delete(id);
			controller.abort();
		};

		return promise;
	}
	ajax (options) {
		let self = this;
		if (typeof options === 'string') options = { url: options };
		let id = options.id || options.url || self.next_id++;

		if (self.tasks.has(id)) self.abort(id);

		return self.run(id, function create_async_task (signal) {
			return new Promise(function (resolve, reject) {
				let success_handler = options.success, error_handler = options.error;

				if (success_handler != null) options.success = undefined;
				if (error_handler != null) options.error = undefined;

				let is_rejected_before_start = false;
				if (options.before_start) {
					let fn = options.before_start;
					options.before_start = undefined;
					is_rejected_before_start = fn(options) === false;
				}

				if (is_rejected_before_start) {
					reject(new Error('Discarded before start'));
				}

				let xhr = $.ajax(options);

				xhr.done(function (res, textStatus, jqXHR) {
					if (signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));

					if (success_handler != null) success_handler(res, textStatus, jqXHR);
					resolve(res);
				}).fail(function(jqXHR, textStatus, errorThrown) {
					if (error_handler != null) error_handler(jqXHR, textStatus, errorThrown);

					if (textStatus === 'abort') {
						reject(new DOMException('Aborted', 'AbortError'));
					} else {
						reject(errorThrown || new Error('AJAX failed'));
					}
				});

				signal.addEventListener('abort', function() {
					xhr.abort();
				});
			})
		})
	}
	context (id) {
		let self = this;

		return {
			run: (create_task) => self.run(id, create_task),
			ajax: (options) => {
				if (typeof options === 'string') options = { url: options };

				return self.ajax({ ...options, id })
			},
			abort: () => self.abort(id),
			is_idle: () => self.is_idle(id),
			is_loading: () => self.is_loading(id),
		};
	}
	abort (id) {
		const task = this.tasks.get(id);
		if (!task) return;

		this.tasks.delete(id);
		App.core.log('async_task.aborting', id)
		task.controller.abort();
	}
	is_idle (id) {
		return !this.tasks.has(id);
	}
	is_loading (id) {
		return this.tasks.has(id);
	}
	abort_all (filter) {
		for (let id_task of this.tasks.keys()) {
			if (filter && !filter(id_task)) continue;
			this.abort(id_task);
		}
	}
}

class AsyncModule {
	constructor(hash) {
		this.hash = hash;
		this.modules = new Map();
		this.loaded_scripts = new Map();
		this.loading_scripts = new Set();
		this.loaded_stylesheets = new Map();
		this.loading_stylesheets = new Set();
		this.preload_timer = null;
		this.preload_queue = [];
		this.preloading = false;
	}

	register (name, constructor) {
		this.modules.set(name, constructor);
	}
	init (name, params) {
		const constructor = this.modules.get(name);
		if (constructor == null) throw new Error('Unknown module: ' + name);

		return constructor(params);
	}
	resolve (name, url) {
		let self = this;
		return new Promise(function (resolve, reject) {
			if (self.modules.has(name)) return resolve(self.modules.get(name));

			self.load_script(url)
				.then(() => {
					const constructor = self.modules.get(name);

					if (typeof constructor === 'function') {
						resolve(constructor);
					} else {
						reject(new Error('Failed to resolve async module: ' + name))
					}
				})
				.catch(reject);
		});
	}
	wait_for (type, url) {
		let self = this;
		return new Promise(function (resolve, reject) {
			let interval, passed = 0, t = 200, max = 10*1000, check = () => {
				passed+= t;
				if (self['loaded_' + type].has(url)) {
					clearInterval(interval);
					resolve();
				} else if (!self['loading_' + type].has(url)) {
					clearInterval(interval);
					reject(new Error('Failed to load: ' + type + ' ' + url));
				} else if (passed > max) {
					clearInterval(interval);
					reject(new Error('Timeout while loading: ' + type + ' ' + url));
				}
			};
			interval = setInterval(check, t);
		});
	}
	load_script (url) {
		let self = this;
		if (self.loading_scripts.has(url)) return self.wait_for('scripts', url);

		return new Promise(function (resolve, reject) {
			if (self.loaded_scripts.has(url)) return resolve();

			self.loading_scripts.add(url);

			let script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.onload = () => {
				//console.log("%cJS loaded:%c " + url, "color: white; background:blue; padding:2px;", "color: black; background:transparent;");
				self.loading_scripts.delete(url);
				self.loaded_scripts.set(url, script)
				resolve();
			};
			script.onerror = (err) => {
				self.loading_scripts.delete(url);
				document.head.removeChild(script);
				reject(err);
			};
			script.src = App.core.asset_rewrite_path(url) + (self.hash ? '?h='+self.hash : '');
			document.head.appendChild(script);
		});
	}
	load_stylesheet (url) {
		let self = this;
		if (self.loading_stylesheets.has(url)) return self.wait_for('stylesheets', url);

		return new Promise(function (resolve, reject) {
			if (self.loaded_stylesheets.has(url)) return resolve();

			self.loading_stylesheets.add(url);

			const link = document.createElement('link');
			link.rel = 'preload';
			link.as = 'style';
			link.href = App.core.asset_rewrite_path(url) + (self.hash ? '?h='+self.hash : '');
			link.onload = () => {
				if (link.rel === 'preload') {
					link.rel = 'stylesheet';
				} else {
					self.loading_stylesheets.delete(url);
					self.loaded_stylesheets.set(url, link);
					//console.log("%cCSS loaded:%c " + url, "color: white; background:darkblue; padding:2px;", "color: black; background:transparent;");
					resolve();
				}
			};
			link.onerror = () => {
				self.loading_stylesheets.delete(url);
				document.head.removeChild(link);
				reject();
			};
			document.head.appendChild(link);
		});
	}
	load_file (url) {
		let path = url.split('?').shift();

		if (path.endsWith('.js')) {
			return this.load_script(url);
		} else if (path.endsWith('.css')) {
			return this.load_stylesheet(url);
		}

		return Promise.reject(new Error('Loader not detected for: ' + path));
	}
	preload_task () {
		let self = this;
		let next_url = self.preload_queue.shift();
		if (next_url == null) return;

		if (self.loading_scripts.has(next_url) || self.loaded_scripts.has(next_url)) return self.preload_task();
		if (self.loading_stylesheets.has(next_url) || self.loaded_stylesheets.has(next_url)) return self.preload_task();

		self.preloading = true;
		self.load_file(next_url).finally(() => {
			self.preloading = false;
			clearTimeout(self.preload_timer);
			self.preload_timer = setTimeout(self.preload_task.bind(self), 1250);
		});
	}
	preload (url) {
		let self = this;

		if (url) {
			let urls = Array.isArray(url) ? url : [url];
			self.preload_queue.push(...urls);
		}

		if (!self.preloading) {
			clearTimeout(self.preload_timer);
			self.preload_timer = setTimeout(self.preload_task.bind(self), 10);
		}

		return self;
	}
}

;class CallQueue {

	constructor() {
		this.data = {};
		this.timeout = null;
	}

	add(id, callback, context, params, delay_seconds) {
		this.data[id] = {
			dt: Date.now() + 1000 * (delay_seconds || 0),
			callback: callback,
			context: context,
			params: params,
			running: false
		};
		if (!this.timeout) this.timeout = setInterval(() => this.run(), 50);
	}

	delete(id) {
		if (id in this.data) delete(this.data[id]);
	}

	retry_after(id, delay_seconds) {
		if (id in this.data) {
			this.data[id].dt += 1000 * (delay_seconds || 0);
			this.data[id].running = false;
		}
	}

	run() {
		let exists = false;
		let dt = Date.now();
		for (let id in this.data) {
			if (this.data[id].dt < dt) {
				if (this.data[id].running) continue;
				this.data[id].running = true;
				this.data[id].callback.call(this.data[id].context, this.data[id].params, function() {
					if ((id in this.data) && this.data[id].running) this.delete(id);
				}.bind(this), function() {
					this.retry_after(id, 10);
				}.bind(this));
			} else exists = true;
		}
		if (!exists) {
			clearInterval(this.timeout);
			this.timeout = null;
		}
	}

	clear() {
		// console.log('call_queue.clear', Object.keys(this.data));
		if (this.timeout) {
			clearInterval(this.timeout);
			this.timeout = null;
		}
		this.data = {};
	}
}

;class ContextProvider {
	constructor() {
		this.data = new Map();
	}

	add (key, payload) {
		if (this.data.has(key)) App.core.warn('ContextProvider::add', 'Context ['+key+'] has already provided');

		this.data.set(key, payload);
	}
	use (key, fallback) {
		let data = this.get(key, fallback);
		this.data.delete(key);

		return data;
	}
	remove (key) {
		this.data.delete(key);
	}
	get (key, fallback) {
		let payload = this.data.get(key);

		if (payload === undefined) {
			payload = typeof fallback === 'function' ? fallback() : fallback;
		}

		return payload;
	}
	scoped (prefix) {
		return {
			get: (key, fallback) => this.get(prefix + ':' + key, fallback),
			add: (key, payload) => this.add(prefix + ':' + key, payload),
			use: (key, fallback) => this.use(prefix + ':' + key, fallback),
			remove: (key) => this.remove(prefix + ':' + key),
			when: (key, handler) => this.when(prefix + ':' + key, handler),
		};
	}
	when (key, handler) {
		let val = this.use(key);
		if (val != null) handler(val);
	}
}

;class CookieApi {
	constructor() {}

	set(name, value, seconds) {
		let expires;
		if (seconds === false) expires = ""; // session cookie
		else if (seconds) {
			let d = new Date();
			d.setTime(d.getTime() + (seconds * 1000));
			expires = ";expires="+ d.toUTCString();
		} else expires = ";expires=0";
		document.cookie = name + "=" + value + expires + ";path=/";
	}

	get(name) {
		let b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
		return b ? b.pop() : '';
	}

	getOrSet(name, value, seconds) {
		let val = this.get(name);

		if (!val) {
			val = value();
			this.set(name, val, seconds);
		}

		return val;
	}
}

;class Eventbus {

	constructor(config) {
		this.on_handlers = new Map();
		this.once_handlers = new Map();
		this.bind_context_items = [];
		this.bind_context_start = false;
		this.config = config;
	}

	exec(fn, payload, context) {
		try {
			fn(payload, context);
		} catch (err) {
			App.core.error('bus.exec', err, { payload, context });
		}
	}

	push(scope, event, payload, context) {
		let _context = context ? { scope, event, ...context } : { scope, event };
		let handlers_key = scope ? scope+':'+event : event;

		(this.on_handlers.get('any') ?? []).forEach(fn => this.exec(fn, payload, _context));
		(this.on_handlers.get(scope+':'+'any') ?? []).forEach(fn => this.exec(fn, payload, _context));

		(this.on_handlers.get(handlers_key) ?? []).forEach(fn => this.exec(fn, payload, _context));

		(this.once_handlers.get(handlers_key) ?? []).forEach(fn => this.exec(fn, payload, _context));
		this.once_handlers.delete(handlers_key);

		if (this.config.onAfterPush) setTimeout(() => this.config.onAfterPush(this, scope, event, payload, context), 1);
	}

	emit (event, payload, context) {
		event.split(' ').forEach(i => {
			let [scope, command] = i.split(':');

			if (command == null) {
				command = scope;
				scope = '';
			}

			this.push(scope, command, payload, context);
		});

		return this;
	}

	addListener(type, command, handler) {
		if (command.endsWith(':')) throw new Error('Eventbus::addListener - invalid command');
		if (handler == null) throw new Error('Eventbus::addListener - handler required');
		if (typeof handler !== 'function') throw new Error('Eventbus::addListener - handler should be a function');

		let map = this[type+'_handlers'];
		let handlers = map.get(command) ?? [];

		if (!handlers.some(i => i === handler)) {
			handlers.push(handler);
			map.set(command, handlers);
		}

		if (this.bind_context_start) {
			this.bind_context_items.push({ command, handler });
		} else {
			console.warn('Eventbus::addListener out of SAFE context!!!')
		}
	}

	removeListener(type, command, handler) {
		let map = this[type+'_handlers'];

		if (handler == null) {
			(map.get(command) ?? []).forEach(h => {
				if (h.clear != null) {
					h.clear();
				}
			});
			map.set(command, []);
		} else {
			const current_handlers = map.get(command) ?? [];
			const this_handler = current_handlers.find(i => i === handler);

			if (this_handler) {
				if (this_handler.clear != null) {
					this_handler.clear();
				}

				map.set(command, current_handlers.filter(i => i !== handler));
			}
		}

		if (map.get(command)?.length === 0) map.delete(command);
	}

	once (command, handler) {
		command.split(' ').forEach(i => this.addListener('once', i, handler));
		return this;
	}

	on (command, handler) {
		command.split(' ').forEach(i => this.addListener('on', i, handler));
		return this;
	}

	off (command, handler) {
		command.split(' ').forEach(i => {
			this.removeListener('on', i, handler);
			this.removeListener('once', i, handler);
		});
		return this;
	}

	scope (scope) {
		let it = this, scoped = (command) => command.indexOf(' ') === -1 ? scope + ':' + command.trim() : command.split(' ').map(i => scoped(i)).join(' ');

		return {
			on: function (command, handler) {
				it.on(scoped(command), handler);
				return this;
			},
			once: function (command, handler) {
				it.once(scoped(command), handler);
				return this;
			},
			off: function (command, handler) {
				it.off(scoped(command), handler);
				return this;
			},
			emit: function (command, payload, context) {
				it.emit(scoped(command), payload, context);
				return this;
			}
		};
	}

	begin_binding_context () {
		this.bind_context_items = [];
		this.bind_context_start = true;
		return this;
	}
	finish_bounded_context () {
		let it = this, ctx = {
			items: it.bind_context_items,
			off: function () {
				this.items.forEach(i => it.off(i.command, i.handler));
			}
		};

		it.bind_context_start = false;
		it.bind_context_items = [];

		return ctx;
	}
}

;class FirebaseMessage {

	static ScriptFile = '/assets/js/workers/firebase-messaging-sw.js';
	static FirebaseAppFile = 'https://www.gstatic.com/firebasejs/10.0.0/firebase-app.js';
	static FirebaseMessagingFile = 'https://www.gstatic.com/firebasejs/10.0.0/firebase-messaging.js';

	constructor(eventbus, params) {
		this.eventbus = eventbus;
		this.firebaseConfig = params?.firebaseConfig || null;
		this.vapidKey = params?.vapidKey || null;
		this.isActive = false;
		this.provider = null;
		this.loading = false;

		this.stopForegroundSubscription = null;
	}

	async start (config) {
		config ||= {};

		this.firebaseConfig = config.firebaseConfig ?? this.firebaseConfig;
		this.vapidKey = config.vapidKey ?? this.vapidKey;
		this.workerUrl = FirebaseMessage.ScriptFile;

		this.provider = await this.get_provider();
		if (this.provider == null) return;

		const sw = await this.find_service_worker();

		this.stopForegroundSubscription = this.provider.onMessage((payload) => {
			this.eventbus.emit('message', payload);
		});

		this.isActive = true;
		this.eventbus.emit('active', {
			has_service_worker: sw != null,
		});

		navigator.serviceWorker.addEventListener('message', this.on_sw_message.bind(this));
	}

	on_sw_message(event) {
		if (!event.data.isFirebaseMessaging) return;

		if (event.data.messageType === 'notification-click') {
			this.eventbus.emit('notification_click', event.data.notification);
		}
	}

	async get_provider() {
		if (this.provider) return this.provider;
		if (!this.firebaseConfig || !this.vapidKey) return null;

		return FirebaseMessage.load_provider(this.firebaseConfig, this.vapidKey);
	}

	async stop () {
		if (!this.isActive) return;

		if (this.stopForegroundSubscription) this.stopForegroundSubscription();

		this.isActive = false;
		this.eventbus.emit('inactive');
		navigator.serviceWorker.removeEventListener('message', this.on_sw_message.bind(this));

		await this.unsubscribe();
	}

	async find_service_worker () {
		return navigator.serviceWorker.getRegistrations().then(items => items.find(i => {
			return i.active && i.active.scriptURL.includes(FirebaseMessage.ScriptFile);
		}));
	}

	is_registered() {
		return this.find_service_worker().then(sw => sw != null);
	}

	async register_service_worker () {
		return navigator.serviceWorker.register(this.workerUrl);
	}

	async subscribe() {
		if (!this.isActive) return;

		const permission = await Notification.requestPermission();
		if (permission !== 'granted') throw new Error('Notification permission not granted');

		const provider = await this.get_provider();
		if (provider == null) throw new Error('Provider not found');

		const sw = await this.register_service_worker();
		const currentToken = await provider.getToken(sw);
		this.eventbus.emit('subscribe', currentToken);
		return currentToken;
	}

	async unsubscribe() {
		if (!this.isActive) return;

		const sw = await this.find_service_worker();
		if (sw == null) return null;

		const provider = await this.get_provider();
		if (provider == null) return null;

		const currentToken = await provider.getToken(sw);
		this.eventbus.emit('unsubscribe', currentToken);
		await provider.deleteToken();

		return currentToken;
	}

	static async load_provider(firebaseConfig, vapidKey) {
		const { initializeApp } = await import(FirebaseMessage.FirebaseAppFile);
		const { getMessaging, getToken, deleteToken, onMessage } = await import(FirebaseMessage.FirebaseMessagingFile);

		initializeApp(firebaseConfig);

		const messaging = getMessaging();

		return {
			onMessage (payload) {
				return onMessage(messaging, payload);
			},
			getToken(serviceWorker) {
				return getToken(messaging, { vapidKey: vapidKey, serviceWorkerRegistration: serviceWorker });
			},
			deleteToken() {
				deleteToken(messaging);
			}
		};
	}
}

;var App = App || {};

App.helper = {

	call_hook: function (container, name, params) {
		for (let i in container) {
			if (name in container[i]) {
				container[i][name](params);
			}
		}
	},

	json: {
		safeParse: function(json) {
			try {
				return JSON.parse(json);
			} catch (e) {
				App.core.warn('json.safeParse', e);
				return null;
			}
		}
	},

	localStorage: {
		value: function (key, fallback) {
			return {
				get: () => this.get(key, fallback),
				set: (val, ttl_seconds) => this.set(key, val !== fallback ? val : null, ttl_seconds),
				del: () => this.del(key),
			};
		},
		get: function (key, fallback) {
			let val = window.localStorage.getItem(key);

			if (val == null) return fallback;

			if (val.startsWith('v1::')) {
				let enc = JSON.parse(val.substring(4), function reviver(key, value) {
					if (value && value.__type === 'Map') {
						return new Map(value.value);
					}
					if (value && value.__type === 'Set') {
						return new Set(value.value);
					}
					return value;
				});
				let is_expired = enc.e != null && enc.e > 0 && enc.e < Date.now();
				if (is_expired) window.localStorage.removeItem(key);

				return is_expired ? fallback : enc.p;
			}

			return val;
		},
		set: function (key, val, ttl_seconds) {
			if (val == null) return window.localStorage.removeItem(key);

			val = 'v1::' + JSON.stringify({ p: val, e: ttl_seconds > 1 ? Date.now() + ttl_seconds*1000 : 0 }, function replacer(key, value) {
				if (value instanceof Map) {
					return {
						__type: 'Map',
						value: Array.from(value.entries())
					};
				} else if (value instanceof Set) {
					return {
						__type: 'Set',
						value: Array.from(value.values())
					};
				} else {
					return value;
				}
			});

			window.localStorage.setItem(key, val);
		},
		del: function (key) {
			const val = this.get(key);
			window.localStorage.removeItem(key);
			return val;
		}
	},

	nextTick: function (func, ttl) {
		return setTimeout(func, ttl || 1);
	},

	/**
	 * @return {function(...[*]): void}
	 */
	debounce: function (func, timeout, burst_mode = false) {
		let timer;
		let last_call_at = 0;

		timeout = timeout || 50;

		let fn = (...args) => {
			clearTimeout(timer);
			if (burst_mode === true && last_call_at === 0) last_call_at = Date.now();

			if (burst_mode === true && Date.now() - last_call_at > timeout) {
				last_call_at = 0;
				func.apply(this, args);
				return;
			}

			timer = setTimeout(() => {
				last_call_at = 0;
				func.apply(this, args);
			}, timeout);
		};

		fn.reset = fn.clear = () => clearTimeout(timer);
		fn.run = (...args) => {
			func.apply(this, args);
		}

		return fn;
	},

	throttle: function (func, timeout) {
		return App.helper.debounce(func, timeout || 99, true);
	},

	// звичайний throttle, з leading + trailing
	just_throttle: function (callback, timeout = 100) {
		let shouldWait = false;
		let waitingArgs = null;
		let timer = null;

		const timeoutFunction = () => {
			if (waitingArgs === null) {
				shouldWait = false;
				timer = null;
			} else {
				callback(...waitingArgs);
				waitingArgs = null;
				timer = setTimeout(timeoutFunction, timeout);
			}
		};

		const fn = (...args) => {
			if (shouldWait) {
				waitingArgs = args;
				return;
			}

			callback(...args);
			shouldWait = true;
			timer = setTimeout(timeoutFunction, timeout);
		};

		// --------------------------
		// API сумісне з debounce()
		// --------------------------

		fn.reset = fn.clear = () => {
			if (timer) clearTimeout(timer);
			timer = null;
			shouldWait = false;
			waitingArgs = null;
		};

		fn.run = (...args) => {
			callback(...args);
		};

		return fn;
	},

	raf_throttle: function (fn) {
		let ticking = false;
		let lastArgs, lastThis;

		const wrapped = function (...args) {
			lastArgs = args;
			lastThis = this;

			if (!ticking) {
				ticking = true;

				requestAnimationFrame(() => {
					ticking = false;
					fn.apply(lastThis, lastArgs);
				});
			}
		};

		wrapped.cancel = () => {
			ticking = false;
		};

		wrapped.run = (...args) => {
			fn.apply(this, args);
		};

		return wrapped;
	},

	reload_html_fragment: function (url, container, selector, next) {
		$.ajax({
			url: url,
			success: function (html) {
				let fragment = $('<div>').html(html);
				let selectors = Array.isArray(selector) ? selector : [selector];

				selectors.forEach(function(s) {
					if (container.find(s + ' .menu_open').length > 0) App.menu.hide_all();
					container.find(s).html(fragment.find(s).html());
				});

				if (next) next();
			},
		});
	},

	xhr: {
		set_headers: function(xhr) {
			xhr.setRequestHeader('x-load-type', 'ajax');
			if (App.hybrid_app) {
				xhr.setRequestHeader("X-app", '2.0');
				if (App.hybrid_app.token) xhr.setRequestHeader("X-app-token", App.hybrid_app.token);
			}
		},
	},

	object: {
		clone: function(obj, obj_override) { // suite only for simple objects (not stings or arrays)
			obj_override ||= {};
			return Object.assign(Object.assign({}, obj), obj_override);
		},

		append: function(target, obj) {
			Object.assign(target, obj);
		},

		is_plain: function (v) {
			return v !== null &&
			typeof v === "object" &&
			Object.getPrototypeOf(v) === Object.prototype;
		},

		deep_append: function(target, obj) {
			for (const key of Object.keys(obj)) {
				const s = obj[key];

				if (!Object.prototype.hasOwnProperty.call(target, key)) {
					// don't need real clone while using only for configs rewrite
					target[key] = s; //App.helper.object.clone(s);
					continue;
				}
				const t = target[key];

				if (App.helper.object.is_plain(t) && App.helper.object.is_plain(s)) {
					App.helper.object.deep_append(t, s);
				} else if (Array.isArray(s)) {
					target[key] = s; // App.helper.object.clone(s);
				} else {
					target[key] = s; //App.helper.object.clone(s);
				}
			}
			return target;
		},

		push_deep: function(obj) {
			if (arguments.length == 2) {
				if (!obj.includes(arguments[1])) obj.push(arguments[1]);
			} else {
				let obj_deep = obj;
				for (let i = 1; i < arguments.length - 1; i++) {
					if (i === arguments.length - 2) {
						obj_deep[arguments[i]] ||= [];
						if (!obj_deep[arguments[i]].includes(arguments[i + 1])) obj_deep[arguments[i]].push(arguments[i + 1]);
					} else  {
						obj_deep[arguments[i]] ||= {};
					}
					obj_deep = obj_deep[arguments[i]];
				}
			}
		},
		push_deep_key: function(obj) {
			if (arguments.length == 2) {
				obj[arguments[1]] = 1;
			} else {
				let obj_deep = obj;
				for (let i = 1; i < arguments.length - 1; i++) {
					obj_deep[arguments[i]] ||= {};
					if (i === arguments.length - 2) {
						obj_deep[arguments[i]][arguments[i + 1]] = 1;
					}
					obj_deep = obj_deep[arguments[i]];
				}
			}
		},
		filter_nulls: function(obj) {
			let result = {};
			for (let i in obj) {
				if (obj[i] != null) result[i] = obj[i];
			}
			return result;
		},
		toFormUrlEncoded(obj, prefix) {
			const pairs = [];

			for (const [key, value] of Object.entries(obj)) {
				const fullKey = prefix
					? `${prefix}[${encodeURIComponent(key)}]`
					: encodeURIComponent(key);

				if (value === null || value === undefined) continue;

				if (typeof value === 'object' && !Array.isArray(value)) {
					pairs.push(App.helper.object.toFormUrlEncoded(value, fullKey));
				} else if (Array.isArray(value)) {
					for (const v of value) {
						if (typeof v === 'object')
							pairs.push(App.helper.object.toFormUrlEncoded(v, `${fullKey}[]`));
						else
							pairs.push(`${fullKey}[]=${encodeURIComponent(v)}`);
					}
				} else {
					pairs.push(`${fullKey}=${encodeURIComponent(value)}`);
				}
			}

			return pairs.join('&');
		},
		delete_deep: function(obj) {
			// let obj_deep = obj;
			// for (let i = 1; i < arguments.length; i++) {
			// 	if (i === arguments.length - 1) {
			// 		delete(obj_deep[arguments[i]]);
			// 	}
			// 	obj_deep = obj_deep[arguments[i]];
			// }
		},
		shallowEqual(a, b) {
			if (a === b) return true;
			if (!a || !b) return false;
			if (typeof a !== 'object' || typeof b !== 'object') return false;
			const aKeys = Object.keys(a);
			const bKeys = Object.keys(b);
			if (aKeys.length !== bKeys.length) return false;
			for (const key of aKeys) if (a[key] !== b[key]) return false;
			for (const key of bKeys) if (a[key] !== b[key]) return false;
			return true;
		},
		readByPath: function(obj, path, fallback = undefined) {
			const parts = String(path)
					.replace(/\[(\w+)\]/g, '.$1')   // some[1] → some.1
					.replace(/^\./, '')
					.split('.');
			let current = obj;
			for (const part of parts) {
				if (current == null || typeof current !== 'object') return fallback;
				current = current[part];
			}
			return current === undefined || current === null ? fallback : current;
		},
		setByPath(object, path, value) {
			const keys = String(path)
				.replace(/\[(\w+)\]/g, '.$1')   // some[1] → some.1
				.replace(/^\./, '')
				.split('.');
			let current = object;

			for (let i = 0; i < keys.length - 1; i++) {
				const key = keys[i];

				if (current[key] == null || typeof current[key] !== 'object') {
					current[key] = Number.isInteger(+keys[i + 1]) ? [] : {};
				}

				current = current[key];
			}

			current[keys[keys.length - 1]] = value;
		},
		sanitize: function(obj) {
			if (!App.helper.object.is_plain(obj)) {
				return {};
			}
			return obj;
		}
	},

	sort: {
		compare: function(a, b) {
			a = +a;
			b = +b;
			if (a === b) return 0;
			return a > b ? 1 : -1;
		},

		compare_strings: function(str1, str2) {
			let size1 = str1.charCodeAt(0);
			let size2 = str2.charCodeAt(0);
			return ((size1 === size2) ? 0 : ((size1 > size2) ? 1 : -1));
		},

		compare_strings_natural: function(f_string1, f_string2, f_version) {

			return f_string1.localeCompare(f_string2, undefined, {
				numeric: true,
				sensitivity: 'base'
			});

			if (f_version == undefined) {
				f_version = false;
			}
			let array1 = App.helper.sort.compare_strings_natural_split(f_string1);
			let array2 = App.helper.sort.compare_strings_natural_split(f_string2);

			let len = array1.length;
			let text = true;

			let result = -1;
			let r = 0;

			if (len > array2.length) {
				len = array2.length;
				result = 1;
			}

			for (i = 0; i < len; i++) {
				if (isNaN(array1[i])) {
					if (isNaN(array2[i])) {
						text = true;

						if ((r = App.helper.sort.compare_strings(array1[i], array2[i])) != 0) {
							return r;
						}
					} else if (text) {
						return 1;
					} else {
						return -1;
					}
				} else if (isNaN(array2[i])) {
					if (text) {
						return -1;
					} else {
						return 1;
					}
				} else {
					if (text || f_version) {
						if ((r = (array1[i] - array2[i])) != 0) {
							return r;
						}
					} else {
						if ((r = App.helper.sort.compare_strings(array1[i].toString(), array2[i].toString())) != 0) {
							return r;
						}
					}

					text = false;
				}
			}

			return result;
		},

		compare_strings_natural_split: function (f_string) {
			let result = [];
			let buffer = '';
			let chr = '';
			let text = true;

			for (let i = 0; i < f_string.length; i++) {
				chr = f_string.substring(i, i + 1);

				if (chr.match(/[0-9]/)) {
					if (text) {
						if (buffer.length > 0) {
							result[result.length] = buffer;
							buffer = '';
						}

						text = false;
					}
					buffer += chr;
				} else if ((text === false) && (chr === '.') && (i < (f_string.length - 1)) && (f_string.substring(i + 1, i + 2).match(/[0-9]/))) {
					result[result.length] = buffer;
					buffer = '';
				} else {
					if (text === false) {
						if (buffer.length > 0) {
							result[result.length] = parseInt(buffer);
							buffer = '';
						}
						text = true;
					}
					buffer += chr;
				}
			}

			if (buffer.length > 0) {
				if (text) {
					result[result.length] = buffer;
				} else {
					result[result.length] = parseInt(buffer);
				}
			}

			return result;
		},

	},

	stage: {

		data: null,
		init: function() {
			if (this.data == null)
			{
				this.data = {};
				let workflows_order = {}, i = 0;
				for (let id_group in App.tags_group) {
					if (App.tags_group[id_group].stage) {
						workflows_order[id_group] = i++;
					}
				}
				for (let id_tag in App.tags) {
					if (App.tags[id_tag].id_group in workflows_order) {
						this.data[id_tag] = 1000*workflows_order[App.tags[id_tag].id_group] + App.tags[id_tag].order;
					}
				}
			}
		},
		order: function(id_stage) {
			this.init();
			return id_stage ? this.data[id_stage] : 999999;
		},
		reset: function() {
			this.data = null;
		}
	},

	html: {
		/**
		 * @param s
		 * @param {Array<string>|undefined} only_tags
		 * @param escape_quotes
		 * @param encode_ampersands
		 */
		encode: function (s, {only_tags = undefined, escape_quotes = true, encode_ampersands = false} = {}) {
			if (only_tags) {
				only_tags.forEach(tag => {
					s = s.replace(new RegExp('<' + tag + '>', 'g'), '&lt;' + tag + '&gt;');
					s = s.replace(new RegExp('</' + tag + '>', 'g'), '&lt;/' + tag + '&gt;');
				})
				if (encode_ampersands) {
					s = s.replace(/&/g, '&amp;');
				}
				return escape_quotes ? s.replace(/"/g, '&quot;') : s;
			}
			s = (s || '').toString();
			if (encode_ampersands) {
				s = s.replace(/&/g, '&amp;');
			}
			return s.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		}
	},

	dom: {
		parse: function(html, children_callback) {
			let loaded_dom = $('<div></div>').css({display: 'none'}).appendTo('body').html(html);
			loaded_dom.children().each(children_callback);
			loaded_dom.remove();
		},
		mark_text: function(text_node, word, mark) {
			let txt = text_node.nodeValue;

			mark ||= 0;

			const escapedSearch = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			const search_regex = new RegExp(escapedSearch, 'gi');

			if (!search_regex.test(txt)) return;

			txt = txt.replace(search_regex, function (match) {
				return '<mark class="mark'+mark+'">'+App.helper.html.encode(match)+'</mark>';
			});
			$(text_node).replaceWith(txt);
		},
		when_closest: function (el, selector, handler) {
			let target = $(el).closest(selector);
			if (target.length === 0) return false;
			return handler ? (handler(target) ?? true) : true;
		},
		is_hidden(el) {
			const style = window.getComputedStyle(el);0
			return !el ||
				!el.ownerDocument ||
				!el.ownerDocument.documentElement.contains(el) ||
				style.display === 'none' ||
				style.visibility === 'hidden' ||
				style.opacity === '0' ||
				el.offsetParent === null;
		},
		depth(element) {
			let d = 0;
			let current = element;
			while (current && current.parentElement) {
				d++;
				current = current.parentElement;
			}
			return d;
		},
		merge_attributes(target, source, {exclude = []} = {}) {
			const source_attrs = source instanceof HTMLElement ? Array.from(source.attributes) : source;
			source_attrs.forEach(attr => {
				 if (exclude.includes(attr.name)) return;
				if (attr.name === 'class') {
					const existing = target.getAttribute('class') || '';
					target.setAttribute('class', `${existing} ${attr.value}`.trim());
				} else if (!target.hasAttribute(attr.name)) {
					target.setAttribute(attr.name, attr.value);
				}
			});
		},
		builder() {
			return new Proxy({}, {
				get(target, tag) {
					return (attrs = {}, ...children) => {
						const node = document.createElement(tag);
						Object.entries(attrs).forEach(([key, value]) => {
							if (value == null) return;
							node.setAttribute(key, value);
						});
						children.forEach(child => {
							if (child instanceof Node || child instanceof HTMLElement) {
								node.appendChild(child);
							} else if (child != null) {
								node.append(...Node.from(child));
							}
						});
						return node;
					}
				}
			});
		},
		html: function (el, html) {
			const $el = $(el);
			App.components_queue.is_enabled = true;
			$el.html(html);
			App.components_queue.is_enabled = false;
			App.components_queue.render();
		},
	},

	number: {
		limit: function(i) {
			return i > 99 ? '99+' : i;
		},
		hasDecimal(num) {
			return num % 1 !== 0;
		},
		normalize_unsigned_decimal_input(value) {
			let normalized = String(value ?? '')
				.replace(/[^\d.,]/g, '')
				.replace(/,/g, '.')
				.replace(/\.{2,}/g, '.');
			const dot_index = normalized.indexOf('.');
			if (dot_index !== -1) {
				normalized = normalized.slice(0, dot_index + 1) + normalized.slice(dot_index + 1).replace(/\./g, '');
			}
			return normalized;
		},
		to_css_unit(num, unit = null) {
			if (typeof num !== 'number' && typeof num !== 'string') {
				return null;
			}
			const already_has_unit = typeof num === 'string' && num.match(/^[\d.\-+]+[a-z%]+$/i);
			if (already_has_unit) return num;
			unit = unit || 'px';
			if (!num) return 0;
			return App.helper.number.hasDecimal(num) ? num + unit : parseInt(num, 10) + unit;
		}
	},

	event: {
		link_click: function(e, filter) {
			return !!$(e.target).parents().addBack().filter(filter || 'a').length;
		}
	},

	clipboard: {
		get_link: function(next) {
			navigator.clipboard.readText().then(data => {
				next(App.helper.is_link(data) ? data.trim() : null);
			}).catch(() => {
				next(null);
			});
		}
	},

	is_link: function (str) {
		if (typeof str !== 'string' || str.trim() === '') return false;

		return /^([a-z]+:)?\/\/[^ ]*$/.test(str.trim()) || /^[^ ]*\.(com|net|ua|ru|eu|de|org|us|info)$/.test(str.trim());
	},

	ip: {
		validate: function (ip) {
			return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\/(\d{1,2}))?$/.test(ip);
		},

		in_range: function (ip, subnet) {
			if (subnet.indexOf('/') === -1) subnet += '/32';
			let mask, base_ip, long_ip = App.helper.ip.to_longint(ip);

			if ((mask = subnet.match(/^(.*?)\/(\d{1,2})$/)) && ((base_ip = App.helper.ip.to_longint(mask[1])) >= 0)) {
				let freedom = Math.pow(2, 32 - parseInt(mask[2]));
				return (long_ip >= base_ip) && (long_ip <= base_ip + freedom - 1);
			}
			return false;
		},
		to_longint: function (ip) {
			let components;
			if (components = ip.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/)) {
				let iplong = 0;
				let power = 1;
				for (let i = 4; i >= 1; i -= 1) {
					iplong += power * parseInt(components[i]);
					power *= 256;
				}
				return iplong;
			} else return -1;
		}
	},

	endpoint: {
		auth: function() {
			return '/ajax/auth/';
		},
		primary: function() {
			return '/ajax/';
		},
		project: function(id) {
			return '/project/' + id + '/ajax/';
		},
		task: function(id) {
			return '/task/' + id + '/';
		},
		user: function(id) {
			return '/ajax/user/' + id + '/';
		},
		ajax: function(projectID) {
			return projectID ? '/ajax2/project/' + projectID + '/' : '/ajax2' + App.page.url.base;
		},
		view: function() {
			return App.page.url.base;
		}
	},

	parse_endpoint: {
		user: function(url) {
			const match = url.match(/\/ajax\/user\/(\d+)/);
			return match ? parseInt(match[1], 10) : null;
		}
	},

	validate: {
		md5: /^[\da-f]{32}$/,
		email: /^[^@]+@[^@]+\.[a-z]+\s*$/,
		number: /^\d+$/,
		digits6: /^\d{6}$/,
		money_float: /^\d+(\.\d+)?$/,
		time_readable: /^(\d+)(?:[:\-](\d+))?$/,
		time_int: /^\d+$/,
		time_float: /^\d+(\.\d+)?$/,

		url_hash: /^#[a-zA-Z01-9_\-]+$/,
		url: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w.-]*)*\/?$/,

		project_url: /\/project\/(\d+)\/(\?|$)/,
		task_url: /\/task\/(\d+)\/(\?|$)/,
		task_url_any: /\/task\/(\d+)\//,
		task_url_fallback: /\/project\/(\d+)\/(\d+)\/((\d+)\/)?(\?|$)/,
		chat_url: /\/chat\/(user\/)?(\d+)\/(\?|$)/,
		intent_url: /^(tel|skype|sms|mailto|geo|viber|whatsapp)\:/,
		file_download_url: /\/file\/(?:task|comment|)(\d+)\/(download)\/(\?|$)/,
		file_download_url_signed: /\/file\/(?:task|comment|)(\w+)\/(ds)\/\w+/,
		file_download_url_fallback: /\/download\/(\d+)\/(\?|$)/,
		file_view_url: /\/file\/(?:task|comment|)?(\d+)\/view\/(\?|$)/,
		link_view_url: /\/link-view\/\?/,

		short_file_url: /\/d\/(\d+)\/?$/,

		phone: /^[01-9\-+()\[\]\s]+$/,

		match_account_url: function (url, pattern) {
			let self = App.helper.validate;

			let is_our_url = self.is_relative_url(url) || self.is_account_url(url);
			if (!is_our_url) return null;

			let match = url.match(pattern);
			if (!match) return null;

			return match[1];
		},

		is_file_download_url: function (url) {
			let self = App.helper.validate;

			let is_our_url = self.is_relative_url(url) || self.is_account_url(url);
			if (!is_our_url) return null;

			return self.file_download_url.test(url)
				|| self.file_download_url_signed.test(url)
				|| self.file_download_url_fallback.test(url);
		},

		is_relative_url: function (url) {
			return url.startsWith('/') || url.startsWith('#');
		},

		is_account_url: function (url) {
			return url.startsWith(App.config.account_url) || !!App.account.known_domains.find(i => url.startsWith('https://' + i));
		}
	},

	url: {

		project: function (id, page) {
			return '/project/' + id + '/' + (page ? page + '/' : '');
		},
		task: function (id, page) {
			return '/task/' + id + '/' + (page ? page + '/' : '');
		},
		user: function (id) {
			return '/user/' + id + '/';
		},
		chat: function (id) {
			return '/chat/' + id + '/';
		},
		chat_personal: function (id) {
			return '/chat/user/' + id + '/';
		},
		parse_query: function (queryString) {
			let query = {};
			let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
			for (let i = 0; i < pairs.length; i++) {
				let pair = pairs[i].split('=');
				query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
			}
			return query;
		},
		add_query: function (str, query, params) {
			query ||= '';

			if (params != null && params instanceof Object) query += (query ? '&' : '') + $.param(params);
			else if (typeof params === 'string') query += (query ? '&' : '') + params;

			return str + (str.indexOf('?') !== -1 ? '&' : '?') + (query || '');
		},
		ajax: {
			user_group: function (id) {
				return '/ajax/user/g' + id + '/';
			},
		},
		domain(str){
			try {
				const url = new URL(str.includes('://') ? str : 'https://' + str);
				return url.hostname;
			} catch {
				return null;
			}
		},
		/**
		 * @param {String} str
		 * @param {*} fallback
		 * @param {'google'|'duckduckgo'} source
		 * @param {Number} size
		 * @return {string}
		 */
		favicon(str, {fallback = null, source = 'google', size = 32} = {}) {
			const domain = App.helper.url.domain(str);
			if (!domain) return fallback;
			switch (source) {
				case 'google':
					return `https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`;
				case 'duckduckgo':
					return `https://icons.duckduckgo.com/ip3/${domain}.ico`;
			}
		},
		safe_decode(s) {
			try {
				return decodeURIComponent(String(s).replace(/\+/g, ' '));
			} catch {
				return s;
			}
		}
	},

	keyboard: {
		chars1: 'qwertyuiop[]asdfghjkl;\'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:"|ZXCVBNM<>?~@#$^&йцукенгшщзхїфівапролджэячсмитьбюёЙЦУКЕНГШЩЗХФВАПРОЛДЖЭЯЧСМИТЬБЮЁ№',
		chars2: 'йцукенгшщзхъфывапролд$@ячсмитьб/|ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛД^Э/ЯЧСМИТЬБЮ&Ё"№;:?qwertyuiop[}aSdfghjkl;\'zxcvbnm,.`QWERTYUIOP{ADFGHJKL:\'ZXCVBNM<>~#',
		replaces: {},
		init: function() {
			if (!this.replaces.length) {
				for (let i=0; i<App.helper.keyboard.chars1.length; i++) this.replaces[App.helper.keyboard.chars1[i]] = App.helper.keyboard.chars2[i];
				if ($('body').attr('data-lang') == 4) {
					this.replaces['S'] = 'і';
					this.replaces['s'] = 'і';
					this.replaces[']'] = 'ї';
					this.replaces['}'] = 'ї';
				}
			}
		},
		switch: function(str) {
			this.init();
			let str2 = '';
			for (let i=0; i<str.length; i++) {
				if (this.replaces[str[i]]) {
					str2 += this.replaces[str[i]];
				} else {
					str2 += str[i];
				}
			}
			return str2
		}
	},

	translit: {
		map_cyr_to_lat: {
			'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd', 'е': 'e', 'є': 'ye',
			'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i', 'ї': 'yi', 'й': 'y', 'к': 'k', 'л': 'l',
			'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
			'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ь': '',
			'ю': 'yu', 'я': 'ya', 'є': 'ie', 'ы': 'y', 'э': 'e',

			// Uppercase
			'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'H', 'Ґ': 'G', 'Д': 'D', 'Е': 'E', 'Є': 'Ye',
			'Ж': 'Zh', 'З': 'Z', 'И': 'Y', 'І': 'I', 'Ї': 'Yi', 'Й': 'Y', 'К': 'K', 'Л': 'L',
			'М': 'M', 'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
			'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch', 'Ь': '',
			'Ю': 'Yu', 'Я': 'Ya', 'Ы': 'Y', 'Э': 'E'
		},

		map_lat_to_cyr: null,

		init: function() {
			if (!this.map_lat_to_cyr) {
				this.map_lat_to_cyr = {};
				for (let key in this.map_cyr_to_lat) {
					let val = this.map_cyr_to_lat[key];
					if (val && !(val in this.map_lat_to_cyr)) this.map_lat_to_cyr[val] = key;
				}
				// handle digraphs like shch, kh etc.
				this.map_lat_to_cyr = Object.fromEntries(
					Object.entries(this.map_lat_to_cyr).sort((a, b) => b[0].length - a[0].length)
				);
			}
		},

		cyr_to_lat: function(str) {
			return str.replace(/[А-Яа-яҐґЄєІіЇїЁёЪъЫыЭэ]/g, ch => this.map_cyr_to_lat[ch] || ch);
		},

		lat_to_cyr: function(str) {
			this.init();
			let result = '', i = 0;
			while (i < str.length) {
				let matched = false;
				for (let key in this.map_lat_to_cyr) {
					if (str.substr(i, key.length) === key) {
						result += this.map_lat_to_cyr[key];
						i += key.length;
						matched = true;
						break;
					}
				}
				if (!matched) {
					result += str[i];
					i++;
				}
			}
			return result;
		},

		convert: function(str) {
			return [
				str,
				this.cyr_to_lat(str),
				this.lat_to_cyr(str)
			];
		}
	},

	doc: {
		content_height: function () {
			let D = document;
			return Math.max(
				D.body.scrollHeight, D.documentElement.scrollHeight,
				D.body.offsetHeight, D.documentElement.offsetHeight,
				D.body.clientHeight, D.documentElement.clientHeight
			);
		}
	},

	selection: {
		clear: function() {
			if(document.selection && document.selection.empty) {
				document.selection.empty();
			} else if(window.getSelection) {
				let sel = window.getSelection();
				sel.removeAllRanges();
			}
		},
		is_not_empty: function() {
			if(window.getSelection) return !window.getSelection().isCollapsed;
			else if(document.selection) return !document.selection.isCollapsed;
		},
	},

	time: {
		demo_diff: 0,
		now: () => Math.floor(Date.now() / 1000) + App.helper.time.demo_diff,
		account: () => App.helper.time.now() - App.config.date_sync_offset,
		server: () => App.helper.time.account() - App.config.date_timezone_offset,
		today: () => Math.floor(App.helper.date.today().getTime() / 1000),
		today_account: () => App.helper.time.today() - App.config.date_sync_offset,
		time2string: time => `${Math.floor(time)}:${String(Math.round((time % 1) * 60)).padStart(2, '0')}`,
	},

	customDate: { // time in user timezone
		get: function(param) {
			let dt = App.helper.date.today();
			switch (param) {
				case 'tomorrow':
					dt.setDate(dt.getDate() + 1);
					break;
				case 'yesterday':
					dt.setDate(dt.getDate() - 1);
					break;
				case 'month':
					dt.setDate(1);
					break;
				case 'month_next':
					dt.setDate(1);
					dt.setMonth(dt.getMonth() + 1);
					break;
				case 'week':
					dt.setDate(dt.getDate() - (dt.getDay() + 6) % 7);
					break;
				case 'week_next':
					dt.setDate(7 + dt.getDate() - (dt.getDay() + 6) % 7);
					break;
				case 'year_start':
					dt.setDate(1);
					dt.setMonth(0);
					break;
			}
			return Math.floor(dt.getTime() / 1000) - App.config.date_timestamp_offset; // this match server day start timestamps
		}
	},

	date: {
		now: function () {
			let dt = new Date();
			dt.setSeconds(dt.getSeconds() - App.config.date_sync_offset); // Switch to Account time
			return dt;
		},
		today: function () {
			let dt = App.helper.date.now();
			dt.setHours(0);
			dt.setMinutes(0);
			dt.setSeconds(0);
			dt.setMilliseconds(0);
			return dt;
		},

		is_week_end: function (dt) {
			if (!$('#datelen_we, #ed_datelen_we').val()) return false;
			w = dt.getDay();
			if (App.controls.datepicker.config.holidays && (App.format.digits_2(dt.getDate()) + '.' + App.format.digits_2(dt.getMonth() + 1) + '.' + dt.getFullYear() in App.controls.datepicker.config.holidays)) return true;
			if (App.controls.datepicker.config.extraday && (App.format.digits_2(dt.getDate()) + '.' + App.format.digits_2(dt.getMonth() + 1) + '.' + dt.getFullYear() in App.controls.datepicker.config.extraday)) return false;
			return w === 0 || (!App.controls.datepicker.config.saturday_work && w === 6);
		},

		index_start_date: '01.01.2017',
		index_date: null,
		to_index: function (dt) {
			if (!this.index_date) this.index_date = App.helper.date.from_input(this.index_start_date); // 0 dif-date, 0 week-day
			return Math.round((dt.getTime() - this.index_date.getTime()) / 86400000);
		},

		from_input: function (date_st) {
			if (!date_st) {
				date_st = $('#datestart_def').length ? $('#datestart_def').val() : $('#ed_datestart_def').val();
			}
			let dt_a = date_st.split('.');
			return new Date(1 * dt_a[2], 1 * dt_a[1] - 1, 1 * dt_a[0]);
		},

		time_from_input: function (due_time, fallback) {
			due_time = due_time.toLowerCase();
			let arr = due_time.match(/^(\d\d?)\s*(am|pm)?$/i);
			if (arr) return 4* arr[1] + (arr[2] && arr[2] === 'pm' && arr[1] != 12 ? 48 : 0);

			arr = due_time.match(/^(\d\d?):?(\d\d)\s*(am|pm)?$/i);
			if (arr) return 4* arr[1] + Math.ceil(arr[2]/15) + (arr[3] && arr[3] === 'pm' && arr[1] != 12 ? 48 : 0);

			return fallback || 0;
		},

		to_time: function (date) {
			return this.to_format(date, App.config.is_24h ? 'H:i' : 'g:i a')
		},

		to_format: function (date, format) {
			if (!format) format = '';
			if (format === 'ymd') return App.format.digits_2(date.getFullYear() - 2000) + '' + App.format.digits_2(date.getMonth() + 1) + '' + App.format.digits_2(date.getDate());
			if (format === 'H:i') return App.format.digits_2(date.getHours()) + ':' + App.format.digits_2(date.getMinutes());
			if (format === 'g:i') {
				let hour = date.getHours() % 12;
				return ((hour === 0) ? '12' : hour) + ':' + App.format.digits_2(date.getMinutes());
			}
			if (format === 'g:i a') {
				let hour = date.getHours() % 12;
				return ((hour === 0) ? '12' : hour) + ':' + App.format.digits_2(date.getMinutes()) + ' ' + (date.getHours() > 11?'pm':'am');
			}
			if (format === 'g:ia') {
				let hour = date.getHours() % 12;
				return ((hour === 0) ? '12' : hour) + ':' + App.format.digits_2(date.getMinutes()) + '' + (date.getHours() > 11?'pm':'am');
			}

			return App.format.digits_2(date.getDate()) + '.' + App.format.digits_2(date.getMonth() + 1) + '.' + date.getFullYear();
		},

		to_timestamp: function(date, float) {
			if (float) return date.getTime() / 1000;
			return Math.round(date.getTime() / 1000);
		},

		to_input: function (date) {
			return App.format.digits_2(date.getDate()) + '.' + App.format.digits_2(date.getMonth() + 1) + '.' + date.getFullYear();
		},

		index_is_weekend: function (w) {
			if (!$('#datelen_we, #ed_datelen_we').val()) return false;
			let u = App.controls.datepicker.config.user_id;
			if (u) {
				if (!App.controls.datepicker.last_user.id || App.controls.datepicker.last_user.id != u) {
					App.controls.datepicker.config.index_holidays = {};
					App.controls.datepicker.config.index_extraday = {};
					for (let type of App.holidays.holiday_types) {
						for (let i in App.controls.datepicker.config.user_config[type]) App.controls.datepicker.config.index_holidays[App.helper.date.to_index(App.helper.date.from_input(i))] = 1;
					}
					for (let i in App.controls.datepicker.config.user_config[WORKDAY]) App.controls.datepicker.config.index_extraday[App.helper.date.to_index(App.helper.date.from_input(i))] = 1;
				}
				if (w in App.controls.datepicker.config.index_holidays) return true;
				if (w in App.controls.datepicker.config.index_extraday) return false;
			}
			if (App.controls.datepicker.config.holidays) {
				if (!window.holidays_) {
					window.holidays_ = {};
					for (let i in App.controls.datepicker.config.holidays) window.holidays_[App.helper.date.to_index(App.helper.date.from_input(i))] = 1;
				}
				if (w in window.holidays_) return true;
			}
			if (App.controls.datepicker.config.extraday) {
				if (!window.extraday_) {
					window.extraday_ = {};
					for (let i in App.controls.datepicker.config.extraday) window.extraday_[App.helper.date.to_index(App.helper.date.from_input(i))] = 1;
				}
				if (w in window.extraday_) return false;
			}
			w = w % 7;
			return w === 0 || (!App.controls.datepicker.config.saturday_work && w === 6);
		},
		from_timestamp: function (ts) {
			const num = Number(ts);
			if (String(num).length === 10) return new Date(num * 1000); // секунды
			if (String(num).length === 13) return new Date(num);        // миллисекунды
			throw new Error("Wrong timestamp format: " + ts);
		},
		get_week_number: function (d) {
			// Copy date so don't modify original
			d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
			// Set to nearest Thursday: current date + 4 - current day number
			// Make Sunday's day number 7
			d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
			// Get first day of year
			var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
			// Calculate full weeks to nearest Thursday
			var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
			// Return array of year and week number
			return weekNo;
		},
		dateDiffInDays(a, b) {
			const _MS_PER_DAY = 1000 * 60 * 60 * 24;
			// Discard the time and time-zone information.
			const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
			const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

			return Math.round((utc2 - utc1) / _MS_PER_DAY);
		},
	},

	work_days: {
		add: function (dt, dt_i) {
			let dt_a = dt.clone();
			if ($('#datelen_we, #ed_datelen_we').val() && dt_i) {
				let w = App.helper.date.to_index(dt);
				if (dt_i < 0) {
					for (let i = -1; i >= dt_i; i--) if (App.helper.date.index_is_weekend(w + i)) dt_i--;
				} else {
					for (let i = 1; i <= dt_i; i++) if (App.helper.date.index_is_weekend(w + i)) dt_i++;
				}
			}
			if (dt_i) dt_a.setDate(dt_a.getDate() + dt_i);
			return dt_a;
		},
		diff: function (dt_a2, dt_b2, datelen) {
			let dt_i = 0;
			if ($('#datelen_we, #ed_datelen_we').val()) {
				let i_a = App.helper.date.to_index(dt_a2);
				let i_b = App.helper.date.to_index(dt_b2);
				if (datelen) i_b++;
				dt_i = 0;
				if (i_b < i_a) { // Shift backward
					for (let i = i_b; i < i_a; i++) if (!App.helper.date.index_is_weekend(i)) dt_i--;
				} else { // TaskDB length or shift forward
					for (let i = i_a; i < i_b; i++) if (!App.helper.date.index_is_weekend(i)) dt_i++;
					if (datelen && !dt_i) dt_i = 1; // Minimal task length
				}
			} else {
				dt_i = Math.round((dt_b2.getTime() - dt_a2.getTime()) / 86400000);
				if (datelen) dt_i++;
			}
			return dt_i;
		}
	},

	input: {
		auto_grow: function(textarea, min_height) {
			textarea.css({height: min_height || 16});
			textarea.css({height: Math.max(min_height || 0, textarea.get(0).scrollHeight)});
		}
	},

	template: {
		cache: {},
		get: function(template, format) {
			const el = format
				? document.getElementById('tmpl_' + template + '_' + format) || document.getElementById('tmpl_' + format + '_' + template)
				: document.getElementById('tmpl_' + template) || document.getElementById(template);
			return el ? el.innerHTML.trim() : '';
		},
		get_cached: function(template, format) {
			const hash = template + '_' + format;
			if (!!this.cache[hash]) return this.cache[hash];
			return this.cache[hash] = this.get(template, format);
		},
		clear_cache: function() {
			this.cache = {};
		},

		html_replacements: { // for state machine
			'<': '⚍',
			'>': '⚎',
			'&': '⚌',
			'"': '⚋',
			// '\'': '⚊',
		},
		html_encode_param: function(str) {
			if (typeof str == 'undefined') str = '';
			str = str.toString();
			for (let i in this.html_replacements) {
				str = str.replace(i, this.html_replacements[i]);
			}
			return str;
		},
		html_decode_string: function(str) {
			let res = '', char;
			let is_tag = false, is_html_param = false, is_js_string = false;
			res = '';
			for (let i = 0; i < str.length; i++)
			{
				char = str[i];
				switch (char)
				{
					case '<':
						is_tag = true;
						break;
					case '>':
						is_tag = false;
						break;
					case '"':
						if (is_tag) is_html_param = !is_html_param;
						break;
					case '⚍':
						char = is_tag ? '&lt;' : '<';
						break;
					case '⚎':
						char = is_tag ? '&gt;' : '>';
						break;
					case '⚌':
						char = is_tag ? '&amp;' : '&';
						break;
					case '⚋':
						char = is_html_param ? '&quot;' : '"';
						break;
					default:
				}
				res += char;
			}
			return res;
		},
		debug: false,
		fill: function(template, params) {
			const  is_id = template[0] !== '<' && /^[a-zA-Z_][\w-]*$/.test(template);
			template = is_id ? App.helper.template.get(template) : template;
			template = template.trim().replace(/\s+/g, ' ');
			if (!template) return '';

			if (App.helper.template.debug) console.log('before any process: ', template);
			template = App.helper.template.process_loops(template, params);
			if (App.helper.template.debug) console.log('after process_loops: ', template);
			template = App.helper.template.process_conditions(template, params);
			if (App.helper.template.debug) console.log('after process_conditions: ', template);

			// фіксанув, якщо є пробіл - то це json, а не змінна шаблона.
			// але рішення таке собі.. може змінні теж в подвійних скобках мають бути?
			return this.html_decode_string(template.replace(/{([^\s}]+)}/g, function(match, match1) {
				let [param_adv, func, extra1, extra2] = match1.split(':');
				let [param, p1, p2] = param_adv.split('.');
				if (App.helper.template.debug) console.log({
					param_adv, func, extra1, extra2, param, p1, p2
				});

				if (!(param in params)) return '';
				if (p1 && !(p1 in params[param])) return '';
				if (p2 && !(p2 in params[param][p1])) return '';

				let val;
				if (p2) val = params[param][p1][p2];
				else if (p1) val = params[param][p1];
				else val = params[param];
				return App.helper.template.run_modifier(func, val, extra1, extra2);

			}));
		},
		run_modifier: function (func, val, extra1, extra2) {
			switch (func)
			{
				case 'format_date':
				case 'format_date_tz':
					let date_format = DATE_DEFAULT;
					if (extra1 === 'compact') {
						date_format = DATE_MINI;
					} else if (extra1 === 'year') {
						date_format = DATE_YEAR;
					} else {
						const isNumericInt = (val) => {
							if (val === null || val === '' || typeof val === 'boolean') return false;
							const num = Number(val);
							return Number.isFinite(num) && Number.isInteger(num);
						};
						if (isNumericInt(extra1)) {
							date_format = parseInt(extra1, 10);
						}
					}
					val += App.config.date_timestamp_offset; // suppose only server date input
					if (func === 'format_date_tz') val += App.config.date_timezone_offset;
					return App.format.date(new Date(val * 1000), date_format);

				case 'format_diff':
					return App.format.time_diff(val, extra1 === 'detail');

				case 'format_diff_short':
					return App.format.time_diff_short(val);

				case 'format_diff_supershort':
					return App.format.time_diff_supershort(val);

				case 'format_time':
					return App.format.term_time(val);

				case 'format_time2':
					return App.format.time(val);

				case 'wrap':
					return val ? extra1 + App.helper.template.html_encode_param(val) + extra2 : '';
				case 'htmlenc':
					return App.helper.html.encode(val);
				case 'bool':
				case 'boolean':
					return App.helper.parseBoolean(val);
				case 'html': // TODO це raw html, можливо додати strip script
					default:
						return App.helper.template.html_encode_param(val);
				}

		},
		process_loops: function(template, params) {
			return template.replace(/{{ for \((.*?) in (.*?)\) }}(.*?){{ endfor }}/gs, function(match, param_key, param, sub_template)
			{
				if (typeof params[param] != 'object') return '';
				let res = '';
				for (let key in params[param])
				{
					let str = sub_template;
					str = str.replace(new RegExp('({{ if \\(.*?|{{ elseif \\(.*?|{)' + param_key + '(\.[a-z][\w\d_.]*)', 'g'), '$1' + param + '.' + key + '$2');
					res += str;
				}
				return res;
			});
		},
		process_conditions: function(template, params) {
			// console.log('template <<<<<< ', template, params);
			template = template
				.replace(/&amp;&amp;/g, '&&')
				.replace(/{{ (else)?if \((.*?)\) }}/g, function(match, match0, match1) {
					match0 ||= '';
					match1 = match1
						.replace('&lt;', '<').replace('&gt;', '>') // fix if conditions !
						.replace(/([a-z][\w\d_.]*)/g, function(match, match1) {
							let [param, p1, p2] = match1.split('.');
							let val;
							if (p2) val = params[param][p1][p2];
							else if (p1) val = params[param][p1];
							else val = params[param];
							if (val === null) return false;
							if (typeof(val) == 'object' && val instanceof Array) return val.length > 0;
							if (typeof(val) == 'object') return true;
							if (typeof(val) == 'string') return val !== '';
							if (typeof(val) == 'undefined') return false;
							return val;
						});
					match1 = eval(match1);
					return match1 ? '{{ ' + match0 + 'ifYes }}' : '{{ ' + match0 + 'ifNo }}';
				});
			let conditions = [], done = [];
			template = template.replace(/(.*?){{ (ifYes|ifNo|elseifYes|elseifNo|else|endif) }}/gms, function(match, match1, match2) {
				let fl = true;
				conditions.forEach((condition) => {
					if (!condition) fl = false;
				});
				let res = fl ? match1 : '';
				switch (match2) {
					case 'ifYes':
						conditions.push(true);
						done.push(true);
						break;
					case 'ifNo':
						conditions.push(false);
						done.push(false);
						break;
					case 'elseifNo':
						conditions.pop();
						conditions.push(false);
						break;
					case 'else':
					case 'elseifYes':
						conditions.pop();
						conditions.push(!done.pop());
						done.push(true);
						break;
					case 'endif':
						conditions.pop();
						done.pop();
						break;
				}
				return res;
			});
			return template;
		}
	},

	string: {
		is_str: function(val, not_empty) {
			not_empty = not_empty ?? true
			return typeof val === 'string' && (!not_empty || val.trim() !== '');
		},
		truncate: function (text, chars) {
			if (!chars) chars = 20;
			if (text.length <= chars) return text;
			return text.substring(0, chars) + '...';
		},
		to_kebab_case(name) {
			return name.replace(/([A-Z])/g, '-$1').toLowerCase();
		},
		to_snake_case(name) {
			return name.replace(/([A-Z])/g, '_$1').replace(/-+/g, '_').toLowerCase();
		},
		to_ids(str) {
			return str.split(',').map(id => id.trim()).filter(Boolean).map(Number);
		}
	},

	random: {
		int2chars: function() {
			let i = App.helper.date.to_timestamp(new Date()) - 1701295200, j = 0;
			let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
			let str = '';
			while (i > chars.length) {
				j = i % chars.length;
				i = Math.floor(i/chars.length);
				str = chars[j] + str;
			};
			str = chars[i] + str;
			return str;
		},
		string: function(length) {
			let result = '';
			const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			const charactersLength = characters.length;
			for (let i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		},
		clipnum: function() {
			let date = new Date();
			let str = '';

			str += Math.floor(Math.floor(App.helper.time.now()/86400) % 31).toString(32);
			str += (date.getHours()*60*60 + date.getMinutes()*60 + date.getSeconds()).toString(32);
			str += Math.round(Math.random()*1000).toString(32);

			'abcdefghijklmnopqrstuvwxyz'.split('').forEach((char) => {
				str = str.replaceAll(char+char, char.toUpperCase());
			});

			return str;
		}
	},

	context_menu: {
		project: function(id, el) {
			App.controls.project_menu.show(el, App.helper.endpoint.ajax(id), { context_menu: true });
		}
	},

	scroll: {
		waitSmoothScrolling: function(el, callback) {
			let listener = function() {
				if (el.tm) clearTimeout(el.tm);
				el.tm = setTimeout(function() {
					el.removeEventListener('scroll', listener);
					callback();
				}, 75);
			};
			el.addEventListener('scroll', listener);
			listener();
		}
	},

	viewport: {
		height: function() {
			return ( window.visualViewport ? window.visualViewport.height : $(window).height() )
				- ( $('#fakeKeyboard').height() ?? 0 );
		},
		width: function() {
			return window.visualViewport ? window.visualViewport.width : $(window).width();
		},
		keyboard_height: function() {
			let h = App.hybrid_app ? App.hybrid_app.keyboard_height : $(window).height() - App.helper.viewport.height();

			if (h < 100) h = 0;

			return h;
		},
	},

	team: function(id, param = undefined, options = {}) {
		if (!id) return null;
		let obj_exists = App.team[id] || App.team_special[id] || App.team_exposed[id];
		if (!obj_exists && options?.proof && options?.onLoad) {
			App.helper.expose_data.api.getUser(id, options.proof).then(function(res) {
				App.team_exposed[id] = res;
			}).catch(function() {
				App.team_exposed[id] = {name: 'undefined'};
			}).finally(function() {
				options.onLoad();
			})
		}
		const obj = obj_exists || {name: 'undefined'};
		return param ? (obj[param] || '') : obj;
	},

	expose_data: {
		tasks: [],
		timer: null,
		is_paused: false,
		batchSize: 99,
		request: null,
		debug: true,
		run: function() {
			let self = App.helper.expose_data;

			if (self.tasks.length === 0 || self.is_paused) return;

			const endpoint = App.helper.endpoint.primary() + '?' + App.actions.get('expose_data:do');
			const pending = self.tasks.splice(0, self.batchSize || 1);

			const handleResult = (data) => {
				if (data.results?.length !== pending.length) {
					throw new Error(`broken results`);
				}

				data.results.forEach(([error, result], i) => {
					const task = pending[i]
					if (task == null) return

					if (self.debug) console.log(`<<< ${task.method}(` + (task.params ? task.params.map((i) => typeof i).join(', ') : '') + ')', { params: task.params, error, result })

					if (error) {
						const err = new Error(error[2] || 'internal error')

						err.code = error[0] || 0;
						err.name = error[1] || 'error';
						err.payload = error[3];
						err.debug = error[4];

						task.reject(err)
					} else {
						task.resolve(result)
					}
				})
			}
			const handleError = (error) => {
				App.core.error(error);
				pending.forEach((t) => {
					let err = new Error('transport error');
					err.originalError = error;
					t.reject(err)
				});
			}

			self.request = App.core.async_task.ajax({
				id: 'expose_data',
				method: 'POST',
				url: endpoint,
				data: {
					fns: pending.map(i => ([i.method, i.params])),
				},
				contextType: 'json',
				dataType: 'json',
			}).then(function(json) {
				handleResult(json);
			}).catch(function(error) {
				handleError(error);
			}).finally(function() {
				self.request = null;
			});

			self.timer = setTimeout(self.run, 1)
		},
		abort: function() {
			let self = App.helper.expose_data;
			if (self.request) {
				self.request.abort();
				self.request = null;
			}
		},
		call: function(method, ...params) {
			let self = App.helper.expose_data;

			if (self.debug) console.log(`>>> ${method}(` + (params ? params.map((i) => typeof i).join(', ') : '') + ')', params);

			return new Promise((resolve, reject) => {
				self.tasks.push({method, params, resolve, reject});
				clearTimeout(self.timer);
				self.timer = setTimeout(self.run, 10);
			})
		},
		create_api: function() {
			return new Proxy(
				{},
				{
					get(_, prop) {
						const fn = String(prop)
						return function (...args) {
							return App.helper.expose_data.call(fn, ...args);
						}
					},
				},
			);
		}
	},

	array: {
		inter: function (arr1, arr2) {
			return arr1.filter(x => arr2.includes(x));
		},
		diff: function (arr1, arr2) {
			return arr1.filter(x => !arr2.includes(x));
		},
		sym_diff: function (arr1, arr2) {
			return arr1.filter(x => !arr2.includes(x))
				.concat(arr2.filter(x => !arr1.includes(x)));
		},
		toggle: function(arr, item) {
			if (arr.includes(item)) {
				arr = arr.filter(i => i !== item);
			} else {
				arr = [...arr, item];
			}

			return arr;
		},
		has(list, value) {
			return Array.isArray(list) && list.includes(value);
		},
		group_by(arr, key) {
			let grouped = arr.reduce(function(acc, cur) {
				const g = cur[key];
				if (g == null) return acc;

				if (acc[g] == null) acc[g] = [];
				acc[g].push(cur);

				return acc;
			}, {});

			grouped.keys = function () {
				return Object.keys(grouped);
			};

			grouped.toArray = function () {
				return Object.keys(grouped).map(function (g) {
					return grouped[g];
				});
			};

			grouped.toEntries = function () {
				return Object.keys(grouped).map(function (g) {
					return [g, grouped[g]];
				});
			};

			return grouped;
		},
		/**
		 * @param {Array} arr1
		 * @param {Array} arr2
		 * @return {boolean}
		 */
		equal(arr1, arr2) {
			if (arr1.length !== arr2.length) return false;
			arr1.forEach(i => {
				if (!arr2.includes(i)) return false;
			});
			arr2.forEach(i => {
				if (!arr1.includes(i)) return false;
			});
			return true;
		}
	},

	/**
	 * Executes JavaScript code stored in the `data-callback_success` or `data-callback_error` attributes
	 * of an HTML element that matches the given `identity`.
	 *
	 * @param identity
	 * @param status
	 */
	callback_identity: function (identity, status = true) {
		const el = $("[data-callback_identity="+identity+"]");
		console.log(el);
		if (!el.length) {
			return;
		}

		if (status) {
			const callbackSuccessCode = el.attr('data-callback_success');
			if (callbackSuccessCode) {
				(function () {
					eval(callbackSuccessCode);
				}).call(el);
			}
		} else {
			const callbackErrorCode = el.attr('data-callback_error');
			if (callbackErrorCode) {
				(function () {
					eval(callbackErrorCode);
				}).call(el);
			}
		}
	},

	/**
	 * Scrolls a container **horizontally** to center an active element inside it.
	 *
	 * @param containerSelector - scrollable container.
	 * @param activeSelector - inside the container.
	 * @param [duration=300] - ms
	 */
	scroll_to_active_tab: function (containerSelector, activeSelector, duration = 300) {
		let container = $(containerSelector);
		let activeElement = container.find(activeSelector);

		if (activeElement.length) {
			let offsetLeft = activeElement.position().left;
			let containerWidth = container.width();
			let activeWidth = activeElement.outerWidth();

			container.animate({ scrollLeft: offsetLeft - (containerWidth / 2) + (activeWidth / 2) }, duration);
		}
	},

	memoize(fn, ttl) {
		const cache = new Map(); // TODO: clear

		const _fn = function (...args) {
			const key = args.length ? JSON.stringify(args) : 'no-args';

			const val = cache.get(key);

			if (val && val.expire > 0 && val.expire > Date.now()) {
				return val.result;
			} else {
				const result = fn.apply(this, args);

				cache.set(key, {
					result,
					expire: ttl ? Date.now() + ttl : 0
				});

				return result;
			}
		};

		_fn.clear = () => cache.clear();

		return _fn;
	},

	cron: {
		tasks: new Map(),
		interval: null,
		last_run_at: null,
		start: function () {
			clearInterval(this.interval);
			this.interval = setInterval(() => this.run(), 1000);
		},
		stop: function () {
			clearInterval(this.interval);
		},
		run: function () {
			if (this.tasks.size === 0) return;

			let dt = new Date(), now = Date.now(), args = [dt.getMinutes(), dt.getHours()];

			this.last_run_at = dt;

			for (let t of this.tasks.values()) {
				if (t.paused) continue;
				if (now - t.last_call_at >= t.interval) {
					t.last_call_at = now;
					t.handler(...args);
				}
			}
		},
		add: function (task_id, handler, interval_seconds, run_now) {
			const interval = Math.max(Math.round(interval_seconds || 60), 1) * 1000;
			const call_point = Math.floor(Date.now()/interval)*interval; // attach to same time grid

			this.tasks.delete(task_id);
			this.tasks.set(task_id, {
				handler: handler,
				interval: interval,
				last_call_at: call_point,
			});

			if (run_now === true) handler();
		},
		add_if_not_exists: function (task_id, handler, interval_seconds, run_now) {
			if (App.helper.cron.has(task_id)) {
				if (run_now === true) handler();
				return;
			}

			App.helper.cron.add(task_id, handler, interval_seconds, run_now);
		},
		has: function (task_id) {
			return this.tasks.has(task_id);
		},
		remove: function (task_id) {
			this.tasks.delete(task_id);
		},
		clear: function () {
			this.tasks.clear();
		},
		pause: function (task_id) {
			let t = this.tasks.get(task_id);
			if (t) t.paused = true;
		},
		resume: function (task_id) {
			let t = this.tasks.get(task_id);
			if (t) t.paused = false;
		},
		create: function (task_id, interval_seconds) {
			return {
				add: function (handler) {
					App.helper.cron.add(task_id, handler, interval_seconds);
				},
				remove: function () { App.helper.cron.remove(task_id); },
				pause: function () { App.helper.cron.pause(task_id); },
				resume: function () { App.helper.cron.resume(task_id); },
			};
		}
	},

	dates_into_ranges: function (dates) {
		dates.sort((a, b) => a - b);
		const ranges = [];
		let startDate = dates[0];
		let endDate = dates[0];

		for (let i = 1; i < dates.length; i++) {
			if ((dates[i] - dates[i - 1]) === 24 * 60 * 60 * 1000) {
				endDate = dates[i];
			} else {
				ranges.push({ start: startDate, end: endDate });
				startDate = dates[i];
				endDate = dates[i];
			}
		}

		ranges.push({ start: startDate, end: endDate });

		return ranges.map(range => ({start: range.start, end: range.end})).filter(r => {
			return r.start.getDate() !== r.end.getDate()
				|| r.start.getMonth() !== r.end.getMonth()
				|| r.start.getFullYear() !== r.end.getFullYear();
		});
	},

	regexp: {
		replaceWordBoundaries: function(pattern) {
			// Визначаємо, чи починається шаблон з \b
			const startsWithBoundary = pattern.startsWith("\\b");
			const endsWithBoundary = pattern.endsWith("\\b");

			// Прибираємо \b по краях, залишаємо всередині
			let core = pattern;
			if (startsWithBoundary) core = core.slice(2);
			if (endsWithBoundary) core = core.slice(0, -2);

			// Додаємо сурогатні границі слова
			if (startsWithBoundary) core = '(^|[^\\p{L}])' + core;
			if (endsWithBoundary) core = core + '([^\\p{L}]|$)';

			return core;
		}
	},

	format_rate_grid_html: function (value, el) {
		if (value === '' || value == null) return '';
		let v = parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
		if (Number.isNaN(v)) return '';
		const rounded_value = Math.round(v);

		if (rounded_value === v) {
			const has_fraction = function(value) {
				let number = Number(value);
				return Number.isFinite(number) && Math.abs(number - Math.round(number)) > 0.000001;
			};
			let force_unit = false;
			let current_cell = el.closest('td[data-name]');
			if (!current_cell) return rounded_value;

			let column_name = current_cell.getAttribute('data-name');
			let cells = current_cell.closest('.dataTable').querySelectorAll(`td[data-name="${column_name}"] ws-editable`);

			for (let i = 0; i < cells.length; i++) {
				if (cells[i] === el) continue;
				let cell_value = cells[i].getAttribute('value');
				if (!cell_value) continue;
				if (has_fraction(String(cell_value).replace(/\s/g, '').replace(',', '.'))) {
					force_unit = true;
					break;
				}
			}
			if (!force_unit) return rounded_value;
			return rounded_value + '<span class="unit">.00</span>';
		}
		let s = v.toFixed(2);
		let parts = s.split('.');
		return parts[0] + '<span class="unit">.' + parts[1] + '</span>';
	},
	eval_safe_context(expression, ...contexts) {
		const _compileExpression = function (expression, arity) {
			const params = [];
			let body = `return (${expression});`;
			for (let i = 0; i < arity; i++) {
				params.push(`$ctx${i}`);
				body = `with ($ctx${i}) { ${body} }`;
			}
			return new Function(...params, body);
		}
		const last = contexts[contexts.length - 1];
		const cache = (last instanceof Map) ? contexts.pop() : null;
		const arity = contexts.length;
		const cacheKey = cache ? `${arity}\x00${expression}` : null;

		try {
			let fn = cacheKey ? cache.get(cacheKey) : null;
			if (!fn) {
				fn = _compileExpression(expression, arity);
				if (cacheKey) cache.set(cacheKey, fn);
			}
			return fn(...contexts);
		} catch (error) {
			console.error('Error evaluating expression:', expression, error);
			return undefined;
		}
	},
	eval_return: function (expression) {
		return this.eval_string('return ' + expression + ';');
	},
	eval_string: function (code) {
		App.core.log('eval_string');
		let fn = new Function(code), result;

		try {
			result = fn();
		} catch (e) {
			console.error(e);
		}

		return result;
	},
	eval_callback: function (callback, params, ctx) {
		params||=[];
		let fn = typeof callback === 'function' ? callback : new Function(callback);
		fn.call(ctx, ...params);
	},

	promise: {
		nextTick: () => new Promise(res => App.helper.nextTick(res)),
		readBlobAsText: (blob) => new Promise((res, rej) => {
			App.helper.read_blob_as_text(blob, function (err, txt) {
				if (err) rej(err); else res(txt);
			});
		}),

		wait_for: function (check_handler, max_time, signal) {
			return new Promise(function (resolve, reject) {
				App.helper.wait_for(function (is_timeout) {
					if (signal && signal.aborted) {
						return reject(new Error('Wait For Aborted'));
					}
					if (!is_timeout && check_handler() === false) return false;
					resolve(is_timeout);
				}, max_time);
			});
		},

		with_timeout: function (promise, timeout) {
			let timer;
			return Promise.race([
				promise,
				new Promise((res, rej) => timer = setTimeout(() => rej(new Error('timeout')), timeout))
			]).finally(() => clearTimeout(timer));
		},

		// не знадобилось .. але поки залишу
		imgToBlob: (img) => new Promise((resolve, reject) => {

			const canvas = document.createElement('canvas');
			// here we can scale/min/max
			canvas.width = img.naturalWidth;
			canvas.height = img.naturalHeight;
			const ctx = canvas.getContext('2d'); // TODO as params { alpha: false }

			ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

			canvas.toBlob(blob => {
				if (blob) resolve(blob);
				else reject(new Error('Failed to create blob'));
			}, 'image/png'); // TODO визначати тип?
		}),
	},

	is_plain_object: function (any) {
		return Object.prototype.toString.call(any) === '[object Object]';
	},
	is_empty_plain_object: function (any) {
		return App.helper.is_plain_object(any) && Object.keys(any).length === 0;
	},

	mobile: {
		stopPropagation: function (event) {
			if (!App.device.is_mobile()) return;
			event.stopPropagation();
		},
	},

	clamp: (v, min = 0) => (v < min ? min : v),
	parseTimeToMinutes: (value) => {
		if (value == null) {
			return 0;
		}
		const s = value.toString();
		if (s.includes(":")) {
			const [h, m] = s.split(":").map(n => parseInt(n) || 0);
			return h * 60 + m;
		}
		return parseInt(s) || 0;
	},
	parseTime: (value) => {
		if (!value) {
			return {
				hours: 0,
				minutes: 0,
			}
		}
		const parts = value.toString().split(":");
		if (parts && parts.length === 2) {
			const hours = parseInt(parts[0], 10) || 0;
			const minutes = parseInt(parts[1], 10) || 0;
			return  {
				hours,
				minutes,
			}
		}
		return {
			hours:  Math.floor(parseInt(value) / 60) || 0,
			minutes: parseInt(value) % 60 || 0,
		}
	},
	minutesToHM: (m) => {
		m = Math.max(0, parseInt(m) || 0);
		const h = Math.floor(m / 60);
		const mm = (m % 60).toString().padStart(2, "0");
		return `${h}:${mm}`;
	},
	minutesToFraction: (m) => {
		// 	 60 -> 1
		const pc = 60 / 100;
		return Math.round(m / pc) / 100;
	},
	parseBoolean: (value) => {
		return !(!value || value=== '' || value === false || value === 'false' || value === 0 || value === '0');
	},

	read_blob_as_text: function (blob, cb) {
		let reader = new FileReader();
		reader.onload = function() {
			cb(null, reader.result);
		};
		reader.onerror = function(err) {
			cb(err);
		};
		reader.readAsText(blob);
	},

	wait_for: function (handler, max_time) {
		let timer, expire_at = Date.now() + Math.max(0, Math.min(max_time, 60000))

		const waiter = function () {
			if (expire_at < Date.now()) return handler(true);
			if (handler() !== false) return;
			timer = setTimeout(waiter, 100);
		};

		timer = setTimeout(waiter, 100);

		return () => {
			clearTimeout(timer);
		}
	},

	get_mime_type_by_extension: function (ext) {
		const map = {
			'.jpg': 'image/jpeg',
			'.jpeg': 'image/jpeg',
			'.png': 'image/png',
			'.gif': 'image/gif',
			'.webp': 'image/webp',
		};

		ext = ext.trim().toLowerCase();
		if (!ext.startsWith('.')) ext = '.' + ext;
		return map[ext] || 'application/octet-stream'; // хз
	},

	/**
	 *
	 * @param {FormInstanceOptions} data
	 * @return {FormInstance}
	 */
	useForm(data){ return new FormInstance(data)},

	classes: {
		exposeFacade(proto, layers) {
			for (const { get: getterName, methods, conflict = 'throw' } of layers) {
				for (const [publicName, targetMethod] of Object.entries(methods)) {
					if (publicName in proto) {
						if (conflict === 'skip') continue;
						if (conflict === 'throw') {
							throw new Error(
								`[exposeFacade] conflict: "${publicName}" already exists on prototype ${proto.constructor.name}.`
							);
						}
					}

					Object.defineProperty(proto, publicName, {
						value: function (...args) {
							return this[getterName][targetMethod](...args);
						},
						writable:     true,
						enumerable:   false,
						configurable: true,
					});
				}
			}
		}
	}

};

class BrowserHelper {
	static openPopup (url, title, w, h) {
		let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
		let dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
		let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
		let left = ((width / 2) - (w / 2)) + dualScreenLeft;
		let top = ((height / 2) - (h / 2)) + dualScreenTop;
		let newWindow = window.open(url, title, 'resizable=no,scrollbars=no,status=no,location=no,toolbars=no,width=' + w + ',height=' + h + ',top=' + top + ',left=' + left);

		if (window.focus) {
			newWindow.focus();
		}

		return newWindow;
	}
}

;class HistoryApi {

	constructor() {
		this.pos = 0;
		this.data = [];
		this.just_poped = false;
		// this.mobile = new HistoryApiMobile();
	}

	push (url, title, task) {
		if (!task) App.core.url = url;
		if (this.just_poped) {
			this.just_poped = false;
			return false;
		}
		if (!task && App.task_view.is_shown()) {
			let new_title = document.title;
			this.data[this.pos + 1] = this.data[this.pos];
			history.replaceState({pos: this.pos, task: !!task}, title, url);
			this.pos++;
			history.pushState({pos: this.pos, task: true}, new_title, this.data[this.pos]);
		} else {
			this.pos++;
			this.data[this.pos] = url;
			history.pushState({pos: this.pos, task: !!task}, title, url);
			document.title = title;
		}
	}

	replace (url, title, task) {
		if (!task) App.core.url = url;
		history.replaceState({pos: this.pos, task: !!task}, title, url);
		document.title = title;
		this.data[this.pos] = url;
	}

	restore_page (from_popstate) {
		App.core.url = App.current_page.url;
		if (!from_popstate) {
			this.just_poped = false;
			if (this.data[this.pos - 1] === App.current_page.url) {
				history.go(-1);
				return;
			}
			this.push(App.current_page.url, App.current_page.title, false);
		}
		document.title = App.current_page.title;
	}

	pop (event, is_hashchange) {
		if (this?.mobile?.pop(event, is_hashchange)) return false;
		event = event.originalEvent;
		let state = event.state || {};
		this.pos = state.pos || 0;
		if (App.task_view?.is_shown() && !state.task && !App.task_view.check_url(document.location.href).is_task_path) {
			App.task_view.hide();
		}
		if (App.core.url !== document.location.pathname) {
			this.just_poped = true;
			App.core.goto(document.location.href);
		}
		return false;
	}

	/**
	 * @param {number} steps
	 * @param {string} [fallbackUrl]
	 * @returns {boolean}
	 */
	back(steps = 1, fallbackUrl) {
		steps = Math.max(1, steps|0);

		if (this.pos <= 1) {
			if (fallbackUrl) {
				App.core.goto(fallbackUrl);
			}
			return false;
		}

		if (steps > this.pos) steps = this.pos;

		history.go(-steps);
		return false;
	}

	safe_back(steps = 1, fallbackCallback) {
		steps = Math.max(1, steps|0);

		if (this.pos <= 1) {
			if (fallbackCallback) {
				fallbackCallback.call();
			}
			return false;
		}

		if (steps > this.pos) steps = this.pos;

		history.go(-steps);
		return false;
	}
}

class HistoryApiMobile {
	constructor() {
		this._from_hide = false;
		this._stack = [];
	}

	init () {
		if (!App.device.is_mobile) return;

		App.bus.app.on('window_signal', (e) => {

			const keys = [
				App.window.left_panel.key,
				App.window.right_panel.key,
				App.window.task_create.key,
			];
			if (!keys.includes(e.key)) return;

			if (e.state === App.windows.states.OPENED) {
				App.core.history.mobile.push(e.key);
			}
			if (e.state === App.windows.states.CLOSED) {
				console.log(e);
				if (!e.payload?.from_popstate) {
					App.core.history.mobile.back_on_hide(e.key);
				}
			}
		});
	}

	/**
	 * @param {'menu'|'modal'|'primary_menu'|'right_panel'|'left_panel'|'task_create'} type
	 * @returns {void}
	 */
	push (type) {
		if (!App.device.is_mobile) return;

		// відкладемо pushState, щоб спочатку виконались всі popstate
		App.helper.nextTick(() => {
			// console.log(' > HISTORY', 'PUSH', { type });
			// TODO косяк: губимо поточний url, document.title
			history.pushState({ type }, '');
			this._stack.push(type);
		});
	}

	/**
	 * will be called directly in menu.hide()/modal.hide()
	 * @param {'menu'|'modal'|'primary_menu'|'right_panel'|'left_panel'|'task_create'} called_type
	 * @returns {void}
	 */
	back_on_hide (called_type) {
		if (!App.device.is_mobile()) return;

		const state = history.state || {};
		const type = state.type || null;

		// console.trace(' > HISTORY', 'BACK_ON_HIDE', { type, called_type });

		this._from_hide = true;
		this._stack.pop();
		history.back();
	}

	/**
	 * @param {*} event
	 * @param {boolean} is_hashchange
	 * @returns {boolean}
	 */
	pop (event, is_hashchange) {
		if (!App.device.is_mobile()) return false;
		if (is_hashchange) return false;

		if (this._from_hide) {
			// console.log(' > HISTORY', 'POP', { from_hide: this._from_hide, state: event.originalEvent.state });
			this._from_hide = false;
			return true;
		}

		const type = this._stack.pop();
		if (!type) return false;

		// console.log(' > HISTORY', 'POP', { type, state: event.originalEvent.state });

		const hide_config = { from_popstate: true };

		switch (type) {
			case 'modal':
				// TODO ще є модалки з табами (типу project info, тут Back не працює - не переключає на попередній таб)
				App.modal.hide(hide_config);
				return true;
			case 'menu':
				App.menu.hide(hide_config);
				return true;
			case 'primary_menu':
				$('body').removeClass('mobileMenuOpen mobileMenuHalfOpen').find('.scrollZone').scrollTop(0);
				return true;
			case App.window.left_panel.key:
			case App.window.right_panel.key:
			case App.window.task_create.key:
				App.windows.close(type, hide_config);
				return true;
		}

		return false;
	}
}

;App.core.overrides = (() => {
	const SYM_DELEGATE_STORE = Symbol('delegateStore');
	const SYM_STYLE_HIDDEN   = Symbol('hiddenStyle');

	const eventTargetProto = (window.EventTarget && EventTarget.prototype) || Element.prototype;

	const defineValue  = (target, name, value)  => Object.defineProperty(target, name, { value });
	const defineGetter = (target, name, getter) => Object.defineProperty(target, name, { get: getter });

	/** @lends Element.prototype */
	const elementMethods = {
		addDelegatedEventListener(event, selector, handler, options = false) {
			this[SYM_DELEGATE_STORE] ||= new Map();
			const byEvent    = this[SYM_DELEGATE_STORE].get(event) || new Map();
			const bySelector = byEvent.get(selector) || new Map();

			if (bySelector.has(handler)) return;

			const container = this;
			const wrapped = function (e) {
				const start = (typeof e.composedPath === 'function' && e.composedPath()[0]) || e.target;
				const match = start && start.closest ? start.closest(selector) : null;
				if (!match || !container.contains(match)) return;
				const res = handler.call(match, e, match, container);
				if (res === false) {
					e.preventDefault();
					e.stopPropagation();
				}
			};

			bySelector.set(handler, { wrapped, options });
			byEvent.set(selector, bySelector);
			this[SYM_DELEGATE_STORE].set(event, byEvent);

			this.addEventListener(event, wrapped, options);
			return {
				unbind: () => this.removeDelegatedEventListener(event, selector, handler),
			};
		},

		removeDelegatedEventListener(event, selector, handler) {
			const store = this[SYM_DELEGATE_STORE];
			if (!store) return;

			const byEvent    = store.get(event);
			const bySelector = byEvent?.get(selector);
			const rec        = bySelector?.get(handler);
			if (!rec) return;

			this.removeEventListener(event, rec.wrapped, rec.options);

			bySelector.delete(handler);
			if (!bySelector.size) byEvent.delete(selector);
			if (!byEvent.size)    store.delete(event);
			if (!store.size)      delete this[SYM_DELEGATE_STORE];
		},

		addMultipleEventListener(events, handler, options = false) {
			for (const ev of events) {
				if (ev === 'dblclick' && App.device.is_mobile()) continue;
				this.addEventListener(ev, handler, options);
			}
			return {
				unbind: () => this.removeMultipleEventListener(events, handler, options),
			};
		},

		removeMultipleEventListener(events, handler, options = false) {
			for (const ev of events) this.removeEventListener(ev, handler, options);
		},

		addDelegatedMultipleEventListener(events, selector, handler, options = false) {
			for (const ev of events) this.addDelegatedEventListener(ev, selector, handler, options);
			return {
				unbind: () => this.removeDelegatedMultipleEventListener(events, selector, handler),
			};
		},

		removeDelegatedMultipleEventListener(events, selector, handler) {
			for (const ev of events) this.removeDelegatedEventListener(ev, selector, handler);
		},

		addEventListenerWs(event, handler, options = undefined) {
			this.addEventListener(event, handler, options);
			return {
				unbind: () => this.removeEventListener(event, handler, options),
			};
		},

		css(prop, value) {
			if (typeof prop === 'string' && value === undefined) {
				return getComputedStyle(this).getPropertyValue(prop);
			}
			if (typeof prop === 'string') {
				this.style.setProperty(prop, value);
				return this;
			}
			if (prop && typeof prop === 'object') {
				for (const [key, val] of Object.entries(prop)) {
					this.style.setProperty(key, val);
				}
				return this;
			}
		},

		show(displayValue = null) {
			if (getComputedStyle(this).display !== 'none') return this;
			this.style.display = displayValue || this[SYM_STYLE_HIDDEN] || '';
			return this;
		},

		hide() {
			if (getComputedStyle(this).display === 'none') return this;
			this[SYM_STYLE_HIDDEN] = this.style.display || '';
			this.style.display = 'none';
			return this;
		},

		toggle(show, displayValue = null) {
			const hidden     = this.isHidden();
			const shouldShow = show === undefined ? hidden : show;
			if      (shouldShow && hidden)  this.show(displayValue);
			else if (!shouldShow && !hidden) this.hide();
			return this;
		},

		addClass(...classNames) {
			this.classList.add(...classNames);
			return this;
		},

		removeClass(...classNames) {
			this.classList.remove(...classNames);
			return this;
		},

		toggleClass(className, force) {
			this.classList.toggle(className, force);
			return this;
		},

		isHidden() {
			if (this.tagName === 'INPUT' && this.type === 'hidden') return true;
			const cs = getComputedStyle(this);
			return (
				cs.display === 'none' ||
				cs.visibility === 'hidden' ||
				cs.opacity === '0' ||
				(this.offsetWidth === 0 && this.offsetHeight === 0) ||
				!document.body.contains(this)
			);
		},

		emitEvent(name, detail = {}, options = { bubbles: true, composed: true, cancelable: true }) {
			return this.dispatchEvent(new CustomEvent(name, { detail, ...options }));
		},

		requestHandshake(topic, { acceptFirst = true, details = {} } = {}) {
			let isResolved = false;
			/** @type {any} */
			let providedValue;

			const provide = (value) => {
				if (acceptFirst && isResolved) return false;
				providedValue = value;
				isResolved = true;
				return true;
			};

			const event = new CustomEvent(`handshake:${topic}`, {
				detail: { ...details, provide },
				bubbles: true,
				composed: true,
				cancelable: true,
			});

			this.dispatchEvent(event);

			return isResolved ? providedValue : undefined;
		},

		onHandshake(topic, handler, options = {}) {
			const { unbind } = this.addEventListenerWs(`handshake:${topic}`, (event) => {
				const value = handler(event);
				if (value === undefined) return;
				if (event.detail.provide(value)) {
					event.preventDefault();
					event.stopPropagation();
				}
			}, options);
			return unbind;
		},
	};

	/** @lends Element.prototype */
	const elementGetters = {
		innerHeight() {
			const s = getComputedStyle(this);
			return this.clientHeight
				- parseFloat(s.borderTopWidth)
				- parseFloat(s.borderBottomWidth);
		},
		outerHeight() {
			return this.offsetHeight;
		},
		outerHeightWithMargin() {
			const s = getComputedStyle(this);
			return this.offsetHeight
				+ parseFloat(s.marginTop)
				+ parseFloat(s.marginBottom);
		},
		height() {
			const s = getComputedStyle(this);
			return this.clientHeight
				- parseFloat(s.paddingTop)
				- parseFloat(s.paddingBottom);
		},
		innerWidth() {
			const s = getComputedStyle(this);
			return this.clientWidth - parseFloat(s.paddingLeft) - parseFloat(s.paddingRight);
		}
	};


	/**
	 * @lends HTMLInputElement.prototype
	 * @lends HTMLTextAreaElement.prototype
	 * */
	const inputMethods = {
		focusWithSelection({ preventScroll = false } = {}) {
			this.focus({ preventScroll });
			this.setSelectionRange(0, this.value.length);
		},
	};

	/** @lends Node */
	const nodeStatics = {
		from(html) {
			const template = document.createElement('template');
			template.innerHTML = html.trim();
			const nodes = Array.from(template.content.childNodes);
			template.remove();
			return nodes;
		},
		fromSingle(html) {
			const nodes = nodeStatics.from(html);
			if (nodes.length > 1) {
				throw new Error('Multiple nodes found, expected single. Use Node.from() instead.');
			}
			return nodes[0] || null;
		},
	};

	/** @lends String */
	const stringMethods = {
		ucFirst() {
			const string = this.toString();
			const [first] = string;
			return first.toUpperCase() + string.slice(first.length)
		}
	}

	/**
	 * @lends Window
	 */
	const windowMethods = {
		ajax(data) {
			return App.classes.ajax.getInstance().call(data);
		}
	}

	const installElementMethods = () => {
		for (const [name, fn] of Object.entries(elementMethods)) {
			defineValue(document, name, fn);
			defineValue(eventTargetProto, name, fn);
			defineValue(NodeList.prototype, name, function (...args) {
				this.forEach(el => el[name](...args));
				return this;
			});
		}
	};

	const installElementGetters = () => {
		for (const [name, getter] of Object.entries(elementGetters)) {
			defineGetter(document, name, getter);
			defineGetter(eventTargetProto, name, getter);
		}
	};

	const installInputMethods = () => {
		for (const [name, fn] of Object.entries(inputMethods)) {
			defineValue(HTMLInputElement.prototype, name, fn);
			defineValue(HTMLTextAreaElement.prototype, name, fn);
		}
	};

	const installNodeStatics = () => {
		for (const [name, fn] of Object.entries(nodeStatics)) {
			defineValue(Node, name, fn);
		}
	};

	const installWindowShortcuts = () => {
		for (const [name, fn] of Object.entries(windowMethods)) {
			defineValue(window, name, fn);
		}
	}

	const installStringMethods = () => {
		for (const [name, fn] of Object.entries(stringMethods)) {
			defineValue(String.prototype, name, fn);
		}
	}


	let installed = false;
	return {
		element: { ...elementMethods, ...elementGetters },
		node:    nodeStatics,
		init() {
			if (installed) return;
			installed = true;

			installElementMethods();
			installElementGetters();
			installInputMethods();
			installNodeStatics();
			installWindowShortcuts();
			installStringMethods();
		},
	};
})();

App.core.overrides.init();
/**
 * @typedef {Object} Unbindable
 * @property {() => void} unbind
 */

/**
 * @callback DelegatedHandler
 * @param {Event} event
 * @param {Element} match
 * @param {Element} container
 * @returns {void|false}
 */

/**
 * @typedef {Object} HandshakeOptions
 * @property {boolean} [acceptFirst=true]
 * @property {Object}  [details={}]
 */

/**
 * @callback HandshakeHandler
 * @param {CustomEvent & { detail: { provide: (value: any) => boolean } }} event
 * @returns {any}
 */

/**
 * @name Element.prototype.addDelegatedEventListener
 * @function
 * @param {string} event
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @param {boolean|AddEventListenerOptions} [options=false]
 * @returns {Unbindable|undefined}
 */

/**
 * @name Element.prototype.removeDelegatedEventListener
 * @function
 * @param {string} event
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @returns {void}
 */

/**
 * @name Element.prototype.addMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean|AddEventListenerOptions} [options=false]
 * @returns {Unbindable}
 */

/**
 * @name Element.prototype.removeMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean|EventListenerOptions} [options=false]
 * @returns {void}
 */

/**
 * @name Element.prototype.addDelegatedMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @param {boolean|AddEventListenerOptions} [options=false]
 * @returns {Unbindable}
 */

/**
 * @name Element.prototype.removeDelegatedMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @returns {void}
 */

/**
 * @name Element.prototype.addEventListenerWs
 * @function
 * @param {string} event
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean|AddEventListenerOptions} [options]
 * @returns {Unbindable}
 */

/**
 * @name Element.prototype.css
 * @function
 * @param {string|Object<string,string>} prop
 * @param {string} [value]
 * @returns {string|Element}
 */

/**
 * @name Element.prototype.show
 * @function
 * @param {string|null} [displayValue=null]
 * @returns {Element}
 */

/**
 * @name Element.prototype.hide
 * @function
 * @returns {Element}
 */

/**
 * @name Element.prototype.toggle
 * @function
 * @param {boolean} [show]
 * @param {string|null} [displayValue=null]
 * @returns {Element}
 */

/**
 * @name Element.prototype.addClass
 * @function
 * @param {...string} classNames
 * @returns {Element}
 */

/**
 * @name Element.prototype.removeClass
 * @function
 * @param {...string} classNames
 * @returns {Element}
 */

/**
 * @name Element.prototype.toggleClass
 * @function
 * @param {string} className
 * @param {boolean} [force]
 * @returns {Element}
 */

/**
 * @name Element.prototype.isHidden
 * @function
 * @returns {boolean}
 */

/**
 * @name Element.prototype.emitEvent
 * @function
 * @param {string} name
 * @param {Object} [detail={}]
 * @param {CustomEventInit} [options]
 * @returns {Boolean}
 */

/**
 * @name Element.prototype.requestHandshake
 * @function
 * @param {string} topic
 * @param {HandshakeOptions} [opts]
 * @returns {any|undefined}
 */

/**
 * @name Element.prototype.onHandshake
 * @function
 * @param {string} topic
 * @param {HandshakeHandler} handler
 * @param {AddEventListenerOptions} [options={}]
 * @returns {() => void}
 */

/**
 * @name Element.prototype.innerHeight
 * @type {number}
 * @readonly
 */

/**
 * @name Element.prototype.innerWidth
 * @type {number}
 * @readonly
 */

/**
 * @name Element.prototype.outerHeight
 * @type {number}
 * @readonly
 */

/**
 * @name Element.prototype.outerHeightWithMargin
 * @type {number}
 * @readonly
 */

/**
 * @name Element.prototype.height
 * @type {number}
 * @readonly
 */

/**
 * @name HTMLInputElement.prototype.focusWithSelection
 * @function
 * @param {{preventScroll?: boolean}} [opts={}]
 * @returns {void}
 */
/**
 * @name HTMLTextAreaElement.prototype.focusWithSelection
 * @function
 * @param {{preventScroll?: boolean}} [opts={}]
 * @returns {void}
 */

/**
 * @name Node.from
 * @function
 * @param {string} html
 * @returns {Node[]}
 */

/**
 * @name Node.fromSingle
 * @function
 * @param {string} html
 * @returns {Node|null}
 * @throws {Error}
 */

/**
 * @name window.ajax
 * @function
 * @param {Object} data
 * @returns {*}
 */
/**
 * @name NodeList.prototype.addDelegatedEventListener
 * @function
 * @param {string} event
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @param {boolean|AddEventListenerOptions} [options=false]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.removeDelegatedEventListener
 * @function
 * @param {string} event
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.addMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean|AddEventListenerOptions} [options=false]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.removeMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean|EventListenerOptions} [options=false]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.addDelegatedMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @param {boolean|AddEventListenerOptions} [options=false]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.removeDelegatedMultipleEventListener
 * @function
 * @param {string[]} events
 * @param {string} selector
 * @param {DelegatedHandler} handler
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.addEventListenerWs
 * @function
 * @param {string} event
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean|AddEventListenerOptions} [options]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.css
 * @function
 * @param {string|Object<string,string>} prop
 * @param {string} [value]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.show
 * @function
 * @param {string|null} [displayValue=null]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.hide
 * @function
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.toggle
 * @function
 * @param {boolean} [show]
 * @param {string|null} [displayValue=null]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.addClass
 * @function
 * @param {...string} classNames
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.removeClass
 * @function
 * @param {...string} classNames
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.toggleClass
 * @function
 * @param {string} className
 * @param {boolean} [force]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.isHidden
 * @function
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.emitEvent
 * @function
 * @param {string} name
 * @param {Object} [detail={}]
 * @param {CustomEventInit} [options]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.requestHandshake
 * @function
 * @param {string} topic
 * @param {HandshakeOptions} [opts]
 * @returns {NodeList}
 */

/**
 * @name NodeList.prototype.onHandshake
 * @function
 * @param {string} topic
 * @param {HandshakeHandler} handler
 * @param {AddEventListenerOptions} [options={}]
 * @returns {NodeList}
 */

/**
 * @name String.ucFirst
 * @function
 * @returns {String}
 */
;class PageController {

	constructor(async_module, context) {
		this.last_load_url = '';
		this.async_module = async_module;
		this.context = context.scoped('page_controller');
	}

	provide_params(name, payload) {
		this.context.add(name+':params', payload);
	}

	init_after_load(html, status, xhr) {
		let self = this;

		App.search.clear();
		let headers_params = ['page', 'subpage', 'where', 'version', 'project', 'status', 'archive'];
		for (let i in headers_params) {
			App.current_page[headers_params[i]] = xhr.getResponseHeader("X-Data-" + headers_params[i]);
		}

		if (App.current_page?.page == null) {
			App.core.error('page', 'Failed to load page');
			App.message.show(App.object_state.locale['load_error'], MSG_VARIANT_D);
			App.controls.loader.stop();
			return;
		}

		if (App.current_page.page === '404') {
			App.core.warn('page', 'Requested page not found');
			App.message.show({
				variant: MSG_VARIANT_W,
				title: App.object_state.locale['page_404_title'],
				text: App.object_state.locale['page_404_text'],
			});
			App.controls.loader.stop();
			App.helper.nextTick(() => App.core.goto('/'));
			return;
		}

		App.current_page.project = parseInt(App.current_page.project);

		self.destroy_html();

		App.core.log('page.init', App.current_page.page, App.current_page.where);

		self.destroy_page();

		// Load new scripts
		$('body')
			.attr('data-page', App.current_page.page)
			.attr('data-archive', App.current_page.archive ? 'on' : 'off')
			.attr('data-subpage', App.current_page.subpage)
			.attr('data-project', App.current_page.project);

		App.core.websocket.register_page();
		App.helper.nextTick(function() {
			App.core.obj_window.destroyComponents().contents().remove();
			// App.core.theme.update_links();
			const load_stylesheets = App.core.theme.update_links_withPromise();
			App.core.obj_window.html(html);

			let internal_page_id = Date.now(), page_where = App.current_page.where, params = self.context.use(page_where+':params');

			if (params?.with_message) App.message.show(params.with_message);

			App?.controls?.view_list?.update_visibility();
			App?.controls?.dashboard?.update_visibility();
			if (App.current_page.url !== self.last_load_url) {
				self.last_load_url = App.current_page.url;
				App.core.history.push(App.current_page.url, App.current_page.title);
			} else App.core.history.replace(App.current_page.url, App.current_page.title);

			App.sidebar.update_visibility();
			App.admin_menu.update_visibility();

			let load_scripts = App.current_page.js_load.map(self.async_module.load_script.bind(self.async_module));
			Promise.all([
				load_stylesheets,
				...load_scripts
			]).then(function() {
				App.controls.loader.stop();
				if (App.object_state) App.object_state.available = true;

				const page_state = {
					shutdown_handlers: [],
					last_set_timeout_ts: 0,
					active: true,
				};

				page_state.add_shutdown_handler = function(handler, params) {
					let ts = Date.now(), key = params?.key || null, ttl = params?.ttl || 0;

					if (typeof key === 'string') {
						let old = page_state.shutdown_handlers.find(it => it.key === key);
						if (old) {
							page_state.shutdown_handlers = page_state.shutdown_handlers.filter(it => it.key !== key);
							old.run();
						}
					}

					page_state.shutdown_handlers.push({
						key,
						run: function() {
							handler();
						},
						expire: ttl > 0 ? ts + ttl : 0, // 0 - no expire
					});

					if (ts - page_state.last_set_timeout_ts > 1000) {
						page_state.shutdown_handlers = page_state.shutdown_handlers.filter(it => it.expire === 0 || it.expire > ts-1000);
					}

					page_state.last_set_timeout_ts = ts;
				};

				const page_controller = {
					ready: function() {
						if (App.page == null || App.page.$internal_page_id !== internal_page_id) {
							App.core.warn('Page::ready', 'Possible memory leak detected in ' + page_where);
							return;
						}
						App.core.log('page.ready', page_where);
						App.core.lifecycle.page_ready();
					},
					async: {
						timeout: function (key, handler, ms) {
							if (typeof key === 'function') {
								ms = handler;
								handler = key;
								key = null;
							}

							if (!page_state.active) {
								App.core.warn('Page::timeout', 'Possible memory leak detected in ' + page_where);
								return 0;
							}

							let t = setTimeout(handler, ms || 1);
							page_state.add_shutdown_handler(() => clearTimeout(t), { ttl: ms || 1, key });
							return t;
						},
						debounce: function (handler, timeout, burst_mode = false) {
							let fn = App.helper.debounce(handler, timeout, burst_mode);
							page_state.add_shutdown_handler(fn.clear);
							return fn;
						},
						clear: function(...key) {
							let old = page_state.shutdown_handlers.filter(it => key.includes(it.key));
							if (old.length > 0) {
								old.forEach(it => it.run());
								page_state.shutdown_handlers = page_state.shutdown_handlers.filter(it => !key.includes(it.key));
							}
						}
					},
				};

				App.page = self.async_module.init('page_'+page_where, page_controller);

				App.page.where = function () {
					return App.page.$internal_page_id === internal_page_id ? page_where : '';
				};

				App.page.$internal_page_id = internal_page_id;
				App.page.$page_key = page_where;
				App.page.$page_state = page_state;

				let is_404 = params == null;

				if (params && params.props) {
					Object.keys(params.props).forEach(function(key) {
						let prop_value = params.props[key];
						if (prop_value == null) return;

						if (App.helper.is_plain_object(prop_value)) {
							App.page[key] ||= {};
							Object.keys(prop_value).forEach(function(key2) {
								App.page[key][key2] = prop_value[key2];
							});
						} else {
							App.page[key] = prop_value;
						}
					});
				}

				if (is_404) {
					App.page.onInitPage = () => {};
					App.page.onLoadPage = () => {};
					App.page.onReadyPage = () => {};
					App.page.onLogin = () => {};
					App.page.onLogout = () => {};
				}

				App.core.lifecycle.page_init(params);

				if (!is_404) Object.keys(params).forEach(function(key) {
					let param_value = params[key];
					if (param_value == null) return;

					if (key === 'filter') {
						App.filter.init_page(param_value);
					} else if (key === 'filter_params') {
						App.filter.init_params(param_value);
					} else if (key === 'filter_advanced') {
						App.filter_advanced.set(param_value.have_data, param_value.filter);
					}
				});

				App.page.loaded = true;
				App.core.lifecycle.page_load();
				if (App.current_page.onload) eval(App.current_page.onload);
			}).catch(function(err) {
				App.core.error('page', err);
				App.controls.loader.stop();
				App.message.show(App.object_state.locale['load_error'], MSG_VARIANT_D, {
					action: { left_icon: 'autorenew', onclick: 'App.core.reload(true)', text: '' }
				});
			});
		}, 50);

		if (App.device.is_mobile()) {
			const onboardingButton = $('#primaryMenu .primaryMenu__item-onboarding');
			$('#onboardingMobileHand').remove();
			if (onboardingButton.length) {
				const hand = $('<div id="onboardingMobileHand"></div>');
				$('#taskPanel').after(hand);
				hand.append(onboardingButton.clone());
			}
		}
	}

	destroy_html() {
		$('.menu-alwaysRemain, .menu-dynamic').appendTo('#fixed_container');

		if (App.menu.is_shown()) {
			$('#menuContainer').find('.menu').not(App.menu.obj_window).find('.scrollZone').each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		} else {
			$('#menuContainer').find('.scrollZone').each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			})
		}

		$('#menuContainer').children().removeWithComponents();
		$('#menuContainer').html('');

		let remain_containers = [
			'main',
			'#sidebar__wrapper',
			'#adminMenu__wrapper',
			'#primaryMenu__wrapper',
			'#mobileMenu__overlay',
			'#mobileMenu__wrapper',
			'#taskView__wrapper',
			'#taskView__overlay',
			'#taskPanel',
			'#taskPanel__menu',
			'#taskPanel__counter',
			'#taskCreate__wrapper',
			'#floatingWindow__wrapper',
			'#fileCreate__wrapper',
			'#noteBook__wrapper',
			'#queueView__wrapper',
			'#timerView__wrapper',
			'#sidePanel__wrapper',
			'#rightPanel__wrapper',
			'#rightPanel__overlay',
			'#fc_override',
			'#fc_frame',
			'#fc_push_frame',
			'#fixed_container',
			'#fixed_container_common',
			'#svg_container',
			'#script_container',
			'#modalContainer',
			'#templates_container',
			'#ui-datepicker-div',
			'#message_container',
			'#intercom-frame',
			'.intercom-lightweight-app',
			'#intercom-container',
			'#intercom-css-container',
			'#dashboardView__wrapper'
		];
		App.menu.invalidate_cache_by_trigger('page');
		$('body').children().not(remain_containers.join(',')).removeWithComponents();
		$('#content').destroyComponents().contents().remove();
		$(window).scrollTop(0);
	}

	destroy_page() {
		let self = this;

		if (App.page != null && !App.page.fake && App.page.$page_key != null) {
			window.stop_click = false;
			if (App.page.$page_state) App.page.$page_state.active = false;
			self.context.remove(App.page.$page_key+':params');
			App.core.lifecycle.page_unload();
			App.core.websocket.unregister_page();
			App.page.unloaded = true;
			if (App.page.$page_state && App.page.$page_state.shutdown_handlers) {
				App.core.log('page.shutdown_handlers', App.page.$page_state.shutdown_handlers.length);
				App.page.$page_state.shutdown_handlers.map(it => it.run());
				App.page.$page_state.shutdown_handlers = [];
			}
		}

		App.page = self.create_fake_page();
	}

	create_fake_page() {
		return {
			where: () => '',
			fake: true, url: { base: '/fake/', filter: '/fake/', filter_advanced: '/fake/' }
		};
	}

	onlogout() {
		App.search.clear();
		this.destroy_html();
		this.destroy_page();
		// @see common.js
		App.current_page = {
			class: '',
			where: '',
			page: '',
			subpage: '',
			project: 0,
			onload: '',
			js_load: []
		};
	}

	preload (paths) {
		if (!Array.isArray(paths)) return;

		this.async_module.preload(paths);
	}

	create_costs_controller(page) {
		return {
			feature: (type) => type in page.data.costs,
			get_time: (id) => page.data.costs.time?.[id] || 0,
			get_money: (id) => page.data.costs.money?.[id] || 0,

			update_item: function(id, data, type) {
				switch (type) {
					case 'plus':
						if ('time' in data) {
							page.data.costs['time'][id] ||= 0;
							page.data.costs['time'][id] += data.time;
						}
						if ('money' in data) {
							page.data.costs['money'][id] ||= 0;
							page.data.costs['money'][id] += data.money;
						}
						break;
					case 'minus':
						page.data.costs[id] ||= {};
						if ('time' in data) {
							page.data.costs['time'][id] ||= 0;
							page.data.costs['time'][id] -= data.time;
						}
						if ('money' in data) {
							page.data.costs['money'][id] ||= 0;
							page.data.costs['money'][id] -= data.money;
						}
						break;
				}

				App.core.call_queue.add('process_filter_and_search', page.process_filter_and_search, page, DATA_UPDATE, 0.01);
			},

		};
	}
}

;/**
 * @template T
 * @param {{id: string, fetch: Function, endpoint?: string, batchSize?: number}} config
 * @returns {T & {controller: {set: (option: string, value: any) => void, abort: () => void}}}
 */
function createRpc (config) {
	let self = {
		id: config?.id ?? 'rpc',
		tasks: [],
		timer: null,
		is_paused: false,
		batchSize: config?.batchSize ?? 99,
		request: null,
		endpoint: config?.endpoint ?? '',
		run: function() {

			if (self.tasks.length === 0 || self.is_paused) return;

			const pending = self.tasks.splice(0, self.batchSize || 1);

			const handleResult = (data) => {
				if (data.results?.length !== pending.length) {
					throw new Error(`broken results`);
				}

				data.results.forEach(([error, result], i) => {
					const task = pending[i]
					if (task == null) return

					App.core.log(`${self.id} <<< ${task.method}(` + (task.params ? task.params.map((i) => typeof i).join(', ') : '') + ')', { params: task.params, error, result })

					if (error) {
						const err = new Error(error[2] || 'internal error')

						err.code = error[0] || 0;
						err.name = error[1] || 'error';
						err.payload = error[3];
						err.debug = error[4];

						task.reject(err)
					} else {
						if (result.__str) {
							task.resolve(result.__str)
						} else {
							task.resolve(result)
						}
					}
				})
			}
			const handleError = (error) => {
				App.core.error(error);
				pending.forEach((t) => {
					let err = new Error('transport error');
					err.originalError = error;
					t.reject(err)
				});
			}

			self.request = config.fetch({
				id: self.id + '_ajax',
				method: 'POST',
				url: self.endpoint,
				data: {
					fns: pending.map(i => ([i.method, i.params])),
				},
				contextType: 'json',
				dataType: 'json',
			}).then(function(json) {
				handleResult(json);
			}).catch(function(error) {
				handleError(error);
			}).finally(function() {
				self.request = null;
			});

			self.timer = setTimeout(self.run, 1)
		},
	}

	const controller = {
		set: function (option, value) {
			if (option === 'batchSize') self.batchSize = value;
			else if (option === 'debug') self.debug = value;
			else if (option === 'endpoint') self.endpoint = value;
			else throw new Error(`unknown option ${option}`);
		},
		abort: function() {
			if (self.request) {
				self.request.abort();
				self.request = null;
			}
		},
		call: function(method, ...params) {
			App.core.log(`${self.id} >>> ${method}(` + (params ? params.map((i) => typeof i).join(', ') : '') + ')', params);

			return new Promise((resolve, reject) => {
				self.tasks.push({method, params, resolve, reject});
				clearTimeout(self.timer);
				self.timer = setTimeout(self.run, 10);
			})
		},
	}

	return new Proxy(
		{},
		{
			get(_, prop) {
				const fn = String(prop)
				if (fn === 'controller') return controller;
				if (fn.indexOf('on') === 0) return config[fn]?.apply(self, []);

				return function (...args) {
					return controller.call(fn, ...args);
				}
			},
		},
	);
}

;
;var App = App || {};

(function () {
	let self = App.ui = {
		stopdrag_timer: null,
		add_context: false,
		context_unsub: [],

		/**
		 * @returns {() => void} Unsubscribe Function
		 */
		on: function (container, element, event, handler) {
			$(container).on(event, element, handler);

			const unsub = function () {
				$(container).off(event, element, handler);
			};

			if (self.add_context) self.context_unsub.push(unsub);

			return unsub;
		},

		/**
		 * @returns {() => void} Unsubscribe Function
		 */
		onMouse: function (container, element, { onBefore, context, select, open, click, dblclick }) {

			const errTrace = new Error('onMouse');

			const stop_drag = function () {
				window.stopdrag = true;
				clearTimeout(self.stopdrag_timer);
				self.stopdrag_timer = setTimeout(() => window.stopdrag = false, 250);
			};

			if (App.device.is_mobile()) dblclick = undefined;

			const handler = function (e) {
				let target = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
				if (!target) return;

				const targetEl = $(target).closest(element).get(0);

				let event = {
					originalEvent: e, // щоб запросто робити App.menu.log_mouse_position(e.originalEvent);
					context: App.click_listener.is_context(e),
					select: App.click_listener.is_select(e),
					open: App.click_listener.is_open(e),
					click: App.click_listener.is_click(e),
					dblclick: App.click_listener.is_dblclick(e),
					// longclick: TODO
					target,
					el: targetEl,
					point: {x:0,y:0}, // TODO
					data: {},
					cancel: false,
					stop: false,
					skip_dblclick: false,
					closest: function (sel) {
						let t = $(this.target).closest(sel);
						return t.length ? t.get(0) : null;
					},
					some: function (sel) {
						let t = $(this.el).find(sel);
						return t.length ? t.get(0) : null;
					},
					first: function (sel) {
						let t = $(this.target).closest(sel).add($(this.el).find(sel));
						return t.length ? t.get(0) : null;
					},
					stop_drag,
				};

				let is_fn = h => typeof h === 'function';
				if (is_fn(onBefore)) onBefore(event);

				if (event.cancel) return;
				if (event.stop) return false;

				if (e.type === 'click' && targetEl.contains(target.closest('[onclick]'))) {
					App.core.warn('mouse:click', 'has inline "onclick" handler');
					return;
				}
				if (e.type === 'dblclick' && targetEl.contains(target.closest('[ondblclick]'))) {
					App.core.warn('mouse:dblclick', 'has inline "ondblclick" handler');
					return;
				}
				if (e.type === 'contextmenu' && targetEl.contains(target.closest('[oncontextmenu]'))) {
					App.core.warn('mouse:contextmenu', 'has inline "oncontextmenu" handler');
					return;
				}

				if (event.context && !target.closest('input, textarea, .editable-value.editing')) {
					App.menu.log_mouse_position(e);
					App.click_listener.longclick.stop(e);

					if (Array.isArray(context)) {
						context.some(i => i(event) !== false);
					} else if (is_fn(context)) {
						context(event);
					} else if (context !== false) {
						App.click_listener.process_contextmenu(e, target);
					}

					return false;
				}

				if (event.select && is_fn(select)) {
					App.click_listener.longclick.stop(e);

					select(event);

					return false;
				}

				if (event.open) {
					App.click_listener.longclick.stop(e);

					$(e.el).blur();

					if (Array.isArray(open)) {
						open.some(i => i(event) !== false);
					} else if (is_fn(open)) {
						open(event);
					} else if (open !== false) {
						App.click_listener.process_open(e, target);
					}

					return false;
				}

				if (event.dblclick && is_fn(dblclick)) {
					let click_params = App.click_listener.dblclick.saved_params,
						click_fn = App.click_listener.dblclick.saved_callback;

					event.click = function () {
						if (!is_fn(click_fn)) return false;
						click_fn(click_params);
						return true;
					}

					App.helper.selection.clear();
					App.click_listener.dblclick.stop(false);
					App.click_listener.longclick.stop(e);
					dblclick(event);
					return false;
				}

				let has_dblclick = is_fn(dblclick) && (!event.skip_dblclick && event.click),
					has_click = is_fn(click);

				if (event.click && (has_dblclick || has_click)) {
					if (has_dblclick && has_click) {
						App.click_listener.dblclick.call(function () {
							App.keyboard_selection.select_by_click(target);
							click(event);
						});
						return false;
					}

					if (has_click) {
						App.keyboard_selection.select_by_click(target);
						click(event);
						return false;
					}

					return false;
				}
			};

			let events = '';

			if (select != null || open != null || click != null || context != null) events += ' click';
			if (dblclick != null) events += ' dblclick';
			if (context != null) events += ' contextmenu';
			if (open != null) events += ' auxclick';

			return self.on(container, element, events, handler);
		},

		onGesture: function (container, element, {
			onBefore,
			onPan,
			onZoom,
			onRotate,
			onGestureStart,
			onGestureEnd,
		} = {}) {

			// if (!App.device.is_mobile()) return;

			container = $(container).get(0); // each?

			if (container == null) return;

			const getTouches = e => {
				if (e.touches && e.touches.length) return e.touches;
				if (e.changedTouches && e.changedTouches.length) return e.changedTouches;
				return [];
			};

			const dist = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
			const angle = (a, b) => Math.atan2(b.clientY - a.clientY, b.clientX - a.clientX) * 180 / Math.PI;

			let mode = null;
			let start = {};

			function buildEvent(e, t) {
				let target = e.target;
				let el = $(target).closest(element).get(0);

				let ev = {
					originalEvent: e,
					target,
					el,
					point: { x: t[0]?.clientX ?? 0, y: t[0]?.clientY ?? 0 },
					data: {},
					cancel: false,
					stop: false,

					closest(sel) {
						let q = $(this.target).closest(sel);
						return q.length ? q.get(0) : null;
					},
					some(sel) {
						let q = $(this.el).find(sel);
						return q.length ? q.get(0) : null;
					},
					first(sel) {
						let q = $(this.target).closest(sel).add($(this.el).find(sel));
						return q.length ? q.get(0) : null;
					},
				};

				return ev;
			}

			container.addEventListener("touchstart", function (e) {
				const t = getTouches(e);
				if (!t.length) return;
				if (t.length === 1) return; // для цього все таки є App.swipe

				let ev = buildEvent(e, t);
				if (typeof onBefore === "function") onBefore(ev);
				if (ev.cancel || ev.stop) return;

				if (!ev.el) return; // не на елементі

				if (t.length === 1) {
					mode = "pan";
					start.x = t[0].clientX;
					start.y = t[0].clientY;
					start.panX = start.x;
					start.panY = start.y;
				}

				if (t.length === 2) {
					mode = "pinch";
					start.d = dist(t[0], t[1]);
					start.a = angle(t[0], t[1]);
				}

				if (onGestureStart) onGestureStart({ ...ev, mode });
			}, { passive: false });

			container.addEventListener("touchmove", function (e) {
				const t = getTouches(e);
				if (!t.length || !mode) return;
				e.preventDefault();

				let ev = buildEvent(e, t);
				ev.mode = mode;

				if (mode === "pan" && t.length === 1) {
					ev.panX = t[0].clientX - start.x;
					ev.panY = t[0].clientY - start.y;
					onPan?.(ev);
				}

				if (mode === "pinch" && t.length === 2) {
					let newD = dist(t[0], t[1]);
					let newA = angle(t[0], t[1]);

					ev.scale = newD / start.d;
					ev.rotate = newA - start.a;

					onZoom?.(ev);
					onRotate?.(ev);
				}
			}, { passive: false });

			container.addEventListener("touchend", function (e) {
				if (!mode) return;

				let ev = buildEvent(e, getTouches(e));
				ev.mode = mode;

				onGestureEnd?.(ev);
				mode = null;
			}, { passive: false });

			container.addEventListener("touchcancel", function (e) {
				if (!mode) return;

				let ev = buildEvent(e, getTouches(e));
				ev.mode = mode;

				onGestureEnd?.(ev);
				mode = null;
			}, { passive: false });
		},


		bindContext: function (handler) {
			self.add_context = true;

			handler(self);
			const unsub = self.context_unsub;

			self.context_unsub = [];
			self.add_context = false;

			return {
				forget() {
					unsub.map(h => h());
				}
			};
		},

		handle_thickbox_click: function (target) {
			let el = $(target).closest('.thickbox');

			if (el.length === 0) return false;
			if (el.hasClass('tb_clicked')) return false;
			if (el.hasClass('nomass') && App.mass.is_shown()) return false;

			let t = el.attr('data-modal-title') || el.attr('title') || el.attr('data-title') || el.attr('name') || '';
			let a = el.attr('data-modal-url') || el.attr('data-href') || el.attr('href') || el.attr('alt');
			let w = el.attr('data-modal-width') || 450;
			let param_backup = el.attr('data-modal-backup') || false;
			let param_reload = el.attr('data-modal-reload') || false;
			let param_ico    = el.attr('data-modal-ico') || false;
			let param_params = el.attr('data-modal-params') || false;

			a = a.replace(/%1/g, el.attr('href'));

			let g = el.attr('rel') || el.attr('data-modal-group') || false;

			el.addClass('tb_clicked').eachDelayed(function() {
				$(this).removeClass('tb_clicked', 50);
			});

			App.modal.show({
				url: a,
				width: w,
				title: t,
				group: g,
				backup: param_backup,
				reload: param_reload,
				ico: param_ico,
				params: param_params,
			});

			el.blur();

			return true;
		},

		handle_help_click: function (el) {
			if (!App.device.is_mobile()) return false;

			$('#mobileHintMenu .menu__group .in').html($(el).attr('data-title') ? App.helper.html.encode($(el).attr('data-title')) : $(el).find('font').html());

			if ($(el).parents('.menu').length) {
				App.menu.show({
					anchor: this,
					box: '#mobileHintMenu',
					type: ($(el).hasClass('help_l') ? 'right' : 'left') + ($(el).hasClass('help_t') ? ' bottom' : '') + ' enc',
					backup: true
				});
			} else {
				App.menu.show({
					anchor: el,
					box: '#mobileHintMenu',
					type: ($(el).hasClass('help_l') ? 'right' : 'left') + ($(el).hasClass('help_t') ? ' bottom' : '') + ' enc',
				});
			}

			return true;
		},

		debug_gesture: function (container, selector) {
			console.log('gesture debug inited', { container, selector });
			App.ui.onGesture(container ?? $('body').get(0), selector ?? 'div', {
				onPan(ev) {
					console.log("PAN", ev.panX, ev.panY);
				},
				onZoom(ev) {
					console.log("ZOOM scale:", ev.scale);
				},
				onRotate(ev) {
					console.log("ROTATE deg:", ev.rotate);
				},
				onGestureStart(ev) {
					console.log("START", ev.mode);
				},
				onGestureEnd(ev) {
					console.log("END", ev.mode);
				},
			});
		}
	};
})();

;class WebsocketApi {

	constructor(eventbus, config) {
		this.version = config?.version || 5;
		this.eventbus = eventbus;
		this.config = config || {};
		this.allow_shared_worker = true;
		this.shared_worker_url = '/assets/js/workers/shared_worker.js?v=' + this.version;
		this.worker_url = '/assets/js/workers/worker.js?v=' + this.version;
		this.worker = null;
		this.port = null;
		this.ready = false;
		this.branch = 'ref';
		this.host = '';
		this.callbacks = {};
	}

	is_available() {
		return this.config.isAvailable();
	}

	unregister() {
		// No need to unregister, Shared Worker dies itself
		if (!this.is_available()) return false;
		try {
			if (localStorage.getItem('worker_url')) {
				// if (App.core.websocket.allow_shared_worker && window.SharedWorker) {
				// 	SharedWorker.getRegistrations().then(function (registrations) {
				// 		for (let registration of registrations) registration.unregister().then((is_ok) => {});
				// 	});
				// }
				localStorage.removeItem('worker_url')
			}
		} catch(e) {}
	}

	start(host) {
		if (!this.is_available()) return false;

		let self = this, worker_params = self.config.resolveWorkerParams(self);

		self.host ||= host;

		if (self.allow_shared_worker && window.SharedWorker) {
			App.core.log('ws:SharedWorker')
			// if (localStorage.getItem('worker_url') !== self.shared_worker_url) self.unregister();
			self.worker = new SharedWorker(self.shared_worker_url, 'Worksection Shared Worker');
			self.port = self.worker.port;
			//localStorage.setItem('worker_url', self.shared_worker_url);
		} else {
			App.core.log('ws:Worker')
			// if (localStorage.getItem('worker_url') !== self.worker_url) self.unregister();
			self.worker = self.port = new Worker(self.worker_url);
			//localStorage.setItem('worker_url', self.worker_url);
		}

		self.postMessage({
			action: 'config',
			host: self.host,
			params: worker_params
		}, true);

		const is_active_user = function () {
			return document.visibilityState !== "hidden";
		}

		self.port.onmessage = function(e) {
			try {
				const json = JSON.parse(e.data);
				if (json.msg) {
					console.log(json.msg);
				} else if (json.command) {
					switch (json.command) {
						case 'host':
							self.host = json.host;
							self.postMessage({
								action: 'config',
								host: self.host,
							}, true);
							break;
						case 'websocket_offline':
							if (self.ready) {
								self.ready = false;
								self.eventbus.emit('offline');
							}
							break;
						case 'websocket_online':
							self.ready = true;
							self.eventbus.emit('online');
							for (let type in self.callbacks) if (type.indexOf('remove') === -1) {
								self.callbacks[type]?.call();
							}
							if (is_active_user()) self.postMessage({action: 'visibility', state: true });
							break;
						default:
							self.eventbus.emit(json.command, json.data);
					}
				}
			} catch (error) {
				App.core.error('ws.port.onmessage', error, e.data);
			}
		}
		if (self.allow_shared_worker && window.SharedWorker) self.port.start();

		// Remove the current worker port from the connected ports list.
		window.addEventListener('beforeunload', () => {
			for (let type in self.callbacks) if (type.indexOf('remove') !== -1) {
				self.callbacks[type]?.call();
			}
			self.postMessage({action: 'unload'});
			if (self.allow_shared_worker && window.SharedWorker) self.port.close();
		});

		window.addEventListener("visibilitychange", () => {
			self.postMessage({action: 'visibility', state: is_active_user() })
		});

		self.__visibility_interval = setInterval(function () {
			if (is_active_user()) self.postMessage({action: 'visibility', state: true });
		}, 30000);
	}

	stop() {
		if (!App.config.websockets || !this.ready) return false;

		clearInterval(this.__visibility_interval);

		if (typeof this.port.close === 'function') this.port.close();
		else if (typeof this.port.terminate === 'function') this.port.terminate();

		this.worker = null;
		this.port = null;
		this.ready = false;
	}

	callback_push(type, callback) {
		this.callbacks[type] = callback;
		if (this.ready) callback.call();
	}

	postMessage(data, skip_ready) {
		if (!this.ready && !skip_ready) return;
		this.port.postMessage(data);
	}

	register_task_view(id_task, hash) {
		let callback = () => this.postMessage({
			action: 'register_task',
			id_task: id_task,
			hash: hash,
		});
		this.callbacks['task' + id_task] = callback;
		if (this.ready) callback.call();

		this.callbacks['task' + id_task + '_remove'] = () => this.postMessage({
			action: 'unregister_task',
			id_task: id_task,
		});
	}

	unregister_task_view(id_task) {
		if (this.ready) this.callbacks['task' + id_task + '_remove']?.call();
		this.callbacks['task' + id_task] = null;
		this.callbacks['task' + id_task + '_remove'] = null;
	}

	register_page() {
		let page = App.page.where();
		if (page) {
			let callback = () => this.postMessage({
				action: 'register_page',
				id_project: App.current_page.project,
				page
			});
			this.callbacks['page'] = callback;
			this.callbacks['page_remove'] = () => this.postMessage({
				action: 'unregister_page',
				id_project: App.current_page.project,
				page
			});
			if (this.ready) callback.call();
		}
	}

	unregister_page() {
		if (this.ready) this.callbacks['page_remove']?.call();
		this.callbacks['page'] = null;
		this.callbacks['page_remove'] = null;
	}
}

;function createAppState() {

	/** @type EntityStore<ContactFromTeam> */
	const contacts = defineEntityStore('contacts', {
		state: () => ({}),
		fetcher: App.expose_data.getContact,
		dummy: {name: '', avatar: '<span class=\"av_sm av_let av_let1\"></span>'}
	});

	/** @type EntityStore<UserFromTeam> */
	const team = defineEntityStore('team', {
		state:   () => App.team,
		fetcher: App.expose_data.getUser,
		dummy:   { name: '', avatar: '<span class="av_sm av_let av_let1"></span>' }
	});

	const custom_fields = defineStore('custom_fields', {
		state: () => App.custom_fields.fields,
		getters: {
			find: function (state) {
				return (id) => {
					const field = state[id] ?? null
					if (!field) return null;

					return {
						...field,
						attributes: {
							...this.type(field.id_type).attributes,
							...field.attributes,
							hint: field.descr
						}
					};
				}
			},
			type: () => (id) => App.custom_fields.types[id] ?? {icon: 'none', input: 'text', attributes: {}},
		},
		actions: {
			set: function (id_field, data) {
				if (Array.isArray(data.attributes)) data = {...data, attributes: {}};
				this.$state[id_field] = data;
			},
			delete: function (id_field) {
				if (this.$state[id_field] == null) return;
				this.$state[id_field] = {...this.$state[id_field], is_deleted: true};
			},
			set_attributes: function (id_field, attributes) {
				if (this.$state[id_field] == null) return;

				this.$state[id_field] = {
					...this.$state[id_field],
					attributes: {
						...this.$state[id_field].attributes,
						...attributes
					}
				};
			}
		}
	});

	const custom_values = defineStore('custom_values', {
		state: () => ({}),
		getters: {
			all: (state) => (id_inst, id_entity) => {
				return Array.from(state[`${id_inst}:${id_entity}`] ?? []).map(id_field => state[`${id_inst}:${id_entity}:${id_field}`] ?? null);
			},
			get: (state) => (id_inst, id_entity, id_field) => state[`${id_inst}:${id_entity}:${id_field}`] ?? null,
			is_loading: (state) => (id_inst, id_entity, id_field) => state[`loading:${id_inst}:${id_entity}:${id_field}`] ?? false,
		},
		actions: {
			set(id_inst, id_entity, id_field, value) {
				const valueKey = this.makeValueKey(id_inst, id_entity, id_field);
				this.$state[valueKey] = value;

				const entityKey = this.makeEntityKey(id_inst, id_entity);
				const fieldIds = this.$state[entityKey] ?? new Set();
				fieldIds.add(id_field);

				this.$state[`${id_inst}:${id_entity}`] = fieldIds;
			},
			ensure(id_inst, id_entity, id_field) {
				if (this.is_loading(id_inst, id_entity, id_field)) return;

				const valueKey = this.makeValueKey(id_inst, id_entity, id_field);
				if (this.$state[valueKey] != null) return;

				this.$state[`loading:${valueKey}`] = true;
				App.expose_data.getCustomValue(id_inst, id_entity, id_field).then(value => {
					if (typeof value === 'string') this.set(id_inst, id_entity, id_field, value);
				}).finally(() => {
					delete this.$state[`loading:${valueKey}`];
				});
			},
			makeValueKey(id_inst, id_entity, id_field) {
				return `${id_inst}:${id_entity}:${id_field}`;
			},
			makeEntityKey(id_inst, id_entity) {
				return `${id_inst}:${id_entity}:`;
			},
		}
	});

	const drag = defineStore('drag', {
		state: () => ({ is_on: false }),
		getters: {
			is_on: (state) => state.is_on,
		},
		actions: {
			start() {
				clearTimeout(this.__timer);
				this.$state.is_on = true;
			},
			stop() {
				clearTimeout(this.__timer);
				this.__timer = setTimeout(() => (this.$state.is_on = false), 100);
			}
		}
	});

	return {
		contacts,
		team,
		custom_values,
		custom_fields,
		drag,

		onLogin: function () {
			App.bus.state
				.on('custom_field_add', function (payload) {
					custom_fields.set(payload.id, payload.data);
				})
				.on('custom_field_update', function (payload) {
					custom_fields.set(payload.id, payload.data);
				})
				.on('custom_field_delete', function (payload) {
					custom_fields.delete(payload.id);
				});

			App.bus.state.on('task_custom_field', function (payload) {
				const id_task = payload.id, id_field = payload.data.id_field, value = payload.data.value;
				custom_values.set(App.custom_fields.INST_TASK, id_task, id_field, value);
			}).on('project_custom_field', function (payload) {
				const id_task = payload.id, id_field = payload.data.id_field, value = payload.data.value;
				custom_values.set(App.custom_fields.INST_PROJECT, id_task, id_field, value);
			});
		},
		onLogout: function () {
			App.me = {};
			App.team = {};
			App.team_groups = {};
			App.team_exposed = {};
			App.team_sorted = {};
			App.tags = {};
			App.tags_group = {};
			App.custom_fields.fields = {};

			custom_values.reset();
			custom_fields.reset();
			team.reset();
			contacts.reset();
		}
	};
}

/**
 * @typedef {Object} UserFromTeam
 * @property {Number} id
 * @property {String} name
 * @property {String} avatar
 */

/**
 * @typedef {UserFromTeam} ContactFromTeam
 */

;/**
 * @template T
 * @typedef {{ value: T, oldValue: T }} Change
 */

/** @typedef {Map<string, Change<*>>} Changeset */

/**
 * @template T
 * @typedef {Object} StoreOptions
 * @property {() => Object<String, T|Boolean>}             [state]
 * @property {Record<string, Function>} [actions]
 * @property {Record<string, Function>} [getters]
 */

class StoreEventBus {
	/** @type {Set<(changeset: Changeset) => void>} */
	_globals = new Set();

	/** @type {Map<string, Set<(value: *, oldValue: *) => void>>} */
	_keyed = new Map();

	/**
	 * @param   {(changeset: Changeset) => void} fn
	 * @returns {() => void}
	 */
	subscribe(fn) {
		this._globals.add(fn);
		return () => this._globals.delete(fn);
	}

	/**
	 * @param   {string} key
	 * @param   {(value: *, oldValue: *) => void} fn
	 * @returns {() => void}
	 */
	watch(key, fn) {
		let set = this._keyed.get(key);

		if (!set) {
			set = new Set();
			this._keyed.set(key, set);
		}

		set.add(fn);
		return () => set.delete(fn);
	}

	/** @param {Changeset} changeset */
	emit(changeset) {
		for (const fn of this._globals) {
			try {
				fn(changeset)
			} catch (error) {
				console.error(error)
			}
		}

		for (const [key, { value, oldValue }] of changeset) {
			const set = this._keyed.get(key);
			if (set) {
				for (const fn of set) {
					try {
						fn(value, oldValue);
					} catch (error) {
						console.error(error)
					}
				}
			}
		}
	}

	dispose() {
		this._globals.clear();
		this._keyed.clear();
	}
}



class ReactiveState {
	/** @type {ReactiveStatePendingMap} */
	_pending = new Map();

	/** @type {boolean} */
	_scheduled = false;

	/** @type {Object} */
	_raw;

	/** @type {Object} */
	_proxy;

	/** @type {StoreEventBus} */
	_bus;

	/** @type {(key: string) => void} */
	_onDirty;

	/**
	 * @param {Object}                initial
	 * @param {StoreEventBus}              bus
	 * @param {(key: string) => void} [onDirty]
	 */
	constructor(initial, bus, onDirty) {
		this._raw     = initial;
		this._bus     = bus;
		this._onDirty = onDirty ?? (() => {});

		this._proxy = new Proxy(this._raw, {
			set: (target, key, value) => {
				const strKey  = String(key);
				const current = target[strKey];

				if (Object.is(current, value)) return true;

				target[strKey] = value;
				this._enqueue(strKey, value, current);
				return true;
			},

			deleteProperty: (target, key) => {
				const strKey = String(key);

				if (!(strKey in target)) return true;

				const current = target[strKey];
				delete target[strKey];
				this._enqueue(strKey, undefined, current);
				return true;
			},
		});
	}

	/** @returns {Object} */
	get proxy() { return this._proxy; }

	/** @returns {Object} */
	get raw() { return this._raw; }

	/**
	 * @param {string} key
	 * @param {*}      value
	 * @param {*}      oldValue
	 */
	_enqueue(key, value, oldValue) {
		const entry = this._pending.get(key);

		if (entry) {
			entry.value = value;
		} else {
			this._pending.set(key, { value, oldValue });
		}

		this._onDirty(key);
		this._schedule();
	}

	_schedule() {
		if (this._scheduled) return;
		this._scheduled = true;

		queueMicrotask(() => {
			const changeset = new Map(this._pending);
			this._pending.clear();
			this._scheduled = false;
			this._bus.emit(changeset);
		});
	}
}



class Store {
	/** @type {string} */
	_id;

	/** @type {StoreEventBus} */
	_bus;

	/** @type {ReactiveState} */
	_reactive;

	/** @type {Map<string, *>} */
	_getterCache = new Map();

	/** @type {boolean} */
	_dirtyGetters = true;

	/**
	 * @param {string}       id
	 * @param {StoreOptions} [options]
	 */
	constructor(id, { state = () => ({}), actions = {}, getters = {} } = {}) {
		this._id  = id;
		this._bus = new StoreEventBus();
		this._make_state = state;
		this._reactive = new ReactiveState(
			this._make_state(),
			this._bus,
			() => { this._dirtyGetters = true; },
		);

		this._bindActions(actions);
		this._defineGetters(getters);
	}

	reset() {
		this._reactive = new ReactiveState(
			this._make_state(),
			this._bus,
			() => { this._dirtyGetters = true; },
		);
	}

	/** @returns {string} */
	get $id() { return this._id; }

	/** @returns {Object} */
	get $state() { return this._reactive.proxy; }

	/** @returns {Object} */
	get $raw() { return this._reactive.raw; }

	/**
	 * @param   {(changeset: Changeset) => void} fn
	 * @returns {() => void}
	 */
	$subscribe(fn) { return this._bus.subscribe(fn); }

	/**
	 * @param   {string} key
	 * @param   {(value: *, oldValue: *) => void} fn
	 * @returns {() => void}
	 */
	$watch(key, fn) { return this._bus.watch(String(key), fn); }

	/** @param {Record<string, *>} partial */
	$patch(partial) {
		const target = this.$state;
		for (const key in partial) {
			if (!Object.prototype.hasOwnProperty.call(partial, key)) continue;
			target[key] = partial[key];
		}
	}

	$dispose() { this._bus.dispose(); }

	/** @param {Record<string, Function>} actions */
	_bindActions(actions) {
		for (const name in actions) {
			if (!Object.prototype.hasOwnProperty.call(actions, name)) continue;
			if (typeof actions[name] !== 'function') continue;

			const fn = actions[name];
			this[name] = (...args) => fn.apply(this, args);
		}
	}

	/** @param {Record<string, Function>} getters */
	_defineGetters(getters) {
		for (const name in getters) {
			if (!Object.prototype.hasOwnProperty.call(getters, name)) continue;
			if (typeof getters[name] !== 'function') continue;

			const fn = getters[name];

			Object.defineProperty(this, name, {
				enumerable: true,
				get: () => {
					if (this._dirtyGetters) {
						this._getterCache.clear();
						this._dirtyGetters = false;
					}

					if (!this._getterCache.has(name)) {
						this._getterCache.set(name, fn.call(this, this._reactive.raw));
					}

					return this._getterCache.get(name);
				},
			});
		}
	}
}

/**
 * @typedef {Map<string, Change<*>>} ReactiveStatePendingMap
 *
 */

;/**
 * @template T
 * @typedef {Object} EntityStoreOptions
 * @property {() => Object<string, T|boolean>}  [state]
 * @property {(id: *, proof?: *) => Promise<T>} fetcher
 * @property {Partial<T>}                       [dummy]
 */

/**
 * @template T
 * @extends {Store<T>}
 */
class EntityStore extends Store {
    /** @type {Partial<T>} */
    _dummy;

    /** @type {(id: *, proof?: *) => Promise<T>} */
    _fetcher;

    /**
     * @param {string}                id
     * @param {EntityStoreOptions<T>} options
     */
    constructor(id, options) {
       super(id, { state: options.state ?? (() => ({})) });

       this._dummy   = options.dummy ?? {};
       this._fetcher = options.fetcher;
    }

	/**
	 * @param   {string|number} id
	 * @returns {Partial<T>}
	 */
	get(id) {
		return  (this.$raw[String(id)] ?? this._dummy);
	}


    /**
     * @param   {string|number} id
     * @returns {boolean}
     */
    exists(id) {
       return this.$raw[String(id)] != null;
    }

    /**
     * @param   {string|number} id
     * @returns {boolean}
     */
    is_loading(id) {
       return this.$raw[`loading:${id}`] === true;
    }

    /**
     * @param   {Array<string|number>} ids
     * @returns {Array<T>}
     */
    all(ids) {
       const raw = this.$raw;
       return ids.map(id => raw[String(id)]).filter(Boolean);
    }

    /**
     * @param {string|number} id
     * @param {*}             [proof]
     */
    fetch(id, proof) {
       this.$state[`loading:${id}`] = true;

       this._fetcher(id, proof)
          .then(entity => {
             this.$state[String(id)] = entity;
          })
          .finally(() => {
             delete this.$state[`loading:${id}`];
          });
    }

    /**
     * @param {string|number} id
     * @param {*}             [proof]
     */
    ensure(id, proof) {
       if (this.exists(id) || this.is_loading(id) || !id) return;
       this.fetch(id, proof);
    }
}

;/**
 * @template T
 * @param   {string}       id
 * @param   {StoreOptions<T>} options
 * @returns {Store<T>}
 */
function defineStore(id, options) {
	return new Store(id, options);
}

/**
 * @template T
 * @param   {string}                id
 * @param   {EntityStoreOptions<T>} options
 * @returns {EntityStore<T>}
 */
function defineEntityStore(id, options) {
	return new EntityStore(id, options);
}